const n0 = (e, t) => e + t, i0 = async (e, t) => {
  const r = (/* @__PURE__ */ new Date()).getTime();
  await t();
  const n = (/* @__PURE__ */ new Date()).getTime();
  console.log(`Function '${e.method || "[no name]"}' returned '${e.result}' after ${n - r}ms`);
}, o0 = (e) => async (t) => (t.data[e] = /* @__PURE__ */ new Date(), t);
var vt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function at(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Eh(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var un = {}, wu;
function Xt() {
  return wu || (wu = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.errors = e.Unavailable = e.BadGateway = e.NotImplemented = e.GeneralError = e.TooManyRequests = e.Unprocessable = e.LengthRequired = e.Gone = e.Conflict = e.Timeout = e.NotAcceptable = e.MethodNotAllowed = e.NotFound = e.Forbidden = e.PaymentError = e.NotAuthenticated = e.BadRequest = e.FeathersError = void 0, e.convert = E;
    class t extends Error {
      constructor(v, p, S, _, A) {
        let F = typeof v == "string" ? v : "Error";
        const T = {
          name: p,
          code: S,
          className: _,
          type: "FeathersError"
        };
        if (Array.isArray(A))
          T.data = A;
        else if (typeof v == "object" || A !== void 0) {
          const { message: D, errors: N, ...$ } = v !== null && typeof v == "object" ? v : A;
          F = D || F, T.errors = N, T.data = $;
        }
        super(F), Object.assign(this, T);
      }
      toJSON() {
        const v = {
          name: this.name,
          message: this.message,
          code: this.code,
          className: this.className
        };
        return this.data !== void 0 && (v.data = this.data), this.errors !== void 0 && (v.errors = this.errors), v;
      }
    }
    e.FeathersError = t;
    class r extends t {
      constructor(v, p) {
        super(v, "BadRequest", 400, "bad-request", p);
      }
    }
    e.BadRequest = r;
    class n extends t {
      constructor(v, p) {
        super(v, "NotAuthenticated", 401, "not-authenticated", p);
      }
    }
    e.NotAuthenticated = n;
    class i extends t {
      constructor(v, p) {
        super(v, "PaymentError", 402, "payment-error", p);
      }
    }
    e.PaymentError = i;
    class o extends t {
      constructor(v, p) {
        super(v, "Forbidden", 403, "forbidden", p);
      }
    }
    e.Forbidden = o;
    class s extends t {
      constructor(v, p) {
        super(v, "NotFound", 404, "not-found", p);
      }
    }
    e.NotFound = s;
    class a extends t {
      constructor(v, p) {
        super(v, "MethodNotAllowed", 405, "method-not-allowed", p);
      }
    }
    e.MethodNotAllowed = a;
    class u extends t {
      constructor(v, p) {
        super(v, "NotAcceptable", 406, "not-acceptable", p);
      }
    }
    e.NotAcceptable = u;
    class f extends t {
      constructor(v, p) {
        super(v, "Timeout", 408, "timeout", p);
      }
    }
    e.Timeout = f;
    class c extends t {
      constructor(v, p) {
        super(v, "Conflict", 409, "conflict", p);
      }
    }
    e.Conflict = c;
    class l extends t {
      constructor(v, p) {
        super(v, "Gone", 410, "gone", p);
      }
    }
    e.Gone = l;
    class d extends t {
      constructor(v, p) {
        super(v, "LengthRequired", 411, "length-required", p);
      }
    }
    e.LengthRequired = d;
    class h extends t {
      constructor(v, p) {
        super(v, "Unprocessable", 422, "unprocessable", p);
      }
    }
    e.Unprocessable = h;
    class y extends t {
      constructor(v, p) {
        super(v, "TooManyRequests", 429, "too-many-requests", p);
      }
    }
    e.TooManyRequests = y;
    class O extends t {
      constructor(v, p) {
        super(v, "GeneralError", 500, "general-error", p);
      }
    }
    e.GeneralError = O;
    class b extends t {
      constructor(v, p) {
        super(v, "NotImplemented", 501, "not-implemented", p);
      }
    }
    e.NotImplemented = b;
    class C extends t {
      constructor(v, p) {
        super(v, "BadGateway", 502, "bad-gateway", p);
      }
    }
    e.BadGateway = C;
    class w extends t {
      constructor(v, p) {
        super(v, "Unavailable", 503, "unavailable", p);
      }
    }
    e.Unavailable = w, e.errors = {
      FeathersError: t,
      BadRequest: r,
      NotAuthenticated: n,
      PaymentError: i,
      Forbidden: o,
      NotFound: s,
      MethodNotAllowed: a,
      NotAcceptable: u,
      Timeout: f,
      Conflict: c,
      LengthRequired: d,
      Unprocessable: h,
      TooManyRequests: y,
      GeneralError: O,
      NotImplemented: b,
      BadGateway: C,
      Unavailable: w,
      400: r,
      401: n,
      402: i,
      403: o,
      404: s,
      405: a,
      406: u,
      408: f,
      409: c,
      410: l,
      411: d,
      422: h,
      429: y,
      500: O,
      501: b,
      502: C,
      503: w
    };
    function E(g) {
      if (!g)
        return g;
      const v = e.errors[g.name], p = v ? new v(g.message, g.data) : new Error(g.message || g);
      return typeof g == "object" && Object.assign(p, g), p;
    }
  })(un)), un;
}
var Su = Xt(), cn, Ou;
function ze() {
  if (Ou) return cn;
  Ou = 1;
  var e = Array.isArray;
  return cn = e, cn;
}
var fn, Au;
function Rh() {
  if (Au) return fn;
  Au = 1;
  var e = typeof vt == "object" && vt && vt.Object === Object && vt;
  return fn = e, fn;
}
var ln, Cu;
function Ue() {
  if (Cu) return ln;
  Cu = 1;
  var e = Rh(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return ln = r, ln;
}
var dn, Eu;
function Yt() {
  if (Eu) return dn;
  Eu = 1;
  var e = Ue(), t = e.Symbol;
  return dn = t, dn;
}
var hn, Ru;
function fy() {
  if (Ru) return hn;
  Ru = 1;
  var e = Yt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
  function o(s) {
    var a = r.call(s, i), u = s[i];
    try {
      s[i] = void 0;
      var f = !0;
    } catch {
    }
    var c = n.call(s);
    return f && (a ? s[i] = u : delete s[i]), c;
  }
  return hn = o, hn;
}
var pn, qu;
function ly() {
  if (qu) return pn;
  qu = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return pn = r, pn;
}
var yn, Pu;
function _t() {
  if (Pu) return yn;
  Pu = 1;
  var e = Yt(), t = fy(), r = ly(), n = "[object Null]", i = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(a) {
    return a == null ? a === void 0 ? i : n : o && o in Object(a) ? t(a) : r(a);
  }
  return yn = s, yn;
}
var gn, Tu;
function ut() {
  if (Tu) return gn;
  Tu = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return gn = e, gn;
}
var mn, Fu;
function qa() {
  if (Fu) return mn;
  Fu = 1;
  var e = _t(), t = ut(), r = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || t(i) && e(i) == r;
  }
  return mn = n, mn;
}
var vn, Iu;
function dy() {
  if (Iu) return vn;
  Iu = 1;
  var e = ze(), t = qa(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function i(o, s) {
    if (e(o))
      return !1;
    var a = typeof o;
    return a == "number" || a == "symbol" || a == "boolean" || o == null || t(o) ? !0 : n.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return vn = i, vn;
}
var bn, ju;
function wt() {
  if (ju) return bn;
  ju = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return bn = e, bn;
}
var _n, ku;
function qh() {
  if (ku) return _n;
  ku = 1;
  var e = _t(), t = wt(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(a) {
    if (!t(a))
      return !1;
    var u = e(a);
    return u == n || u == i || u == r || u == o;
  }
  return _n = s, _n;
}
var wn, Nu;
function hy() {
  if (Nu) return wn;
  Nu = 1;
  var e = Ue(), t = e["__core-js_shared__"];
  return wn = t, wn;
}
var Sn, Lu;
function py() {
  if (Lu) return Sn;
  Lu = 1;
  var e = hy(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return Sn = r, Sn;
}
var On, Du;
function Ph() {
  if (Du) return On;
  Du = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return On = r, On;
}
var An, Mu;
function yy() {
  if (Mu) return An;
  Mu = 1;
  var e = qh(), t = py(), r = wt(), n = Ph(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, a = Object.prototype, u = s.toString, f = a.hasOwnProperty, c = RegExp(
    "^" + u.call(f).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(d) {
    if (!r(d) || t(d))
      return !1;
    var h = e(d) ? c : o;
    return h.test(n(d));
  }
  return An = l, An;
}
var Cn, Bu;
function gy() {
  if (Bu) return Cn;
  Bu = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return Cn = e, Cn;
}
var En, $u;
function ct() {
  if ($u) return En;
  $u = 1;
  var e = yy(), t = gy();
  function r(n, i) {
    var o = t(n, i);
    return e(o) ? o : void 0;
  }
  return En = r, En;
}
var Rn, Uu;
function Dr() {
  if (Uu) return Rn;
  Uu = 1;
  var e = ct(), t = e(Object, "create");
  return Rn = t, Rn;
}
var qn, xu;
function my() {
  if (xu) return qn;
  xu = 1;
  var e = Dr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return qn = t, qn;
}
var Pn, Hu;
function vy() {
  if (Hu) return Pn;
  Hu = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Pn = e, Pn;
}
var Tn, Ku;
function by() {
  if (Ku) return Tn;
  Ku = 1;
  var e = Dr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    if (e) {
      var a = s[o];
      return a === t ? void 0 : a;
    }
    return n.call(s, o) ? s[o] : void 0;
  }
  return Tn = i, Tn;
}
var Fn, Wu;
function _y() {
  if (Wu) return Fn;
  Wu = 1;
  var e = Dr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(i) {
    var o = this.__data__;
    return e ? o[i] !== void 0 : r.call(o, i);
  }
  return Fn = n, Fn;
}
var In, Gu;
function wy() {
  if (Gu) return In;
  Gu = 1;
  var e = Dr(), t = "__lodash_hash_undefined__";
  function r(n, i) {
    var o = this.__data__;
    return this.size += this.has(n) ? 0 : 1, o[n] = e && i === void 0 ? t : i, this;
  }
  return In = r, In;
}
var jn, Vu;
function Sy() {
  if (Vu) return jn;
  Vu = 1;
  var e = my(), t = vy(), r = by(), n = _y(), i = wy();
  function o(s) {
    var a = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++a < u; ) {
      var f = s[a];
      this.set(f[0], f[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, jn = o, jn;
}
var kn, zu;
function Oy() {
  if (zu) return kn;
  zu = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return kn = e, kn;
}
var Nn, Ju;
function Th() {
  if (Ju) return Nn;
  Ju = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Nn = e, Nn;
}
var Ln, Qu;
function Mr() {
  if (Qu) return Ln;
  Qu = 1;
  var e = Th();
  function t(r, n) {
    for (var i = r.length; i--; )
      if (e(r[i][0], n))
        return i;
    return -1;
  }
  return Ln = t, Ln;
}
var Dn, Xu;
function Ay() {
  if (Xu) return Dn;
  Xu = 1;
  var e = Mr(), t = Array.prototype, r = t.splice;
  function n(i) {
    var o = this.__data__, s = e(o, i);
    if (s < 0)
      return !1;
    var a = o.length - 1;
    return s == a ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Dn = n, Dn;
}
var Mn, Yu;
function Cy() {
  if (Yu) return Mn;
  Yu = 1;
  var e = Mr();
  function t(r) {
    var n = this.__data__, i = e(n, r);
    return i < 0 ? void 0 : n[i][1];
  }
  return Mn = t, Mn;
}
var Bn, Zu;
function Ey() {
  if (Zu) return Bn;
  Zu = 1;
  var e = Mr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Bn = t, Bn;
}
var $n, ec;
function Ry() {
  if (ec) return $n;
  ec = 1;
  var e = Mr();
  function t(r, n) {
    var i = this.__data__, o = e(i, r);
    return o < 0 ? (++this.size, i.push([r, n])) : i[o][1] = n, this;
  }
  return $n = t, $n;
}
var Un, tc;
function Br() {
  if (tc) return Un;
  tc = 1;
  var e = Oy(), t = Ay(), r = Cy(), n = Ey(), i = Ry();
  function o(s) {
    var a = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++a < u; ) {
      var f = s[a];
      this.set(f[0], f[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, Un = o, Un;
}
var xn, rc;
function Pa() {
  if (rc) return xn;
  rc = 1;
  var e = ct(), t = Ue(), r = e(t, "Map");
  return xn = r, xn;
}
var Hn, nc;
function qy() {
  if (nc) return Hn;
  nc = 1;
  var e = Sy(), t = Br(), r = Pa();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Hn = n, Hn;
}
var Kn, ic;
function Py() {
  if (ic) return Kn;
  ic = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Kn = e, Kn;
}
var Wn, oc;
function $r() {
  if (oc) return Wn;
  oc = 1;
  var e = Py();
  function t(r, n) {
    var i = r.__data__;
    return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return Wn = t, Wn;
}
var Gn, sc;
function Ty() {
  if (sc) return Gn;
  sc = 1;
  var e = $r();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Gn = t, Gn;
}
var Vn, ac;
function Fy() {
  if (ac) return Vn;
  ac = 1;
  var e = $r();
  function t(r) {
    return e(this, r).get(r);
  }
  return Vn = t, Vn;
}
var zn, uc;
function Iy() {
  if (uc) return zn;
  uc = 1;
  var e = $r();
  function t(r) {
    return e(this, r).has(r);
  }
  return zn = t, zn;
}
var Jn, cc;
function jy() {
  if (cc) return Jn;
  cc = 1;
  var e = $r();
  function t(r, n) {
    var i = e(this, r), o = i.size;
    return i.set(r, n), this.size += i.size == o ? 0 : 1, this;
  }
  return Jn = t, Jn;
}
var Qn, fc;
function Fh() {
  if (fc) return Qn;
  fc = 1;
  var e = qy(), t = Ty(), r = Fy(), n = Iy(), i = jy();
  function o(s) {
    var a = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++a < u; ) {
      var f = s[a];
      this.set(f[0], f[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, Qn = o, Qn;
}
var Xn, lc;
function ky() {
  if (lc) return Xn;
  lc = 1;
  var e = Fh(), t = "Expected a function";
  function r(n, i) {
    if (typeof n != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var o = function() {
      var s = arguments, a = i ? i.apply(this, s) : s[0], u = o.cache;
      if (u.has(a))
        return u.get(a);
      var f = n.apply(this, s);
      return o.cache = u.set(a, f) || u, f;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Xn = r, Xn;
}
var Yn, dc;
function Ny() {
  if (dc) return Yn;
  dc = 1;
  var e = ky(), t = 500;
  function r(n) {
    var i = e(n, function(s) {
      return o.size === t && o.clear(), s;
    }), o = i.cache;
    return i;
  }
  return Yn = r, Yn;
}
var Zn, hc;
function Ly() {
  if (hc) return Zn;
  hc = 1;
  var e = Ny(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(t, function(s, a, u, f) {
      o.push(u ? f.replace(r, "$1") : a || s);
    }), o;
  });
  return Zn = n, Zn;
}
var ei, pc;
function Ih() {
  if (pc) return ei;
  pc = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, o = Array(i); ++n < i; )
      o[n] = r(t[n], n, t);
    return o;
  }
  return ei = e, ei;
}
var ti, yc;
function Dy() {
  if (yc) return ti;
  yc = 1;
  var e = Yt(), t = Ih(), r = ze(), n = qa(), i = e ? e.prototype : void 0, o = i ? i.toString : void 0;
  function s(a) {
    if (typeof a == "string")
      return a;
    if (r(a))
      return t(a, s) + "";
    if (n(a))
      return o ? o.call(a) : "";
    var u = a + "";
    return u == "0" && 1 / a == -1 / 0 ? "-0" : u;
  }
  return ti = s, ti;
}
var ri, gc;
function My() {
  if (gc) return ri;
  gc = 1;
  var e = Dy();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return ri = t, ri;
}
var ni, mc;
function St() {
  if (mc) return ni;
  mc = 1;
  var e = ze(), t = dy(), r = Ly(), n = My();
  function i(o, s) {
    return e(o) ? o : t(o, s) ? [o] : r(n(o));
  }
  return ni = i, ni;
}
var ii, vc;
function Ur() {
  if (vc) return ii;
  vc = 1;
  var e = qa();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return ii = t, ii;
}
var oi, bc;
function Ta() {
  if (bc) return oi;
  bc = 1;
  var e = St(), t = Ur();
  function r(n, i) {
    i = e(i, n);
    for (var o = 0, s = i.length; n != null && o < s; )
      n = n[t(i[o++])];
    return o && o == s ? n : void 0;
  }
  return oi = r, oi;
}
var si, _c;
function jh() {
  if (_c) return si;
  _c = 1;
  var e = ct(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return si = t, si;
}
var ai, wc;
function kh() {
  if (wc) return ai;
  wc = 1;
  var e = jh();
  function t(r, n, i) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : r[n] = i;
  }
  return ai = t, ai;
}
var ui, Sc;
function Fa() {
  if (Sc) return ui;
  Sc = 1;
  var e = kh(), t = Th(), r = Object.prototype, n = r.hasOwnProperty;
  function i(o, s, a) {
    var u = o[s];
    (!(n.call(o, s) && t(u, a)) || a === void 0 && !(s in o)) && e(o, s, a);
  }
  return ui = i, ui;
}
var ci, Oc;
function Ia() {
  if (Oc) return ci;
  Oc = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var o = typeof n;
    return i = i ?? e, !!i && (o == "number" || o != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return ci = r, ci;
}
var fi, Ac;
function ja() {
  if (Ac) return fi;
  Ac = 1;
  var e = Fa(), t = St(), r = Ia(), n = wt(), i = Ur();
  function o(s, a, u, f) {
    if (!n(s))
      return s;
    a = t(a, s);
    for (var c = -1, l = a.length, d = l - 1, h = s; h != null && ++c < l; ) {
      var y = i(a[c]), O = u;
      if (y === "__proto__" || y === "constructor" || y === "prototype")
        return s;
      if (c != d) {
        var b = h[y];
        O = f ? f(b, y, h) : void 0, O === void 0 && (O = n(b) ? b : r(a[c + 1]) ? [] : {});
      }
      e(h, y, O), h = h[y];
    }
    return s;
  }
  return fi = o, fi;
}
var li, Cc;
function By() {
  if (Cc) return li;
  Cc = 1;
  var e = Ta(), t = ja(), r = St();
  function n(i, o, s) {
    for (var a = -1, u = o.length, f = {}; ++a < u; ) {
      var c = o[a], l = e(i, c);
      s(l, c) && t(f, r(c, i), l);
    }
    return f;
  }
  return li = n, li;
}
var di, Ec;
function $y() {
  if (Ec) return di;
  Ec = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return di = e, di;
}
var hi, Rc;
function Uy() {
  if (Rc) return hi;
  Rc = 1;
  var e = _t(), t = ut(), r = "[object Arguments]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return hi = n, hi;
}
var pi, qc;
function ka() {
  if (qc) return pi;
  qc = 1;
  var e = Uy(), t = ut(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return t(s) && n.call(s, "callee") && !i.call(s, "callee");
  };
  return pi = o, pi;
}
var yi, Pc;
function Na() {
  if (Pc) return yi;
  Pc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return yi = t, yi;
}
var gi, Tc;
function Nh() {
  if (Tc) return gi;
  Tc = 1;
  var e = St(), t = ka(), r = ze(), n = Ia(), i = Na(), o = Ur();
  function s(a, u, f) {
    u = e(u, a);
    for (var c = -1, l = u.length, d = !1; ++c < l; ) {
      var h = o(u[c]);
      if (!(d = a != null && f(a, h)))
        break;
      a = a[h];
    }
    return d || ++c != l ? d : (l = a == null ? 0 : a.length, !!l && i(l) && n(h, l) && (r(a) || t(a)));
  }
  return gi = s, gi;
}
var mi, Fc;
function xy() {
  if (Fc) return mi;
  Fc = 1;
  var e = $y(), t = Nh();
  function r(n, i) {
    return n != null && t(n, i, e);
  }
  return mi = r, mi;
}
var vi, Ic;
function Hy() {
  if (Ic) return vi;
  Ic = 1;
  var e = By(), t = xy();
  function r(n, i) {
    return e(n, i, function(o, s) {
      return t(n, s);
    });
  }
  return vi = r, vi;
}
var bi, jc;
function La() {
  if (jc) return bi;
  jc = 1;
  function e(t, r) {
    for (var n = -1, i = r.length, o = t.length; ++n < i; )
      t[o + n] = r[n];
    return t;
  }
  return bi = e, bi;
}
var _i, kc;
function Ky() {
  if (kc) return _i;
  kc = 1;
  var e = Yt(), t = ka(), r = ze(), n = e ? e.isConcatSpreadable : void 0;
  function i(o) {
    return r(o) || t(o) || !!(n && o && o[n]);
  }
  return _i = i, _i;
}
var wi, Nc;
function Wy() {
  if (Nc) return wi;
  Nc = 1;
  var e = La(), t = Ky();
  function r(n, i, o, s, a) {
    var u = -1, f = n.length;
    for (o || (o = t), a || (a = []); ++u < f; ) {
      var c = n[u];
      i > 0 && o(c) ? i > 1 ? r(c, i - 1, o, s, a) : e(a, c) : s || (a[a.length] = c);
    }
    return a;
  }
  return wi = r, wi;
}
var Si, Lc;
function Gy() {
  if (Lc) return Si;
  Lc = 1;
  var e = Wy();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return Si = t, Si;
}
var Oi, Dc;
function Vy() {
  if (Dc) return Oi;
  Dc = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return Oi = e, Oi;
}
var Ai, Mc;
function zy() {
  if (Mc) return Ai;
  Mc = 1;
  var e = Vy(), t = Math.max;
  function r(n, i, o) {
    return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
      for (var s = arguments, a = -1, u = t(s.length - i, 0), f = Array(u); ++a < u; )
        f[a] = s[i + a];
      a = -1;
      for (var c = Array(i + 1); ++a < i; )
        c[a] = s[a];
      return c[i] = o(f), e(n, this, c);
    };
  }
  return Ai = r, Ai;
}
var Ci, Bc;
function Jy() {
  if (Bc) return Ci;
  Bc = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Ci = e, Ci;
}
var Ei, $c;
function Qy() {
  if ($c) return Ei;
  $c = 1;
  function e(t) {
    return t;
  }
  return Ei = e, Ei;
}
var Ri, Uc;
function Xy() {
  if (Uc) return Ri;
  Uc = 1;
  var e = Jy(), t = jh(), r = Qy(), n = t ? function(i, o) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Ri = n, Ri;
}
var qi, xc;
function Yy() {
  if (xc) return qi;
  xc = 1;
  var e = 800, t = 16, r = Date.now;
  function n(i) {
    var o = 0, s = 0;
    return function() {
      var a = r(), u = t - (a - s);
      if (s = a, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return qi = n, qi;
}
var Pi, Hc;
function Zy() {
  if (Hc) return Pi;
  Hc = 1;
  var e = Xy(), t = Yy(), r = t(e);
  return Pi = r, Pi;
}
var Ti, Kc;
function Lh() {
  if (Kc) return Ti;
  Kc = 1;
  var e = Gy(), t = zy(), r = Zy();
  function n(i) {
    return r(t(i, void 0, e), i + "");
  }
  return Ti = n, Ti;
}
var Fi, Wc;
function eg() {
  if (Wc) return Fi;
  Wc = 1;
  var e = Hy(), t = Lh(), r = t(function(n, i) {
    return n == null ? {} : e(n, i);
  });
  return Fi = r, Fi;
}
eg();
var Ii, Gc;
function tg() {
  if (Gc) return Ii;
  Gc = 1;
  var e = ja();
  function t(r, n, i) {
    return r == null ? r : e(r, n, i);
  }
  return Ii = t, Ii;
}
tg();
var ji, Vc;
function rg() {
  if (Vc) return ji;
  Vc = 1;
  var e = Ta();
  function t(r, n, i) {
    var o = r == null ? void 0 : e(r, n);
    return o === void 0 ? i : o;
  }
  return ji = t, ji;
}
rg();
var ki, zc;
function ng() {
  if (zc) return ki;
  zc = 1;
  var e = Br();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return ki = t, ki;
}
var Ni, Jc;
function ig() {
  if (Jc) return Ni;
  Jc = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Ni = e, Ni;
}
var Li, Qc;
function og() {
  if (Qc) return Li;
  Qc = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Li = e, Li;
}
var Di, Xc;
function sg() {
  if (Xc) return Di;
  Xc = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Di = e, Di;
}
var Mi, Yc;
function ag() {
  if (Yc) return Mi;
  Yc = 1;
  var e = Br(), t = Pa(), r = Fh(), n = 200;
  function i(o, s) {
    var a = this.__data__;
    if (a instanceof e) {
      var u = a.__data__;
      if (!t || u.length < n - 1)
        return u.push([o, s]), this.size = ++a.size, this;
      a = this.__data__ = new r(u);
    }
    return a.set(o, s), this.size = a.size, this;
  }
  return Mi = i, Mi;
}
var Bi, Zc;
function ug() {
  if (Zc) return Bi;
  Zc = 1;
  var e = Br(), t = ng(), r = ig(), n = og(), i = sg(), o = ag();
  function s(a) {
    var u = this.__data__ = new e(a);
    this.size = u.size;
  }
  return s.prototype.clear = t, s.prototype.delete = r, s.prototype.get = n, s.prototype.has = i, s.prototype.set = o, Bi = s, Bi;
}
var $i, ef;
function cg() {
  if (ef) return $i;
  ef = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return $i = e, $i;
}
var Ui, tf;
function Zt() {
  if (tf) return Ui;
  tf = 1;
  var e = Fa(), t = kh();
  function r(n, i, o, s) {
    var a = !o;
    o || (o = {});
    for (var u = -1, f = i.length; ++u < f; ) {
      var c = i[u], l = s ? s(o[c], n[c], c, o, n) : void 0;
      l === void 0 && (l = n[c]), a ? t(o, c, l) : e(o, c, l);
    }
    return o;
  }
  return Ui = r, Ui;
}
var xi, rf;
function fg() {
  if (rf) return xi;
  rf = 1;
  function e(t, r) {
    for (var n = -1, i = Array(t); ++n < t; )
      i[n] = r(n);
    return i;
  }
  return xi = e, xi;
}
var Ht = { exports: {} }, Hi, nf;
function lg() {
  if (nf) return Hi;
  nf = 1;
  function e() {
    return !1;
  }
  return Hi = e, Hi;
}
Ht.exports;
var of;
function Dh() {
  return of || (of = 1, (function(e, t) {
    var r = Ue(), n = lg(), i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, s = o && o.exports === i, a = s ? r.Buffer : void 0, u = a ? a.isBuffer : void 0, f = u || n;
    e.exports = f;
  })(Ht, Ht.exports)), Ht.exports;
}
var Ki, sf;
function dg() {
  if (sf) return Ki;
  sf = 1;
  var e = _t(), t = Na(), r = ut(), n = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", s = "[object Date]", a = "[object Error]", u = "[object Function]", f = "[object Map]", c = "[object Number]", l = "[object Object]", d = "[object RegExp]", h = "[object Set]", y = "[object String]", O = "[object WeakMap]", b = "[object ArrayBuffer]", C = "[object DataView]", w = "[object Float32Array]", E = "[object Float64Array]", g = "[object Int8Array]", v = "[object Int16Array]", p = "[object Int32Array]", S = "[object Uint8Array]", _ = "[object Uint8ClampedArray]", A = "[object Uint16Array]", F = "[object Uint32Array]", T = {};
  T[w] = T[E] = T[g] = T[v] = T[p] = T[S] = T[_] = T[A] = T[F] = !0, T[n] = T[i] = T[b] = T[o] = T[C] = T[s] = T[a] = T[u] = T[f] = T[c] = T[l] = T[d] = T[h] = T[y] = T[O] = !1;
  function D(N) {
    return r(N) && t(N.length) && !!T[e(N)];
  }
  return Ki = D, Ki;
}
var Wi, af;
function Da() {
  if (af) return Wi;
  af = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Wi = e, Wi;
}
var Kt = { exports: {} };
Kt.exports;
var uf;
function Ma() {
  return uf || (uf = 1, (function(e, t) {
    var r = Rh(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, o = i && i.exports === n, s = o && r.process, a = (function() {
      try {
        var u = i && i.require && i.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = a;
  })(Kt, Kt.exports)), Kt.exports;
}
var Gi, cf;
function hg() {
  if (cf) return Gi;
  cf = 1;
  var e = dg(), t = Da(), r = Ma(), n = r && r.isTypedArray, i = n ? t(n) : e;
  return Gi = i, Gi;
}
var Vi, ff;
function Mh() {
  if (ff) return Vi;
  ff = 1;
  var e = fg(), t = ka(), r = ze(), n = Dh(), i = Ia(), o = hg(), s = Object.prototype, a = s.hasOwnProperty;
  function u(f, c) {
    var l = r(f), d = !l && t(f), h = !l && !d && n(f), y = !l && !d && !h && o(f), O = l || d || h || y, b = O ? e(f.length, String) : [], C = b.length;
    for (var w in f)
      (c || a.call(f, w)) && !(O && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      y && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      i(w, C))) && b.push(w);
    return b;
  }
  return Vi = u, Vi;
}
var zi, lf;
function Ba() {
  if (lf) return zi;
  lf = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
    return r === i;
  }
  return zi = t, zi;
}
var Ji, df;
function Bh() {
  if (df) return Ji;
  df = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Ji = e, Ji;
}
var Qi, hf;
function pg() {
  if (hf) return Qi;
  hf = 1;
  var e = Bh(), t = e(Object.keys, Object);
  return Qi = t, Qi;
}
var Xi, pf;
function yg() {
  if (pf) return Xi;
  pf = 1;
  var e = Ba(), t = pg(), r = Object.prototype, n = r.hasOwnProperty;
  function i(o) {
    if (!e(o))
      return t(o);
    var s = [];
    for (var a in Object(o))
      n.call(o, a) && a != "constructor" && s.push(a);
    return s;
  }
  return Xi = i, Xi;
}
var Yi, yf;
function $h() {
  if (yf) return Yi;
  yf = 1;
  var e = qh(), t = Na();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return Yi = r, Yi;
}
var Zi, gf;
function $a() {
  if (gf) return Zi;
  gf = 1;
  var e = Mh(), t = yg(), r = $h();
  function n(i) {
    return r(i) ? e(i) : t(i);
  }
  return Zi = n, Zi;
}
var eo, mf;
function gg() {
  if (mf) return eo;
  mf = 1;
  var e = Zt(), t = $a();
  function r(n, i) {
    return n && e(i, t(i), n);
  }
  return eo = r, eo;
}
var to, vf;
function mg() {
  if (vf) return to;
  vf = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return to = e, to;
}
var ro, bf;
function vg() {
  if (bf) return ro;
  bf = 1;
  var e = wt(), t = Ba(), r = mg(), n = Object.prototype, i = n.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var a = t(s), u = [];
    for (var f in s)
      f == "constructor" && (a || !i.call(s, f)) || u.push(f);
    return u;
  }
  return ro = o, ro;
}
var no, _f;
function Ua() {
  if (_f) return no;
  _f = 1;
  var e = Mh(), t = vg(), r = $h();
  function n(i) {
    return r(i) ? e(i, !0) : t(i);
  }
  return no = n, no;
}
var io, wf;
function bg() {
  if (wf) return io;
  wf = 1;
  var e = Zt(), t = Ua();
  function r(n, i) {
    return n && e(i, t(i), n);
  }
  return io = r, io;
}
var Wt = { exports: {} };
Wt.exports;
var Sf;
function _g() {
  return Sf || (Sf = 1, (function(e, t) {
    var r = Ue(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, o = i && i.exports === n, s = o ? r.Buffer : void 0, a = s ? s.allocUnsafe : void 0;
    function u(f, c) {
      if (c)
        return f.slice();
      var l = f.length, d = a ? a(l) : new f.constructor(l);
      return f.copy(d), d;
    }
    e.exports = u;
  })(Wt, Wt.exports)), Wt.exports;
}
var oo, Of;
function wg() {
  if (Of) return oo;
  Of = 1;
  function e(t, r) {
    var n = -1, i = t.length;
    for (r || (r = Array(i)); ++n < i; )
      r[n] = t[n];
    return r;
  }
  return oo = e, oo;
}
var so, Af;
function Sg() {
  if (Af) return so;
  Af = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, o = 0, s = []; ++n < i; ) {
      var a = t[n];
      r(a, n, t) && (s[o++] = a);
    }
    return s;
  }
  return so = e, so;
}
var ao, Cf;
function Uh() {
  if (Cf) return ao;
  Cf = 1;
  function e() {
    return [];
  }
  return ao = e, ao;
}
var uo, Ef;
function xa() {
  if (Ef) return uo;
  Ef = 1;
  var e = Sg(), t = Uh(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(s) {
    return s == null ? [] : (s = Object(s), e(i(s), function(a) {
      return n.call(s, a);
    }));
  } : t;
  return uo = o, uo;
}
var co, Rf;
function Og() {
  if (Rf) return co;
  Rf = 1;
  var e = Zt(), t = xa();
  function r(n, i) {
    return e(n, t(n), i);
  }
  return co = r, co;
}
var fo, qf;
function Ha() {
  if (qf) return fo;
  qf = 1;
  var e = Bh(), t = e(Object.getPrototypeOf, Object);
  return fo = t, fo;
}
var lo, Pf;
function xh() {
  if (Pf) return lo;
  Pf = 1;
  var e = La(), t = Ha(), r = xa(), n = Uh(), i = Object.getOwnPropertySymbols, o = i ? function(s) {
    for (var a = []; s; )
      e(a, r(s)), s = t(s);
    return a;
  } : n;
  return lo = o, lo;
}
var ho, Tf;
function Ag() {
  if (Tf) return ho;
  Tf = 1;
  var e = Zt(), t = xh();
  function r(n, i) {
    return e(n, t(n), i);
  }
  return ho = r, ho;
}
var po, Ff;
function Hh() {
  if (Ff) return po;
  Ff = 1;
  var e = La(), t = ze();
  function r(n, i, o) {
    var s = i(n);
    return t(n) ? s : e(s, o(n));
  }
  return po = r, po;
}
var yo, If;
function Cg() {
  if (If) return yo;
  If = 1;
  var e = Hh(), t = xa(), r = $a();
  function n(i) {
    return e(i, r, t);
  }
  return yo = n, yo;
}
var go, jf;
function Kh() {
  if (jf) return go;
  jf = 1;
  var e = Hh(), t = xh(), r = Ua();
  function n(i) {
    return e(i, r, t);
  }
  return go = n, go;
}
var mo, kf;
function Eg() {
  if (kf) return mo;
  kf = 1;
  var e = ct(), t = Ue(), r = e(t, "DataView");
  return mo = r, mo;
}
var vo, Nf;
function Rg() {
  if (Nf) return vo;
  Nf = 1;
  var e = ct(), t = Ue(), r = e(t, "Promise");
  return vo = r, vo;
}
var bo, Lf;
function qg() {
  if (Lf) return bo;
  Lf = 1;
  var e = ct(), t = Ue(), r = e(t, "Set");
  return bo = r, bo;
}
var _o, Df;
function Pg() {
  if (Df) return _o;
  Df = 1;
  var e = ct(), t = Ue(), r = e(t, "WeakMap");
  return _o = r, _o;
}
var wo, Mf;
function Ka() {
  if (Mf) return wo;
  Mf = 1;
  var e = Eg(), t = Pa(), r = Rg(), n = qg(), i = Pg(), o = _t(), s = Ph(), a = "[object Map]", u = "[object Object]", f = "[object Promise]", c = "[object Set]", l = "[object WeakMap]", d = "[object DataView]", h = s(e), y = s(t), O = s(r), b = s(n), C = s(i), w = o;
  return (e && w(new e(new ArrayBuffer(1))) != d || t && w(new t()) != a || r && w(r.resolve()) != f || n && w(new n()) != c || i && w(new i()) != l) && (w = function(E) {
    var g = o(E), v = g == u ? E.constructor : void 0, p = v ? s(v) : "";
    if (p)
      switch (p) {
        case h:
          return d;
        case y:
          return a;
        case O:
          return f;
        case b:
          return c;
        case C:
          return l;
      }
    return g;
  }), wo = w, wo;
}
var So, Bf;
function Tg() {
  if (Bf) return So;
  Bf = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var i = n.length, o = new n.constructor(i);
    return i && typeof n[0] == "string" && t.call(n, "index") && (o.index = n.index, o.input = n.input), o;
  }
  return So = r, So;
}
var Oo, $f;
function Fg() {
  if ($f) return Oo;
  $f = 1;
  var e = Ue(), t = e.Uint8Array;
  return Oo = t, Oo;
}
var Ao, Uf;
function Wa() {
  if (Uf) return Ao;
  Uf = 1;
  var e = Fg();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return Ao = t, Ao;
}
var Co, xf;
function Ig() {
  if (xf) return Co;
  xf = 1;
  var e = Wa();
  function t(r, n) {
    var i = n ? e(r.buffer) : r.buffer;
    return new r.constructor(i, r.byteOffset, r.byteLength);
  }
  return Co = t, Co;
}
var Eo, Hf;
function jg() {
  if (Hf) return Eo;
  Hf = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return Eo = t, Eo;
}
var Ro, Kf;
function kg() {
  if (Kf) return Ro;
  Kf = 1;
  var e = Yt(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(i) {
    return r ? Object(r.call(i)) : {};
  }
  return Ro = n, Ro;
}
var qo, Wf;
function Ng() {
  if (Wf) return qo;
  Wf = 1;
  var e = Wa();
  function t(r, n) {
    var i = n ? e(r.buffer) : r.buffer;
    return new r.constructor(i, r.byteOffset, r.length);
  }
  return qo = t, qo;
}
var Po, Gf;
function Lg() {
  if (Gf) return Po;
  Gf = 1;
  var e = Wa(), t = Ig(), r = jg(), n = kg(), i = Ng(), o = "[object Boolean]", s = "[object Date]", a = "[object Map]", u = "[object Number]", f = "[object RegExp]", c = "[object Set]", l = "[object String]", d = "[object Symbol]", h = "[object ArrayBuffer]", y = "[object DataView]", O = "[object Float32Array]", b = "[object Float64Array]", C = "[object Int8Array]", w = "[object Int16Array]", E = "[object Int32Array]", g = "[object Uint8Array]", v = "[object Uint8ClampedArray]", p = "[object Uint16Array]", S = "[object Uint32Array]";
  function _(A, F, T) {
    var D = A.constructor;
    switch (F) {
      case h:
        return e(A);
      case o:
      case s:
        return new D(+A);
      case y:
        return t(A, T);
      case O:
      case b:
      case C:
      case w:
      case E:
      case g:
      case v:
      case p:
      case S:
        return i(A, T);
      case a:
        return new D();
      case u:
      case l:
        return new D(A);
      case f:
        return r(A);
      case c:
        return new D();
      case d:
        return n(A);
    }
  }
  return Po = _, Po;
}
var To, Vf;
function Dg() {
  if (Vf) return To;
  Vf = 1;
  var e = wt(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(i) {
      if (!e(i))
        return {};
      if (t)
        return t(i);
      n.prototype = i;
      var o = new n();
      return n.prototype = void 0, o;
    };
  })();
  return To = r, To;
}
var Fo, zf;
function Mg() {
  if (zf) return Fo;
  zf = 1;
  var e = Dg(), t = Ha(), r = Ba();
  function n(i) {
    return typeof i.constructor == "function" && !r(i) ? e(t(i)) : {};
  }
  return Fo = n, Fo;
}
var Io, Jf;
function Bg() {
  if (Jf) return Io;
  Jf = 1;
  var e = Ka(), t = ut(), r = "[object Map]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return Io = n, Io;
}
var jo, Qf;
function $g() {
  if (Qf) return jo;
  Qf = 1;
  var e = Bg(), t = Da(), r = Ma(), n = r && r.isMap, i = n ? t(n) : e;
  return jo = i, jo;
}
var ko, Xf;
function Ug() {
  if (Xf) return ko;
  Xf = 1;
  var e = Ka(), t = ut(), r = "[object Set]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return ko = n, ko;
}
var No, Yf;
function xg() {
  if (Yf) return No;
  Yf = 1;
  var e = Ug(), t = Da(), r = Ma(), n = r && r.isSet, i = n ? t(n) : e;
  return No = i, No;
}
var Lo, Zf;
function Wh() {
  if (Zf) return Lo;
  Zf = 1;
  var e = ug(), t = cg(), r = Fa(), n = gg(), i = bg(), o = _g(), s = wg(), a = Og(), u = Ag(), f = Cg(), c = Kh(), l = Ka(), d = Tg(), h = Lg(), y = Mg(), O = ze(), b = Dh(), C = $g(), w = wt(), E = xg(), g = $a(), v = Ua(), p = 1, S = 2, _ = 4, A = "[object Arguments]", F = "[object Array]", T = "[object Boolean]", D = "[object Date]", N = "[object Error]", $ = "[object Function]", G = "[object GeneratorFunction]", X = "[object Map]", Z = "[object Number]", ce = "[object Object]", ne = "[object RegExp]", j = "[object Set]", R = "[object String]", k = "[object Symbol]", I = "[object WeakMap]", B = "[object ArrayBuffer]", Y = "[object DataView]", V = "[object Float32Array]", te = "[object Float64Array]", re = "[object Int8Array]", Q = "[object Int16Array]", M = "[object Int32Array]", W = "[object Uint8Array]", K = "[object Uint8ClampedArray]", U = "[object Uint16Array]", J = "[object Uint32Array]", x = {};
  x[A] = x[F] = x[B] = x[Y] = x[T] = x[D] = x[V] = x[te] = x[re] = x[Q] = x[M] = x[X] = x[Z] = x[ce] = x[ne] = x[j] = x[R] = x[k] = x[W] = x[K] = x[U] = x[J] = !0, x[N] = x[$] = x[I] = !1;
  function se(H, ie, he, ge, be, _e) {
    var ae, z = ie & p, pe = ie & S, Ne = ie & _;
    if (he && (ae = be ? he(H, ge, be, _e) : he(H)), ae !== void 0)
      return ae;
    if (!w(H))
      return H;
    var Ce = O(H);
    if (Ce) {
      if (ae = d(H), !z)
        return s(H, ae);
    } else {
      var Fe = l(H), Le = Fe == $ || Fe == G;
      if (b(H))
        return o(H, z);
      if (Fe == ce || Fe == A || Le && !be) {
        if (ae = pe || Le ? {} : y(H), !z)
          return pe ? u(H, i(ae, H)) : a(H, n(ae, H));
      } else {
        if (!x[Fe])
          return be ? H : {};
        ae = h(H, Fe, z);
      }
    }
    _e || (_e = new e());
    var qe = _e.get(H);
    if (qe)
      return qe;
    _e.set(H, ae), E(H) ? H.forEach(function(De) {
      ae.add(se(De, ie, he, De, H, _e));
    }) : C(H) && H.forEach(function(De, Ie) {
      ae.set(Ie, se(De, ie, he, Ie, H, _e));
    });
    var ir = Ne ? pe ? c : f : pe ? v : g, or = Ce ? void 0 : ir(H);
    return t(or || H, function(De, Ie) {
      or && (Ie = De, De = H[Ie]), r(ae, Ie, se(De, ie, he, Ie, H, _e));
    }), ae;
  }
  return Lo = se, Lo;
}
var Do, el;
function Hg() {
  if (el) return Do;
  el = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Do = e, Do;
}
var Mo, tl;
function Kg() {
  if (tl) return Mo;
  tl = 1;
  function e(t, r, n) {
    var i = -1, o = t.length;
    r < 0 && (r = -r > o ? 0 : o + r), n = n > o ? o : n, n < 0 && (n += o), o = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++i < o; )
      s[i] = t[i + r];
    return s;
  }
  return Mo = e, Mo;
}
var Bo, rl;
function Wg() {
  if (rl) return Bo;
  rl = 1;
  var e = Ta(), t = Kg();
  function r(n, i) {
    return i.length < 2 ? n : e(n, t(i, 0, -1));
  }
  return Bo = r, Bo;
}
var $o, nl;
function Gg() {
  if (nl) return $o;
  nl = 1;
  var e = St(), t = Hg(), r = Wg(), n = Ur(), i = Object.prototype, o = i.hasOwnProperty;
  function s(a, u) {
    u = e(u, a);
    var f = -1, c = u.length;
    if (!c)
      return !0;
    for (; ++f < c; ) {
      var l = n(u[f]);
      if (l === "__proto__" && !o.call(a, "__proto__") || (l === "constructor" || l === "prototype") && f < c - 1)
        return !1;
    }
    var d = r(a, u);
    return d == null || delete d[n(t(u))];
  }
  return $o = s, $o;
}
var Uo, il;
function Vg() {
  if (il) return Uo;
  il = 1;
  var e = _t(), t = Ha(), r = ut(), n = "[object Object]", i = Function.prototype, o = Object.prototype, s = i.toString, a = o.hasOwnProperty, u = s.call(Object);
  function f(c) {
    if (!r(c) || e(c) != n)
      return !1;
    var l = t(c);
    if (l === null)
      return !0;
    var d = a.call(l, "constructor") && l.constructor;
    return typeof d == "function" && d instanceof d && s.call(d) == u;
  }
  return Uo = f, Uo;
}
var xo, ol;
function zg() {
  if (ol) return xo;
  ol = 1;
  var e = Vg();
  function t(r) {
    return e(r) ? void 0 : r;
  }
  return xo = t, xo;
}
var Ho, sl;
function Jg() {
  if (sl) return Ho;
  sl = 1;
  var e = Ih(), t = Wh(), r = Gg(), n = St(), i = Zt(), o = zg(), s = Lh(), a = Kh(), u = 1, f = 2, c = 4, l = s(function(d, h) {
    var y = {};
    if (d == null)
      return y;
    var O = !1;
    h = e(h, function(C) {
      return C = n(C, d), O || (O = C.length > 1), C;
    }), i(d, a(d), y), O && (y = t(y, u | f | c, o));
    for (var b = h.length; b--; )
      r(y, h[b]);
    return y;
  });
  return Ho = l, Ho;
}
Jg();
var cr = { exports: {} }, Ko, al;
function Gh() {
  if (al) return Ko;
  al = 1;
  var e = 1e3, t = e * 60, r = t * 60, n = r * 24, i = n * 7, o = n * 365.25;
  Ko = function(c, l) {
    l = l || {};
    var d = typeof c;
    if (d === "string" && c.length > 0)
      return s(c);
    if (d === "number" && isFinite(c))
      return l.long ? u(c) : a(c);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(c)
    );
  };
  function s(c) {
    if (c = String(c), !(c.length > 100)) {
      var l = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        c
      );
      if (l) {
        var d = parseFloat(l[1]), h = (l[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return d * o;
          case "weeks":
          case "week":
          case "w":
            return d * i;
          case "days":
          case "day":
          case "d":
            return d * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return d * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return d * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return d * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return d;
          default:
            return;
        }
      }
    }
  }
  function a(c) {
    var l = Math.abs(c);
    return l >= n ? Math.round(c / n) + "d" : l >= r ? Math.round(c / r) + "h" : l >= t ? Math.round(c / t) + "m" : l >= e ? Math.round(c / e) + "s" : c + "ms";
  }
  function u(c) {
    var l = Math.abs(c);
    return l >= n ? f(c, l, n, "day") : l >= r ? f(c, l, r, "hour") : l >= t ? f(c, l, t, "minute") : l >= e ? f(c, l, e, "second") : c + " ms";
  }
  function f(c, l, d, h) {
    var y = l >= d * 1.5;
    return Math.round(c / d) + " " + h + (y ? "s" : "");
  }
  return Ko;
}
var Wo, ul;
function Qg() {
  if (ul) return Wo;
  ul = 1;
  function e(t) {
    n.debug = n, n.default = n, n.coerce = f, n.disable = a, n.enable = o, n.enabled = u, n.humanize = Gh(), n.destroy = c, Object.keys(t).forEach((l) => {
      n[l] = t[l];
    }), n.names = [], n.skips = [], n.formatters = {};
    function r(l) {
      let d = 0;
      for (let h = 0; h < l.length; h++)
        d = (d << 5) - d + l.charCodeAt(h), d |= 0;
      return n.colors[Math.abs(d) % n.colors.length];
    }
    n.selectColor = r;
    function n(l) {
      let d, h = null, y, O;
      function b(...C) {
        if (!b.enabled)
          return;
        const w = b, E = Number(/* @__PURE__ */ new Date()), g = E - (d || E);
        w.diff = g, w.prev = d, w.curr = E, d = E, C[0] = n.coerce(C[0]), typeof C[0] != "string" && C.unshift("%O");
        let v = 0;
        C[0] = C[0].replace(/%([a-zA-Z%])/g, (S, _) => {
          if (S === "%%")
            return "%";
          v++;
          const A = n.formatters[_];
          if (typeof A == "function") {
            const F = C[v];
            S = A.call(w, F), C.splice(v, 1), v--;
          }
          return S;
        }), n.formatArgs.call(w, C), (w.log || n.log).apply(w, C);
      }
      return b.namespace = l, b.useColors = n.useColors(), b.color = n.selectColor(l), b.extend = i, b.destroy = n.destroy, Object.defineProperty(b, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => h !== null ? h : (y !== n.namespaces && (y = n.namespaces, O = n.enabled(l)), O),
        set: (C) => {
          h = C;
        }
      }), typeof n.init == "function" && n.init(b), b;
    }
    function i(l, d) {
      const h = n(this.namespace + (typeof d > "u" ? ":" : d) + l);
      return h.log = this.log, h;
    }
    function o(l) {
      n.save(l), n.namespaces = l, n.names = [], n.skips = [];
      const d = (typeof l == "string" ? l : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
      for (const h of d)
        h[0] === "-" ? n.skips.push(h.slice(1)) : n.names.push(h);
    }
    function s(l, d) {
      let h = 0, y = 0, O = -1, b = 0;
      for (; h < l.length; )
        if (y < d.length && (d[y] === l[h] || d[y] === "*"))
          d[y] === "*" ? (O = y, b = h, y++) : (h++, y++);
        else if (O !== -1)
          y = O + 1, b++, h = b;
        else
          return !1;
      for (; y < d.length && d[y] === "*"; )
        y++;
      return y === d.length;
    }
    function a() {
      const l = [
        ...n.names,
        ...n.skips.map((d) => "-" + d)
      ].join(",");
      return n.enable(""), l;
    }
    function u(l) {
      for (const d of n.skips)
        if (s(l, d))
          return !1;
      for (const d of n.names)
        if (s(l, d))
          return !0;
      return !1;
    }
    function f(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
    function c() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return n.enable(n.load()), n;
  }
  return Wo = e, Wo;
}
var cl;
function Xg() {
  return cl || (cl = 1, (function(e, t) {
    t.formatArgs = n, t.save = i, t.load = o, t.useColors = r, t.storage = s(), t.destroy = /* @__PURE__ */ (() => {
      let u = !1;
      return () => {
        u || (u = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function r() {
      if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
        return !0;
      if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
        return !1;
      let u;
      return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && (u = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(u[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function n(u) {
      if (u[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + u[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
        return;
      const f = "color: " + this.color;
      u.splice(1, 0, f, "color: inherit");
      let c = 0, l = 0;
      u[0].replace(/%[a-zA-Z%]/g, (d) => {
        d !== "%%" && (c++, d === "%c" && (l = c));
      }), u.splice(l, 0, f);
    }
    t.log = console.debug || console.log || (() => {
    });
    function i(u) {
      try {
        u ? t.storage.setItem("debug", u) : t.storage.removeItem("debug");
      } catch {
      }
    }
    function o() {
      let u;
      try {
        u = t.storage.getItem("debug") || t.storage.getItem("DEBUG");
      } catch {
      }
      return !u && typeof process < "u" && "env" in process && (u = process.env.DEBUG), u;
    }
    function s() {
      try {
        return localStorage;
      } catch {
      }
    }
    e.exports = Qg()(t);
    const { formatters: a } = e.exports;
    a.j = function(u) {
      try {
        return JSON.stringify(u);
      } catch (f) {
        return "[UnexpectedJSONParseError]: " + f.message;
      }
    };
  })(cr, cr.exports)), cr.exports;
}
var Yg = Xg();
const Vh = /* @__PURE__ */ at(Yg);
var Go, fl;
function Zg() {
  if (fl) return Go;
  fl = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n, i) {
    return n != null && t.call(n, i);
  }
  return Go = r, Go;
}
var Vo, ll;
function em() {
  if (ll) return Vo;
  ll = 1;
  var e = Zg(), t = Nh();
  function r(n, i) {
    return n != null && t(n, i, e);
  }
  return Vo = r, Vo;
}
em();
var zo, dl;
function tm() {
  if (dl) return zo;
  dl = 1;
  var e = ja();
  function t(r, n, i, o) {
    return o = typeof o == "function" ? o : void 0, r == null ? r : e(r, n, i, o);
  }
  return zo = t, zo;
}
tm();
var Jo, hl;
function rm() {
  if (hl) return Jo;
  hl = 1;
  var e = Wh(), t = 4;
  function r(n) {
    return e(n, t);
  }
  return Jo = r, Jo;
}
rm();
var nm = ["find", "get", "create", "update", "patch", "remove"];
function zh(e, t, r, n = "anonymous") {
  if (!(Array.isArray(t) ? t : [t]).includes(e.type))
    throw new Error(`The '${n}' hook can only be used as a '${t}' hook.`);
  if (!r || !nm.includes(e.method))
    return;
  const i = Array.isArray(r) ? r : [r];
  if (i.length > 0 && !i.includes(e.method)) {
    const o = JSON.stringify(i);
    throw new Error(`The '${n}' hook can only be used on the '${o}' service method(s).`);
  }
}
Vh("fgraphql");
Vh("feathers-hooks-common/setField");
const s0 = (e) => (t) => (zh(t, "before", ["get"], "memoize"), t.id && t.id in e && (t.result = e[t.id]), t), a0 = (e) => (t) => {
  console.log(`* ${e || ""}
type:${t.type}, method: ${t.method}`), t.data && console.log("data:", t.data), t.params && t.params.query && console.log("query:", t.params.query), t.result && console.log("result:", t.result), t.error && console.log("error", t.error);
};
var fr = { exports: {} }, lr = { exports: {} }, Qo, pl;
function im() {
  if (pl) return Qo;
  pl = 1;
  function e(t) {
    n.debug = n, n.default = n, n.coerce = f, n.disable = a, n.enable = s, n.enabled = u, n.humanize = Gh(), Object.keys(t).forEach(function(c) {
      n[c] = t[c];
    }), n.instances = [], n.names = [], n.skips = [], n.formatters = {};
    function r(c) {
      for (var l = 0, d = 0; d < c.length; d++)
        l = (l << 5) - l + c.charCodeAt(d), l |= 0;
      return n.colors[Math.abs(l) % n.colors.length];
    }
    n.selectColor = r;
    function n(c) {
      var l;
      function d() {
        if (d.enabled) {
          for (var h = arguments.length, y = new Array(h), O = 0; O < h; O++)
            y[O] = arguments[O];
          var b = d, C = Number(/* @__PURE__ */ new Date()), w = C - (l || C);
          b.diff = w, b.prev = l, b.curr = C, l = C, y[0] = n.coerce(y[0]), typeof y[0] != "string" && y.unshift("%O");
          var E = 0;
          y[0] = y[0].replace(/%([a-zA-Z%])/g, function(v, p) {
            if (v === "%%")
              return v;
            E++;
            var S = n.formatters[p];
            if (typeof S == "function") {
              var _ = y[E];
              v = S.call(b, _), y.splice(E, 1), E--;
            }
            return v;
          }), n.formatArgs.call(b, y);
          var g = b.log || n.log;
          g.apply(b, y);
        }
      }
      return d.namespace = c, d.enabled = n.enabled(c), d.useColors = n.useColors(), d.color = r(c), d.destroy = i, d.extend = o, typeof n.init == "function" && n.init(d), n.instances.push(d), d;
    }
    function i() {
      var c = n.instances.indexOf(this);
      return c !== -1 ? (n.instances.splice(c, 1), !0) : !1;
    }
    function o(c, l) {
      return n(this.namespace + (typeof l > "u" ? ":" : l) + c);
    }
    function s(c) {
      n.save(c), n.names = [], n.skips = [];
      var l, d = (typeof c == "string" ? c : "").split(/[\s,]+/), h = d.length;
      for (l = 0; l < h; l++)
        d[l] && (c = d[l].replace(/\*/g, ".*?"), c[0] === "-" ? n.skips.push(new RegExp("^" + c.substr(1) + "$")) : n.names.push(new RegExp("^" + c + "$")));
      for (l = 0; l < n.instances.length; l++) {
        var y = n.instances[l];
        y.enabled = n.enabled(y.namespace);
      }
    }
    function a() {
      n.enable("");
    }
    function u(c) {
      if (c[c.length - 1] === "*")
        return !0;
      var l, d;
      for (l = 0, d = n.skips.length; l < d; l++)
        if (n.skips[l].test(c))
          return !1;
      for (l = 0, d = n.names.length; l < d; l++)
        if (n.names[l].test(c))
          return !0;
      return !1;
    }
    function f(c) {
      return c instanceof Error ? c.stack || c.message : c;
    }
    return n.enable(n.load()), n;
  }
  return Qo = e, Qo;
}
var yl;
function om() {
  return yl || (yl = 1, (function(e, t) {
    function r(c) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(d) {
        return typeof d;
      } : r = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, r(c);
    }
    t.log = o, t.formatArgs = i, t.save = s, t.load = a, t.useColors = n, t.storage = u(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
    function n() {
      return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function i(c) {
      if (c[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + c[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !!this.useColors) {
        var l = "color: " + this.color;
        c.splice(1, 0, l, "color: inherit");
        var d = 0, h = 0;
        c[0].replace(/%[a-zA-Z%]/g, function(y) {
          y !== "%%" && (d++, y === "%c" && (h = d));
        }), c.splice(h, 0, l);
      }
    }
    function o() {
      var c;
      return (typeof console > "u" ? "undefined" : r(console)) === "object" && console.log && (c = console).log.apply(c, arguments);
    }
    function s(c) {
      try {
        c ? t.storage.setItem("debug", c) : t.storage.removeItem("debug");
      } catch {
      }
    }
    function a() {
      var c;
      try {
        c = t.storage.getItem("debug");
      } catch {
      }
      return !c && typeof process < "u" && "env" in process && (c = process.env.DEBUG), c;
    }
    function u() {
      try {
        return localStorage;
      } catch {
      }
    }
    e.exports = im()(t);
    var f = e.exports.formatters;
    f.j = function(c) {
      try {
        return JSON.stringify(c);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
  })(lr, lr.exports)), lr.exports;
}
var gl;
function sm() {
  return gl || (gl = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = Object.assign || function(_) {
      for (var A = 1; A < arguments.length; A++) {
        var F = arguments[A];
        for (var T in F)
          Object.prototype.hasOwnProperty.call(F, T) && (_[T] = F[T]);
      }
      return _;
    }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
      return typeof _;
    } : function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, i = om()("feathers-errors");
    function o(_, A, F, T, D) {
      _ = _ || "Error";
      var N = void 0, $ = void 0, G = void 0;
      _ instanceof Error ? ($ = _.message || "Error", _.errors && (N = _.errors)) : (typeof _ > "u" ? "undefined" : n(_)) === "object" ? ($ = _.message || "Error", D = _) : $ = _, D && (G = JSON.parse(JSON.stringify(D)), G.errors ? (N = G.errors, delete G.errors) : D.errors && (N = JSON.parse(JSON.stringify(D.errors)))), this.type = "FeathersError", this.name = A, this.message = $, this.code = F, this.className = T, this.data = G, this.errors = N || {}, i(this.name + "(" + this.code + "): " + this.message), i(this.errors), Error.captureStackTrace ? Error.captureStackTrace(this, o) : this.stack = new Error().stack;
    }
    o.prototype = Object.create(Error.prototype), Object.defineProperty(o.prototype, "toJSON", {
      value: function() {
        return {
          name: this.name,
          message: this.message,
          code: this.code,
          className: this.className,
          data: this.data,
          errors: this.errors
        };
      }
    });
    function s(_, A) {
      o.call(this, _, "BadRequest", 400, "bad-request", A);
    }
    s.prototype = o.prototype;
    function a(_, A) {
      o.call(this, _, "NotAuthenticated", 401, "not-authenticated", A);
    }
    a.prototype = o.prototype;
    function u(_, A) {
      o.call(this, _, "PaymentError", 402, "payment-error", A);
    }
    u.prototype = o.prototype;
    function f(_, A) {
      o.call(this, _, "Forbidden", 403, "forbidden", A);
    }
    f.prototype = o.prototype;
    function c(_, A) {
      o.call(this, _, "NotFound", 404, "not-found", A);
    }
    c.prototype = o.prototype;
    function l(_, A) {
      o.call(this, _, "MethodNotAllowed", 405, "method-not-allowed", A);
    }
    l.prototype = o.prototype;
    function d(_, A) {
      o.call(this, _, "NotAcceptable", 406, "not-acceptable", A);
    }
    d.prototype = o.prototype;
    function h(_, A) {
      o.call(this, _, "Timeout", 408, "timeout", A);
    }
    h.prototype = o.prototype;
    function y(_, A) {
      o.call(this, _, "Conflict", 409, "conflict", A);
    }
    y.prototype = o.prototype;
    function O(_, A) {
      o.call(this, _, "LengthRequired", 411, "length-required", A);
    }
    O.prototype = o.prototype;
    function b(_, A) {
      o.call(this, _, "Unprocessable", 422, "unprocessable", A);
    }
    b.prototype = o.prototype;
    function C(_, A) {
      o.call(this, _, "TooManyRequests", 429, "too-many-requests", A);
    }
    C.prototype = o.prototype;
    function w(_, A) {
      o.call(this, _, "GeneralError", 500, "general-error", A);
    }
    w.prototype = o.prototype;
    function E(_, A) {
      o.call(this, _, "NotImplemented", 501, "not-implemented", A);
    }
    E.prototype = o.prototype;
    function g(_, A) {
      o.call(this, _, "BadGateway", 502, "bad-gateway", A);
    }
    g.prototype = o.prototype;
    function v(_, A) {
      o.call(this, _, "Unavailable", 503, "unavailable", A);
    }
    v.prototype = o.prototype;
    var p = {
      FeathersError: o,
      BadRequest: s,
      NotAuthenticated: a,
      PaymentError: u,
      Forbidden: f,
      NotFound: c,
      MethodNotAllowed: l,
      NotAcceptable: d,
      Timeout: h,
      Conflict: y,
      LengthRequired: O,
      Unprocessable: b,
      TooManyRequests: C,
      GeneralError: w,
      NotImplemented: E,
      BadGateway: g,
      Unavailable: v,
      400: s,
      401: a,
      402: u,
      403: f,
      404: c,
      405: l,
      406: d,
      408: h,
      409: y,
      411: O,
      422: b,
      429: C,
      500: w,
      501: E,
      502: g,
      503: v
    };
    function S(_) {
      if (!_)
        return _;
      var A = p[_.name], F = A ? new A(_.message, _.data) : new Error(_.message || _);
      return (typeof _ > "u" ? "undefined" : n(_)) === "object" && r(F, _), F;
    }
    t.default = r({
      convert: S,
      types: p,
      errors: p
    }, p), e.exports = t.default;
  })(fr, fr.exports)), fr.exports;
}
var am = sm();
const um = /* @__PURE__ */ at(am), u0 = () => function(e) {
  if (zh(e, "before", ["update", "patch", "remove"], "disableMultiItemChange"), !e.id)
    throw new um.BadRequest(`Multi-record changes not allowed for ${e.path} ${e.method}. (disableMultiItemChange)`);
}, c0 = (e = {}) => async (t) => {
  var c;
  const r = t.app.get("logger");
  r.info("reached the checkPermissions hook");
  const { params: n, path: i, method: o } = t;
  if (n != null && n.fromRemote || !(n != null && n.provider))
    return t;
  if (!(n != null && n.user) || !((c = n == null ? void 0 : n.user) != null && c.role))
    throw new Su.Forbidden("access denied");
  if (e.publicToAuthenticated)
    return t.params.fullAccess = !1, r.info({ ...t.logCtx, message: "checkPermissions bypassed: publicToAuthenticated service" }), t;
  const s = n.user.role, a = await t.app.service("roles").find({
    query: {
      _id: { $in: s }
    },
    paginate: !1
  }), u = a.some(
    (l) => {
      var d;
      return (d = l.permissions) == null ? void 0 : d.some((h) => h.serviceName === i && (h.method === o || h.method === "*"));
    }
  ), f = a.some((l) => {
    var d;
    return (d = l.permissions) == null ? void 0 : d.some((h) => h.serviceName === i && h.method === "fullAccess");
  });
  if (t.params.fullAccess = !!f, !u)
    throw new Su.Forbidden("Insufficient permissions");
  return r.info({ ...t.logCtx, message: "checkPermissions hook completed successfully" }), t;
}, f0 = () => async (e) => {
  const t = e.app.get("logger");
  t.info("reached the populateAdminUserRoles hook");
  const { params: r } = e;
  if (r.user && r.user.role && Array.isArray(r.user.role)) {
    const n = r.user.role, i = n[0];
    if (i && typeof i == "object" && "permissions" in i)
      return e;
    const o = await e.app.service("roles").find({
      query: { _id: { $in: n } },
      paginate: !1
    });
    r.user.role = o;
  }
  return t.info({ ...e.logCtx, message: "populateAdminUserRoles hook completed successfully" }), e;
}, Jh = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getcustomerFilterData hook");
  const r = e.params.user;
  if (!r || !r.companies || r.companies.length === 0)
    return t.info({ ...e.logCtx, message: "User has no Companies assigned to them" }), { sourceSystemCodes: [], customers: [] };
  const n = r.companies.map((c) => c.company), o = await e.app.service("source-systems").find({
    query: {
      companies: { $in: n }
    },
    paginate: !1
  }), a = (Array.isArray(o) ? o : o.data || []).map((c) => c.code);
  if (a.length === 0)
    return t.info({ ...e.logCtx, message: "no source systsm code found" }), { sourceSystemCodes: [], customers: [] };
  let u = [];
  e.path === "clientUsers" && (u = await e.app.service("guardianCustomers").filterFind(a));
  const f = u || [];
  return t.info({
    ...e.logCtx,
    message: "getcustomerFilterData hook completed successfully",
    sourceSystemCodes: a,
    customers: f
  }), { sourceSystemCodes: a, customers: f };
}, l0 = async (e) => {
  console.log(`Running hook CustomerFilter on ${e.path}.${e.method}`);
  const { sourceSystemCodes: t } = await Jh(e);
  return t.length === 0 ? (e.params.query = { ...e.params.query, _id: null }, e) : (e.params.query = {
    ...e.params.query,
    "sourceIds.source": { $in: t }
  }, console.log(`customer filter is ${JSON.stringify(e.params.query, null, 2)}`), e);
}, d0 = async (e) => {
  console.log(`Running hook auth filter on ${e.path}.${e.method}`);
  const t = e.params.query;
  console.log(`query ${JSON.stringify(t, null, 2)}`);
  const { customers: r } = await Jh(e);
  if (r.length === 0)
    return e.params.query = { ...e.params.query, _id: null }, e;
  const n = r.map((o) => o.c360Id);
  if (n.length === 0)
    return e.params.query = { ...e.params.query, _id: null }, e;
  const i = e.params.query["customer.id"];
  return i ? n.includes(i) ? (console.log(`contex qeury returned are ${JSON.stringify(e.params.query, null, 2)}`), e) : (e.params.query = { ...e.params.query, _id: null }, console.log(`contex qeury returned are ${JSON.stringify(e.params.query, null, 2)}`), e) : (e.params.query = {
    ...e.params.query,
    "customer.id": { $in: n }
  }, console.log(`contex qeury returned are ${JSON.stringify(e.params.query, null, 2)}`), e);
}, h0 = async (e) => {
  var r, n;
  const t = e.app.get("logger");
  return t.info("reached the transformC360IdNeQuery"), (n = (r = e == null ? void 0 : e.params) == null ? void 0 : r.query) != null && n.c360Id && typeof e.params.query.c360Id == "object" && e.params.query.c360Id.$ne === "" && (e.params.query.c360Id.$ne = null), t.info({ ...e.logCtx, message: "transformC360IdNeQuery hook completed successfully", query: e.params.query }), e;
}, p0 = async (e) => {
  var a, u, f, c;
  const t = e.app.get("logger");
  t.info("reached the addSourceIds hook");
  const r = e.params.user;
  if (!r || !(r != null && r.companies) || ((a = r == null ? void 0 : r.companies) == null ? void 0 : a.length) === 0)
    return (u = e == null ? void 0 : e.params) != null && u.provider && (e.params.query["sourceIds.source"] = "__NO_RESULT__"), e;
  const n = r.companies.map((l) => l.company), i = {};
  (Array.isArray(r.companies) ? r.companies : []).forEach((l) => {
    Array.isArray(l.lob) && l.lob.forEach((d) => {
      if (!d)
        return;
      const h = typeof d == "object" && typeof d.toString == "function" ? d.toString() : String(d);
      i[h] || (i[h] = d);
    });
  });
  const s = Object.values(i);
  console.log("lobs: ", s);
  try {
    const d = await e.app.service("source-systems").find({
      query: {
        companies: { $in: n },
        lobs: { $in: s }
      },
      paginate: !1
    }), y = (Array.isArray(d) ? d : d.data || []).map((O) => O.code);
    y.length === 0 ? (t.info({ ...e.logCtx, message: "No source systems found for user's companies - filtering to no results" }), (f = e == null ? void 0 : e.params) != null && f.provider && (e.params.query["sourceIds.source"] = "__NO_RESULTS__")) : e.params.query["sourceIds.source"] = { $in: y };
  } catch (l) {
    t.error({ ...e.logCtx, message: "Error getting source systems for user", error: l }), (c = e == null ? void 0 : e.params) != null && c.provider && (e.params.query["sourceIds.source"] = "__NO_RESULTS__");
  }
  return t.info({ ...e.logCtx, message: "addSourceIds hook completed successfully", query: e.params.query }), e;
}, y0 = (e) => {
  var r, n;
  const t = e.app.get("logger");
  return t.info("reached the addGuardianCustomerQuery hook"), (n = (r = e == null ? void 0 : e.params) == null ? void 0 : r.query) != null && n["sourceIds.source"] && (e.params.query["guardianCustomer.sourceIds.source"] = e.params.query["sourceIds.source"]), delete e.params.query["sourceIds.source"], t.info({ ...e.logCtx, message: "context query after addGuardianCustomerQuery in the hook", query: e.params.query }), e;
}, g0 = async (e) => {
  var a;
  const t = e.app.get("logger");
  t.info("reached the addUserLobs hook");
  const r = (a = e.params) == null ? void 0 : a.user, n = Array.isArray(r == null ? void 0 : r.companies) ? r.companies : [], i = [...new Set(n.flatMap((u) => u.lob))], s = (await e.app.service("lobs").find({
    query: { _id: { $in: i } },
    paginate: !1
  })).map((u) => u.code);
  return e.params.lobs = s, t.info({ ...e.logCtx, message: "addUserLobs hook completed successfully" }), e;
};
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function cm(e) {
  return e != null && typeof e == "object" && Array.isArray(e) === !1;
}
const fm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cm
}, Symbol.toStringTag, { value: "Module" })), lm = /* @__PURE__ */ Eh(fm);
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Xo, ml;
function dm() {
  return ml || (ml = 1, Xo = function(t) {
    return t != null && typeof t == "object" && Array.isArray(t) === !1;
  }), Xo;
}
/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
var Yo, vl;
function hm() {
  if (vl) return Yo;
  vl = 1;
  const e = dm();
  Yo = function(o, s, a) {
    if (e(a) || (a = { default: a }), !i(o))
      return typeof a.default < "u" ? a.default : o;
    typeof s == "number" && (s = String(s));
    const u = Array.isArray(s), f = typeof s == "string", c = a.separator || ".", l = a.joinChar || (typeof c == "string" ? c : ".");
    if (!f && !u)
      return o;
    if (f && s in o)
      return n(s, o, a) ? o[s] : a.default;
    let d = u ? s : r(s, c, a), h = d.length, y = 0;
    do {
      let O = d[y];
      for (typeof O == "number" && (O = String(O)); O && O.slice(-1) === "\\"; )
        O = t([O.slice(0, -1), d[++y] || ""], l, a);
      if (O in o) {
        if (!n(O, o, a))
          return a.default;
        o = o[O];
      } else {
        let b = !1, C = y + 1;
        for (; C < h; )
          if (O = t([O, d[C++]], l, a), b = O in o) {
            if (!n(O, o, a))
              return a.default;
            o = o[O], y = C - 1;
            break;
          }
        if (!b)
          return a.default;
      }
    } while (++y < h && i(o));
    return y === h ? o : a.default;
  };
  function t(o, s, a) {
    return typeof a.join == "function" ? a.join(o) : o[0] + s + o[1];
  }
  function r(o, s, a) {
    return typeof a.split == "function" ? a.split(o) : o.split(s);
  }
  function n(o, s, a) {
    return typeof a.isValid == "function" ? a.isValid(o, s) : !0;
  }
  function i(o) {
    return e(o) || Array.isArray(o) || typeof o == "function";
  }
  return Yo;
}
var Zo, bl;
function pm() {
  if (bl) return Zo;
  bl = 1;
  var e = Object.prototype.toString;
  Zo = function(l) {
    if (l === void 0) return "undefined";
    if (l === null) return "null";
    var d = typeof l;
    if (d === "boolean") return "boolean";
    if (d === "string") return "string";
    if (d === "number") return "number";
    if (d === "symbol") return "symbol";
    if (d === "function")
      return s(l) ? "generatorfunction" : "function";
    if (r(l)) return "array";
    if (f(l)) return "buffer";
    if (u(l)) return "arguments";
    if (i(l)) return "date";
    if (n(l)) return "error";
    if (o(l)) return "regexp";
    switch (t(l)) {
      case "Symbol":
        return "symbol";
      case "Promise":
        return "promise";
      // Set, Map, WeakSet, WeakMap
      case "WeakMap":
        return "weakmap";
      case "WeakSet":
        return "weakset";
      case "Map":
        return "map";
      case "Set":
        return "set";
      // 8-bit typed arrays
      case "Int8Array":
        return "int8array";
      case "Uint8Array":
        return "uint8array";
      case "Uint8ClampedArray":
        return "uint8clampedarray";
      // 16-bit typed arrays
      case "Int16Array":
        return "int16array";
      case "Uint16Array":
        return "uint16array";
      // 32-bit typed arrays
      case "Int32Array":
        return "int32array";
      case "Uint32Array":
        return "uint32array";
      case "Float32Array":
        return "float32array";
      case "Float64Array":
        return "float64array";
    }
    if (a(l))
      return "generator";
    switch (d = e.call(l), d) {
      case "[object Object]":
        return "object";
      // iterators
      case "[object Map Iterator]":
        return "mapiterator";
      case "[object Set Iterator]":
        return "setiterator";
      case "[object String Iterator]":
        return "stringiterator";
      case "[object Array Iterator]":
        return "arrayiterator";
    }
    return d.slice(8, -1).toLowerCase().replace(/\s/g, "");
  };
  function t(c) {
    return typeof c.constructor == "function" ? c.constructor.name : null;
  }
  function r(c) {
    return Array.isArray ? Array.isArray(c) : c instanceof Array;
  }
  function n(c) {
    return c instanceof Error || typeof c.message == "string" && c.constructor && typeof c.constructor.stackTraceLimit == "number";
  }
  function i(c) {
    return c instanceof Date ? !0 : typeof c.toDateString == "function" && typeof c.getDate == "function" && typeof c.setDate == "function";
  }
  function o(c) {
    return c instanceof RegExp ? !0 : typeof c.flags == "string" && typeof c.ignoreCase == "boolean" && typeof c.multiline == "boolean" && typeof c.global == "boolean";
  }
  function s(c, l) {
    return t(c) === "GeneratorFunction";
  }
  function a(c) {
    return typeof c.throw == "function" && typeof c.return == "function" && typeof c.next == "function";
  }
  function u(c) {
    try {
      if (typeof c.length == "number" && typeof c.callee == "function")
        return !0;
    } catch (l) {
      if (l.message.indexOf("callee") !== -1)
        return !0;
    }
    return !1;
  }
  function f(c) {
    return c.constructor && typeof c.constructor.isBuffer == "function" ? c.constructor.isBuffer(c) : !1;
  }
  return Zo;
}
/*!
 * has-values <https://github.com/jonschlinkert/has-values>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
var es, _l;
function ym() {
  if (_l) return es;
  _l = 1;
  const e = pm();
  return es = function t(r) {
    switch (e(r)) {
      case "boolean":
      case "date":
      case "function":
      case "null":
      case "number":
        return !0;
      case "undefined":
        return !1;
      case "regexp":
        return r.source !== "(?:)" && r.source !== "";
      case "buffer":
        return r.toString() !== "";
      case "error":
        return r.message !== "";
      case "string":
      case "arguments":
        return r.length !== 0;
      case "file":
      case "map":
      case "set":
        return r.size !== 0;
      case "array":
      case "object":
        for (const n of Object.keys(r))
          if (t(r[n]))
            return !0;
        return !1;
      // everything else
      default:
        return !0;
    }
  }, es;
}
/*!
 * has-value <https://github.com/jonschlinkert/has-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
var ts, wl;
function gm() {
  if (wl) return ts;
  wl = 1;
  const e = hm(), t = ym();
  ts = function(n, i, o) {
    return r(n) && (typeof i == "string" || Array.isArray(i)) ? t(e(n, i, o)) : !1;
  };
  function r(n) {
    return n != null && (typeof n == "object" || typeof n == "function" || Array.isArray(n));
  }
  return ts;
}
/*!
 * unset-value <https://github.com/jonschlinkert/unset-value>
 *
 * Copyright (c) 2015, 2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var rs, Sl;
function mm() {
  if (Sl) return rs;
  Sl = 1;
  var e = lm, t = gm();
  const r = (i) => i === "__proto__" || i === "constructor" || i === "prototype", n = (i) => {
    if (r(i))
      throw new Error(`Cannot set unsafe key: "${i}"`);
  };
  return rs = function(o, s) {
    if (!e(o))
      throw new TypeError("expected an object.");
    var a = Array.isArray(s);
    if (!a && o.hasOwnProperty(s))
      return delete o[s], !0;
    if (t(o, s)) {
      for (var u = a ? s.slice() : s.split("."), f = u.pop(); u.length && u[u.length - 1].slice(-1) === "\\"; )
        f = u.pop().slice(0, -1) + "." + f;
      for (; u.length; )
        s = u.shift(), n(s), o = o[s];
      return delete o[f];
    }
    return !0;
  }, rs;
}
var vm = mm();
const bm = /* @__PURE__ */ at(vm);
var ns, Ol;
function Ot() {
  return Ol || (Ol = 1, ns = TypeError), ns;
}
const _m = {}, wm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _m
}, Symbol.toStringTag, { value: "Module" })), Sm = /* @__PURE__ */ Eh(wm);
var is, Al;
function xr() {
  if (Al) return is;
  Al = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, o = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = i && o && typeof o.get == "function" ? o.get : null, a = i && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, f = u ? WeakMap.prototype.has : null, c = typeof WeakSet == "function" && WeakSet.prototype, l = c ? WeakSet.prototype.has : null, d = typeof WeakRef == "function" && WeakRef.prototype, h = d ? WeakRef.prototype.deref : null, y = Boolean.prototype.valueOf, O = Object.prototype.toString, b = Function.prototype.toString, C = String.prototype.match, w = String.prototype.slice, E = String.prototype.replace, g = String.prototype.toUpperCase, v = String.prototype.toLowerCase, p = RegExp.prototype.test, S = Array.prototype.concat, _ = Array.prototype.join, A = Array.prototype.slice, F = Math.floor, T = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, D = Object.getOwnPropertySymbols, N = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, $ = typeof Symbol == "function" && typeof Symbol.iterator == "object", G = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $ || !0) ? Symbol.toStringTag : null, X = Object.prototype.propertyIsEnumerable, Z = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(q) {
    return q.__proto__;
  } : null);
  function ce(q, P) {
    if (q === 1 / 0 || q === -1 / 0 || q !== q || q && q > -1e3 && q < 1e3 || p.call(/e/, P))
      return P;
    var ue = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof q == "number") {
      var fe = q < 0 ? -F(-q) : F(q);
      if (fe !== q) {
        var le = String(fe), ee = w.call(P, le.length + 1);
        return E.call(le, ue, "$&_") + "." + E.call(E.call(ee, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return E.call(P, ue, "$&_");
  }
  var ne = Sm, j = ne.custom, R = J(j) ? j : null, k = {
    __proto__: null,
    double: '"',
    single: "'"
  }, I = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  is = function q(P, ue, fe, le) {
    var ee = ue || {};
    if (H(ee, "quoteStyle") && !H(k, ee.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (H(ee, "maxStringLength") && (typeof ee.maxStringLength == "number" ? ee.maxStringLength < 0 && ee.maxStringLength !== 1 / 0 : ee.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Ke = H(ee, "customInspect") ? ee.customInspect : !0;
    if (typeof Ke != "boolean" && Ke !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (H(ee, "indent") && ee.indent !== null && ee.indent !== "	" && !(parseInt(ee.indent, 10) === ee.indent && ee.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (H(ee, "numericSeparator") && typeof ee.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Je = ee.numericSeparator;
    if (typeof P > "u")
      return "undefined";
    if (P === null)
      return "null";
    if (typeof P == "boolean")
      return P ? "true" : "false";
    if (typeof P == "string")
      return Ce(P, ee);
    if (typeof P == "number") {
      if (P === 0)
        return 1 / 0 / P > 0 ? "0" : "-0";
      var Ee = String(P);
      return Je ? ce(P, Ee) : Ee;
    }
    if (typeof P == "bigint") {
      var We = String(P) + "n";
      return Je ? ce(P, We) : We;
    }
    var en = typeof ee.depth > "u" ? 5 : ee.depth;
    if (typeof fe > "u" && (fe = 0), fe >= en && en > 0 && typeof P == "object")
      return te(P) ? "[Array]" : "[Object]";
    var ft = De(ee, fe);
    if (typeof le > "u")
      le = [];
    else if (ge(le, P) >= 0)
      return "[Circular]";
    function je(lt, ur, cy) {
      if (ur && (le = A.call(le), le.push(ur)), cy) {
        var _u = {
          depth: ee.depth
        };
        return H(ee, "quoteStyle") && (_u.quoteStyle = ee.quoteStyle), q(lt, _u, fe + 1, le);
      }
      return q(lt, ee, fe + 1, le);
    }
    if (typeof P == "function" && !Q(P)) {
      var hu = he(P), pu = sr(P, je);
      return "[Function" + (hu ? ": " + hu : " (anonymous)") + "]" + (pu.length > 0 ? " { " + _.call(pu, ", ") + " }" : "");
    }
    if (J(P)) {
      var yu = $ ? E.call(String(P), /^(Symbol\(.*\))_[^)]*$/, "$1") : N.call(P);
      return typeof P == "object" && !$ ? Le(yu) : yu;
    }
    if (Ne(P)) {
      for (var qt = "<" + v.call(String(P.nodeName)), tn = P.attributes || [], ar = 0; ar < tn.length; ar++)
        qt += " " + tn[ar].name + "=" + B(Y(tn[ar].value), "double", ee);
      return qt += ">", P.childNodes && P.childNodes.length && (qt += "..."), qt += "</" + v.call(String(P.nodeName)) + ">", qt;
    }
    if (te(P)) {
      if (P.length === 0)
        return "[]";
      var rn = sr(P, je);
      return ft && !or(rn) ? "[" + Ie(rn, ft) + "]" : "[ " + _.call(rn, ", ") + " ]";
    }
    if (M(P)) {
      var nn = sr(P, je);
      return !("cause" in Error.prototype) && "cause" in P && !X.call(P, "cause") ? "{ [" + String(P) + "] " + _.call(S.call("[cause]: " + je(P.cause), nn), ", ") + " }" : nn.length === 0 ? "[" + String(P) + "]" : "{ [" + String(P) + "] " + _.call(nn, ", ") + " }";
    }
    if (typeof P == "object" && Ke) {
      if (R && typeof P[R] == "function" && ne)
        return ne(P, { depth: en - fe });
      if (Ke !== "symbol" && typeof P.inspect == "function")
        return P.inspect();
    }
    if (be(P)) {
      var gu = [];
      return n && n.call(P, function(lt, ur) {
        gu.push(je(ur, P, !0) + " => " + je(lt, P));
      }), ir("Map", r.call(P), gu, ft);
    }
    if (z(P)) {
      var mu = [];
      return a && a.call(P, function(lt) {
        mu.push(je(lt, P));
      }), ir("Set", s.call(P), mu, ft);
    }
    if (_e(P))
      return qe("WeakMap");
    if (pe(P))
      return qe("WeakSet");
    if (ae(P))
      return qe("WeakRef");
    if (K(P))
      return Le(je(Number(P)));
    if (x(P))
      return Le(je(T.call(P)));
    if (U(P))
      return Le(y.call(P));
    if (W(P))
      return Le(je(String(P)));
    if (typeof window < "u" && P === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && P === globalThis || typeof vt < "u" && P === vt)
      return "{ [object globalThis] }";
    if (!re(P) && !Q(P)) {
      var on = sr(P, je), vu = Z ? Z(P) === Object.prototype : P instanceof Object || P.constructor === Object, sn = P instanceof Object ? "" : "null prototype", bu = !vu && G && Object(P) === P && G in P ? w.call(ie(P), 8, -1) : sn ? "Object" : "", uy = vu || typeof P.constructor != "function" ? "" : P.constructor.name ? P.constructor.name + " " : "", an = uy + (bu || sn ? "[" + _.call(S.call([], bu || [], sn || []), ": ") + "] " : "");
      return on.length === 0 ? an + "{}" : ft ? an + "{" + Ie(on, ft) + "}" : an + "{ " + _.call(on, ", ") + " }";
    }
    return String(P);
  };
  function B(q, P, ue) {
    var fe = ue.quoteStyle || P, le = k[fe];
    return le + q + le;
  }
  function Y(q) {
    return E.call(String(q), /"/g, "&quot;");
  }
  function V(q) {
    return !G || !(typeof q == "object" && (G in q || typeof q[G] < "u"));
  }
  function te(q) {
    return ie(q) === "[object Array]" && V(q);
  }
  function re(q) {
    return ie(q) === "[object Date]" && V(q);
  }
  function Q(q) {
    return ie(q) === "[object RegExp]" && V(q);
  }
  function M(q) {
    return ie(q) === "[object Error]" && V(q);
  }
  function W(q) {
    return ie(q) === "[object String]" && V(q);
  }
  function K(q) {
    return ie(q) === "[object Number]" && V(q);
  }
  function U(q) {
    return ie(q) === "[object Boolean]" && V(q);
  }
  function J(q) {
    if ($)
      return q && typeof q == "object" && q instanceof Symbol;
    if (typeof q == "symbol")
      return !0;
    if (!q || typeof q != "object" || !N)
      return !1;
    try {
      return N.call(q), !0;
    } catch {
    }
    return !1;
  }
  function x(q) {
    if (!q || typeof q != "object" || !T)
      return !1;
    try {
      return T.call(q), !0;
    } catch {
    }
    return !1;
  }
  var se = Object.prototype.hasOwnProperty || function(q) {
    return q in this;
  };
  function H(q, P) {
    return se.call(q, P);
  }
  function ie(q) {
    return O.call(q);
  }
  function he(q) {
    if (q.name)
      return q.name;
    var P = C.call(b.call(q), /^function\s*([\w$]+)/);
    return P ? P[1] : null;
  }
  function ge(q, P) {
    if (q.indexOf)
      return q.indexOf(P);
    for (var ue = 0, fe = q.length; ue < fe; ue++)
      if (q[ue] === P)
        return ue;
    return -1;
  }
  function be(q) {
    if (!r || !q || typeof q != "object")
      return !1;
    try {
      r.call(q);
      try {
        s.call(q);
      } catch {
        return !0;
      }
      return q instanceof Map;
    } catch {
    }
    return !1;
  }
  function _e(q) {
    if (!f || !q || typeof q != "object")
      return !1;
    try {
      f.call(q, f);
      try {
        l.call(q, l);
      } catch {
        return !0;
      }
      return q instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function ae(q) {
    if (!h || !q || typeof q != "object")
      return !1;
    try {
      return h.call(q), !0;
    } catch {
    }
    return !1;
  }
  function z(q) {
    if (!s || !q || typeof q != "object")
      return !1;
    try {
      s.call(q);
      try {
        r.call(q);
      } catch {
        return !0;
      }
      return q instanceof Set;
    } catch {
    }
    return !1;
  }
  function pe(q) {
    if (!l || !q || typeof q != "object")
      return !1;
    try {
      l.call(q, l);
      try {
        f.call(q, f);
      } catch {
        return !0;
      }
      return q instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Ne(q) {
    return !q || typeof q != "object" ? !1 : typeof HTMLElement < "u" && q instanceof HTMLElement ? !0 : typeof q.nodeName == "string" && typeof q.getAttribute == "function";
  }
  function Ce(q, P) {
    if (q.length > P.maxStringLength) {
      var ue = q.length - P.maxStringLength, fe = "... " + ue + " more character" + (ue > 1 ? "s" : "");
      return Ce(w.call(q, 0, P.maxStringLength), P) + fe;
    }
    var le = I[P.quoteStyle || "single"];
    le.lastIndex = 0;
    var ee = E.call(E.call(q, le, "\\$1"), /[\x00-\x1f]/g, Fe);
    return B(ee, "single", P);
  }
  function Fe(q) {
    var P = q.charCodeAt(0), ue = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[P];
    return ue ? "\\" + ue : "\\x" + (P < 16 ? "0" : "") + g.call(P.toString(16));
  }
  function Le(q) {
    return "Object(" + q + ")";
  }
  function qe(q) {
    return q + " { ? }";
  }
  function ir(q, P, ue, fe) {
    var le = fe ? Ie(ue, fe) : _.call(ue, ", ");
    return q + " (" + P + ") {" + le + "}";
  }
  function or(q) {
    for (var P = 0; P < q.length; P++)
      if (ge(q[P], `
`) >= 0)
        return !1;
    return !0;
  }
  function De(q, P) {
    var ue;
    if (q.indent === "	")
      ue = "	";
    else if (typeof q.indent == "number" && q.indent > 0)
      ue = _.call(Array(q.indent + 1), " ");
    else
      return null;
    return {
      base: ue,
      prev: _.call(Array(P + 1), ue)
    };
  }
  function Ie(q, P) {
    if (q.length === 0)
      return "";
    var ue = `
` + P.prev + P.base;
    return ue + _.call(q, "," + ue) + `
` + P.prev;
  }
  function sr(q, P) {
    var ue = te(q), fe = [];
    if (ue) {
      fe.length = q.length;
      for (var le = 0; le < q.length; le++)
        fe[le] = H(q, le) ? P(q[le], q) : "";
    }
    var ee = typeof D == "function" ? D(q) : [], Ke;
    if ($) {
      Ke = {};
      for (var Je = 0; Je < ee.length; Je++)
        Ke["$" + ee[Je]] = ee[Je];
    }
    for (var Ee in q)
      H(q, Ee) && (ue && String(Number(Ee)) === Ee && Ee < q.length || $ && Ke["$" + Ee] instanceof Symbol || (p.call(/[^\w$]/, Ee) ? fe.push(P(Ee, q) + ": " + P(q[Ee], q)) : fe.push(Ee + ": " + P(q[Ee], q))));
    if (typeof D == "function")
      for (var We = 0; We < ee.length; We++)
        X.call(q, ee[We]) && fe.push("[" + P(ee[We]) + "]: " + P(q[ee[We]], q));
    return fe;
  }
  return is;
}
var os, Cl;
function Om() {
  if (Cl) return os;
  Cl = 1;
  var e = /* @__PURE__ */ xr(), t = /* @__PURE__ */ Ot(), r = function(a, u, f) {
    for (var c = a, l; (l = c.next) != null; c = l)
      if (l.key === u)
        return c.next = l.next, f || (l.next = /** @type {NonNullable<typeof list.next>} */
        a.next, a.next = l), l;
  }, n = function(a, u) {
    if (a) {
      var f = r(a, u);
      return f && f.value;
    }
  }, i = function(a, u, f) {
    var c = r(a, u);
    c ? c.value = f : a.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: u,
      next: a.next,
      value: f
    };
  }, o = function(a, u) {
    return a ? !!r(a, u) : !1;
  }, s = function(a, u) {
    if (a)
      return r(a, u, !0);
  };
  return os = function() {
    var u, f = {
      assert: function(c) {
        if (!f.has(c))
          throw new t("Side channel does not contain " + e(c));
      },
      delete: function(c) {
        var l = s(u, c);
        return l && u && !u.next && (u = void 0), !!l;
      },
      get: function(c) {
        return n(u, c);
      },
      has: function(c) {
        return o(u, c);
      },
      set: function(c, l) {
        u || (u = {
          next: void 0
        }), i(
          /** @type {NonNullable<typeof $o>} */
          u,
          c,
          l
        );
      }
    };
    return f;
  }, os;
}
var ss, El;
function Qh() {
  return El || (El = 1, ss = Object), ss;
}
var as, Rl;
function Am() {
  return Rl || (Rl = 1, as = Error), as;
}
var us, ql;
function Cm() {
  return ql || (ql = 1, us = EvalError), us;
}
var cs, Pl;
function Em() {
  return Pl || (Pl = 1, cs = RangeError), cs;
}
var fs, Tl;
function Rm() {
  return Tl || (Tl = 1, fs = ReferenceError), fs;
}
var ls, Fl;
function qm() {
  return Fl || (Fl = 1, ls = SyntaxError), ls;
}
var ds, Il;
function Pm() {
  return Il || (Il = 1, ds = URIError), ds;
}
var hs, jl;
function Tm() {
  return jl || (jl = 1, hs = Math.abs), hs;
}
var ps, kl;
function Fm() {
  return kl || (kl = 1, ps = Math.floor), ps;
}
var ys, Nl;
function Im() {
  return Nl || (Nl = 1, ys = Math.max), ys;
}
var gs, Ll;
function jm() {
  return Ll || (Ll = 1, gs = Math.min), gs;
}
var ms, Dl;
function km() {
  return Dl || (Dl = 1, ms = Math.pow), ms;
}
var vs, Ml;
function Nm() {
  return Ml || (Ml = 1, vs = Math.round), vs;
}
var bs, Bl;
function Lm() {
  return Bl || (Bl = 1, bs = Number.isNaN || function(t) {
    return t !== t;
  }), bs;
}
var _s, $l;
function Dm() {
  if ($l) return _s;
  $l = 1;
  var e = /* @__PURE__ */ Lm();
  return _s = function(r) {
    return e(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, _s;
}
var ws, Ul;
function Mm() {
  return Ul || (Ul = 1, ws = Object.getOwnPropertyDescriptor), ws;
}
var Ss, xl;
function Xh() {
  if (xl) return Ss;
  xl = 1;
  var e = /* @__PURE__ */ Mm();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Ss = e, Ss;
}
var Os, Hl;
function Yh() {
  if (Hl) return Os;
  Hl = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Os = e, Os;
}
var As, Kl;
function Bm() {
  return Kl || (Kl = 1, As = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[r] = i;
    for (var o in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (a.value !== i || a.enumerable !== !0)
        return !1;
    }
    return !0;
  }), As;
}
var Cs, Wl;
function $m() {
  if (Wl) return Cs;
  Wl = 1;
  var e = typeof Symbol < "u" && Symbol, t = Bm();
  return Cs = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Cs;
}
var Es, Gl;
function Zh() {
  return Gl || (Gl = 1, Es = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Es;
}
var Rs, Vl;
function ep() {
  if (Vl) return Rs;
  Vl = 1;
  var e = /* @__PURE__ */ Qh();
  return Rs = e.getPrototypeOf || null, Rs;
}
var qs, zl;
function Um() {
  if (zl) return qs;
  zl = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", i = function(u, f) {
    for (var c = [], l = 0; l < u.length; l += 1)
      c[l] = u[l];
    for (var d = 0; d < f.length; d += 1)
      c[d + u.length] = f[d];
    return c;
  }, o = function(u, f) {
    for (var c = [], l = f, d = 0; l < u.length; l += 1, d += 1)
      c[d] = u[l];
    return c;
  }, s = function(a, u) {
    for (var f = "", c = 0; c < a.length; c += 1)
      f += a[c], c + 1 < a.length && (f += u);
    return f;
  };
  return qs = function(u) {
    var f = this;
    if (typeof f != "function" || t.apply(f) !== n)
      throw new TypeError(e + f);
    for (var c = o(arguments, 1), l, d = function() {
      if (this instanceof l) {
        var C = f.apply(
          this,
          i(c, arguments)
        );
        return Object(C) === C ? C : this;
      }
      return f.apply(
        u,
        i(c, arguments)
      );
    }, h = r(0, f.length - c.length), y = [], O = 0; O < h; O++)
      y[O] = "$" + O;
    if (l = Function("binder", "return function (" + s(y, ",") + "){ return binder.apply(this,arguments); }")(d), f.prototype) {
      var b = function() {
      };
      b.prototype = f.prototype, l.prototype = new b(), b.prototype = null;
    }
    return l;
  }, qs;
}
var Ps, Jl;
function Hr() {
  if (Jl) return Ps;
  Jl = 1;
  var e = Um();
  return Ps = Function.prototype.bind || e, Ps;
}
var Ts, Ql;
function Ga() {
  return Ql || (Ql = 1, Ts = Function.prototype.call), Ts;
}
var Fs, Xl;
function tp() {
  return Xl || (Xl = 1, Fs = Function.prototype.apply), Fs;
}
var Is, Yl;
function xm() {
  return Yl || (Yl = 1, Is = typeof Reflect < "u" && Reflect && Reflect.apply), Is;
}
var js, Zl;
function Hm() {
  if (Zl) return js;
  Zl = 1;
  var e = Hr(), t = tp(), r = Ga(), n = xm();
  return js = n || e.call(r, t), js;
}
var ks, ed;
function rp() {
  if (ed) return ks;
  ed = 1;
  var e = Hr(), t = /* @__PURE__ */ Ot(), r = Ga(), n = Hm();
  return ks = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new t("a function is required");
    return n(e, r, o);
  }, ks;
}
var Ns, td;
function Km() {
  if (td) return Ns;
  td = 1;
  var e = rp(), t = /* @__PURE__ */ Xh(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, o = i.getPrototypeOf;
  return Ns = n && typeof n.get == "function" ? e([n.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(a) {
      return o(a == null ? a : i(a));
    }
  ) : !1, Ns;
}
var Ls, rd;
function Wm() {
  if (rd) return Ls;
  rd = 1;
  var e = Zh(), t = ep(), r = /* @__PURE__ */ Km();
  return Ls = e ? function(i) {
    return e(i);
  } : t ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return t(i);
  } : r ? function(i) {
    return r(i);
  } : null, Ls;
}
var Ds, nd;
function Gm() {
  if (nd) return Ds;
  nd = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Hr();
  return Ds = r.call(e, t), Ds;
}
var Ms, id;
function Va() {
  if (id) return Ms;
  id = 1;
  var e, t = /* @__PURE__ */ Qh(), r = /* @__PURE__ */ Am(), n = /* @__PURE__ */ Cm(), i = /* @__PURE__ */ Em(), o = /* @__PURE__ */ Rm(), s = /* @__PURE__ */ qm(), a = /* @__PURE__ */ Ot(), u = /* @__PURE__ */ Pm(), f = /* @__PURE__ */ Tm(), c = /* @__PURE__ */ Fm(), l = /* @__PURE__ */ Im(), d = /* @__PURE__ */ jm(), h = /* @__PURE__ */ km(), y = /* @__PURE__ */ Nm(), O = /* @__PURE__ */ Dm(), b = Function, C = function(Q) {
    try {
      return b('"use strict"; return (' + Q + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ Xh(), E = /* @__PURE__ */ Yh(), g = function() {
    throw new a();
  }, v = w ? (function() {
    try {
      return arguments.callee, g;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return g;
      }
    }
  })() : g, p = $m()(), S = Wm(), _ = ep(), A = Zh(), F = tp(), T = Ga(), D = {}, N = typeof Uint8Array > "u" || !S ? e : S(Uint8Array), $ = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": p && S ? S([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": D,
    "%AsyncGenerator%": D,
    "%AsyncGeneratorFunction%": D,
    "%AsyncIteratorPrototype%": D,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": b,
    "%GeneratorFunction%": D,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": p && S ? S(S([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !p || !S ? e : S((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !p || !S ? e : S((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": p && S ? S(""[Symbol.iterator]()) : e,
    "%Symbol%": p ? Symbol : e,
    "%SyntaxError%": s,
    "%ThrowTypeError%": v,
    "%TypedArray%": N,
    "%TypeError%": a,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": u,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": T,
    "%Function.prototype.apply%": F,
    "%Object.defineProperty%": E,
    "%Object.getPrototypeOf%": _,
    "%Math.abs%": f,
    "%Math.floor%": c,
    "%Math.max%": l,
    "%Math.min%": d,
    "%Math.pow%": h,
    "%Math.round%": y,
    "%Math.sign%": O,
    "%Reflect.getPrototypeOf%": A
  };
  if (S)
    try {
      null.error;
    } catch (Q) {
      var G = S(S(Q));
      $["%Error.prototype%"] = G;
    }
  var X = function Q(M) {
    var W;
    if (M === "%AsyncFunction%")
      W = C("async function () {}");
    else if (M === "%GeneratorFunction%")
      W = C("function* () {}");
    else if (M === "%AsyncGeneratorFunction%")
      W = C("async function* () {}");
    else if (M === "%AsyncGenerator%") {
      var K = Q("%AsyncGeneratorFunction%");
      K && (W = K.prototype);
    } else if (M === "%AsyncIteratorPrototype%") {
      var U = Q("%AsyncGenerator%");
      U && S && (W = S(U.prototype));
    }
    return $[M] = W, W;
  }, Z = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, ce = Hr(), ne = /* @__PURE__ */ Gm(), j = ce.call(T, Array.prototype.concat), R = ce.call(F, Array.prototype.splice), k = ce.call(T, String.prototype.replace), I = ce.call(T, String.prototype.slice), B = ce.call(T, RegExp.prototype.exec), Y = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, V = /\\(\\)?/g, te = function(M) {
    var W = I(M, 0, 1), K = I(M, -1);
    if (W === "%" && K !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (K === "%" && W !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var U = [];
    return k(M, Y, function(J, x, se, H) {
      U[U.length] = se ? k(H, V, "$1") : x || J;
    }), U;
  }, re = function(M, W) {
    var K = M, U;
    if (ne(Z, K) && (U = Z[K], K = "%" + U[0] + "%"), ne($, K)) {
      var J = $[K];
      if (J === D && (J = X(K)), typeof J > "u" && !W)
        throw new a("intrinsic " + M + " exists, but is not available. Please file an issue!");
      return {
        alias: U,
        name: K,
        value: J
      };
    }
    throw new s("intrinsic " + M + " does not exist!");
  };
  return Ms = function(M, W) {
    if (typeof M != "string" || M.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof W != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (B(/^%?[^%]*%?$/, M) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var K = te(M), U = K.length > 0 ? K[0] : "", J = re("%" + U + "%", W), x = J.name, se = J.value, H = !1, ie = J.alias;
    ie && (U = ie[0], R(K, j([0, 1], ie)));
    for (var he = 1, ge = !0; he < K.length; he += 1) {
      var be = K[he], _e = I(be, 0, 1), ae = I(be, -1);
      if ((_e === '"' || _e === "'" || _e === "`" || ae === '"' || ae === "'" || ae === "`") && _e !== ae)
        throw new s("property names with quotes must have matching quotes");
      if ((be === "constructor" || !ge) && (H = !0), U += "." + be, x = "%" + U + "%", ne($, x))
        se = $[x];
      else if (se != null) {
        if (!(be in se)) {
          if (!W)
            throw new a("base intrinsic for " + M + " exists, but the property is not available.");
          return;
        }
        if (w && he + 1 >= K.length) {
          var z = w(se, be);
          ge = !!z, ge && "get" in z && !("originalValue" in z.get) ? se = z.get : se = se[be];
        } else
          ge = ne(se, be), se = se[be];
        ge && !H && ($[x] = se);
      }
    }
    return se;
  }, Ms;
}
var Bs, od;
function np() {
  if (od) return Bs;
  od = 1;
  var e = /* @__PURE__ */ Va(), t = rp(), r = t([e("%String.prototype.indexOf%")]);
  return Bs = function(i, o) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(i, !!o)
    );
    return typeof s == "function" && r(i, ".prototype.") > -1 ? t(
      /** @type {const} */
      [s]
    ) : s;
  }, Bs;
}
var $s, sd;
function ip() {
  if (sd) return $s;
  sd = 1;
  var e = /* @__PURE__ */ Va(), t = /* @__PURE__ */ np(), r = /* @__PURE__ */ xr(), n = /* @__PURE__ */ Ot(), i = e("%Map%", !0), o = t("Map.prototype.get", !0), s = t("Map.prototype.set", !0), a = t("Map.prototype.has", !0), u = t("Map.prototype.delete", !0), f = t("Map.prototype.size", !0);
  return $s = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var l, d = {
      assert: function(h) {
        if (!d.has(h))
          throw new n("Side channel does not contain " + r(h));
      },
      delete: function(h) {
        if (l) {
          var y = u(l, h);
          return f(l) === 0 && (l = void 0), y;
        }
        return !1;
      },
      get: function(h) {
        if (l)
          return o(l, h);
      },
      has: function(h) {
        return l ? a(l, h) : !1;
      },
      set: function(h, y) {
        l || (l = new i()), s(l, h, y);
      }
    };
    return d;
  }, $s;
}
var Us, ad;
function Vm() {
  if (ad) return Us;
  ad = 1;
  var e = /* @__PURE__ */ Va(), t = /* @__PURE__ */ np(), r = /* @__PURE__ */ xr(), n = ip(), i = /* @__PURE__ */ Ot(), o = e("%WeakMap%", !0), s = t("WeakMap.prototype.get", !0), a = t("WeakMap.prototype.set", !0), u = t("WeakMap.prototype.has", !0), f = t("WeakMap.prototype.delete", !0);
  return Us = o ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var l, d, h = {
        assert: function(y) {
          if (!h.has(y))
            throw new i("Side channel does not contain " + r(y));
        },
        delete: function(y) {
          if (o && y && (typeof y == "object" || typeof y == "function")) {
            if (l)
              return f(l, y);
          } else if (n && d)
            return d.delete(y);
          return !1;
        },
        get: function(y) {
          return o && y && (typeof y == "object" || typeof y == "function") && l ? s(l, y) : d && d.get(y);
        },
        has: function(y) {
          return o && y && (typeof y == "object" || typeof y == "function") && l ? u(l, y) : !!d && d.has(y);
        },
        set: function(y, O) {
          o && y && (typeof y == "object" || typeof y == "function") ? (l || (l = new o()), a(l, y, O)) : n && (d || (d = n()), d.set(y, O));
        }
      };
      return h;
    }
  ) : n, Us;
}
var xs, ud;
function za() {
  if (ud) return xs;
  ud = 1;
  var e = /* @__PURE__ */ Ot(), t = /* @__PURE__ */ xr(), r = Om(), n = ip(), i = Vm(), o = i || n || r;
  return xs = function() {
    var a, u = {
      assert: function(f) {
        if (!u.has(f)) {
          var c = f && Object(f) === f ? "the given object key" : t(f);
          throw new e("Side channel does not contain " + c);
        }
      },
      delete: function(f) {
        return !!a && a.delete(f);
      },
      get: function(f) {
        return a && a.get(f);
      },
      has: function(f) {
        return !!a && a.has(f);
      },
      set: function(f, c) {
        a || (a = o()), a.set(f, c);
      }
    };
    return u;
  }, xs;
}
var Hs, cd;
function Ja() {
  if (cd) return Hs;
  cd = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986",
    WHATWG: "WHATWG"
  };
  return Hs = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      },
      WHATWG: function(n) {
        return e.call(n, t, "+");
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986,
    WHATWG: r.WHATWG
  }, Hs;
}
var Ks, fd;
function op() {
  if (fd) return Ks;
  fd = 1;
  var e = /* @__PURE__ */ Ja(), t = za(), r = /* @__PURE__ */ Yh(), n = Object.prototype.hasOwnProperty, i = Array.isArray, o = t(), s = function(R, k) {
    return o.set(R, k), R;
  }, a = function(R) {
    return o.has(R);
  }, u = function(R) {
    return o.get(R);
  }, f = function(R, k) {
    o.set(R, k);
  }, c = t(), l = function(R, k) {
    return c.set(R, k), R;
  }, d = function(R) {
    return c.has(R);
  }, h = function(R) {
    return c.get(R);
  }, y = (function() {
    for (var j = [], R = 0; R < 256; ++R)
      j[j.length] = "%" + ((R < 16 ? "0" : "") + R.toString(16)).toUpperCase();
    return j;
  })(), O = function(R) {
    for (; R.length > 1; ) {
      var k = R.pop(), I = k.obj[k.prop];
      if (i(I)) {
        for (var B = [], Y = 0; Y < I.length; ++Y)
          typeof I[Y] < "u" && (B[B.length] = I[Y]);
        k.obj[k.prop] = B;
      }
    }
  }, b = function(R, k) {
    for (var I = k && k.plainObjects ? { __proto__: null } : {}, B = 0; B < R.length; ++B)
      typeof R[B] < "u" && (I[B] = R[B]);
    return I;
  }, C = function(R, k, I) {
    k === "__proto__" && r ? r(R, k, {
      configurable: !0,
      enumerable: !0,
      value: I,
      writable: !0
    }) : R[k] = I;
  }, w = function(R, k) {
    for (var I = k, B = Object.keys(R), Y = 0; Y < B.length; ++Y) {
      var V = parseInt(B[Y], 10);
      String(V) === B[Y] && V > I && (I = V);
    }
    return I;
  }, E = function(R) {
    for (var k = 0, I = 0; I < R.length; ++I)
      n.call(R, I) && (k += 1);
    return k;
  }, g = function(R, k, I) {
    var B = [R, k];
    if (I && typeof I.arrayLimit == "number" && B.length > I.arrayLimit) {
      if (I.throwOnLimitExceeded)
        throw new RangeError("Array limit exceeded. Only " + I.arrayLimit + " element" + (I.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
      return s(b(B, I), 1);
    }
    return B;
  }, v = function j(R, k, I) {
    if (!k)
      return R;
    if (typeof k != "object" && typeof k != "function") {
      if (i(R)) {
        var B = R.length;
        if (I && typeof I.arrayLimit == "number" && E(R) >= I.arrayLimit) {
          if (I.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + I.arrayLimit + " element" + (I.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          return s(b(R.concat(k), I), B);
        }
        R[B] = k;
      } else if (R && typeof R == "object")
        if (a(R)) {
          var Y = u(R) + 1;
          R[Y] = k, f(R, Y);
        } else if (I && I.strictMerge && d(R)) {
          var V = h(R) + 1;
          if (I.throwOnLimitExceeded && typeof I.arrayLimit == "number" && V >= I.arrayLimit)
            throw new RangeError("Array limit exceeded. Only " + I.arrayLimit + " element" + (I.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          R[V] = k, l(R, V);
        } else if (I && I.strictMerge) {
          var te = g(R, k, I);
          return i(te) ? l(te, 1) : te;
        } else (I && (I.plainObjects || I.allowPrototypes) || !n.call(Object.prototype, k)) && (R[k] = !0);
      else
        return g(R, k, I);
      return R;
    }
    if (!R || typeof R != "object") {
      if (a(k)) {
        for (var re = Object.keys(k), Q = I && I.plainObjects ? { __proto__: null, 0: R } : { 0: R }, M = 0; M < re.length; M++) {
          var W = parseInt(re[M], 10);
          Q[W + 1] = k[re[M]];
        }
        return s(Q, u(k) + 1);
      }
      var K = [R].concat(k);
      if (I && typeof I.arrayLimit == "number" && K.length > I.arrayLimit) {
        if (I.throwOnLimitExceeded)
          throw new RangeError("Array limit exceeded. Only " + I.arrayLimit + " element" + (I.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
        return s(b(K, I), K.length - 1);
      }
      return K;
    }
    var U = R;
    if (i(R) && !i(k) && (U = b(R, I), d(R) && l(U, R.length - 1)), i(R) && i(k)) {
      if (k.forEach(function(J, x) {
        if (n.call(R, x)) {
          var se = R[x];
          se && typeof se == "object" && J && typeof J == "object" ? R[x] = j(se, J, I) : R[R.length] = J;
        } else
          R[x] = J;
      }), I && typeof I.arrayLimit == "number" && E(R) > I.arrayLimit) {
        if (I.throwOnLimitExceeded)
          throw new RangeError("Array limit exceeded. Only " + I.arrayLimit + " element" + (I.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
        return s(b(R, I), R.length - 1);
      }
      return R;
    }
    return Object.keys(k).reduce(function(J, x) {
      var se = k[x];
      if (n.call(J, x) ? C(J, x, j(J[x], se, I)) : C(J, x, se), a(k) && !a(J) && s(J, w(J, u(k))), a(J)) {
        var H = parseInt(x, 10);
        String(H) === x && H >= 0 && H > u(J) && f(J, H);
      }
      if (d(J)) {
        var ie = parseInt(x, 10);
        String(ie) === x && ie > h(J) && l(J, ie);
      }
      return J;
    }, U);
  }, p = function(R, k) {
    return Object.keys(k).reduce(function(I, B) {
      return C(I, B, k[B]), I;
    }, R);
  }, S = function(j, R, k) {
    if (typeof j == "string" && j.indexOf("%") === -1)
      return j.indexOf("+") === -1 ? j : j.replace(/\+/g, " ");
    var I = j.replace(/\+/g, " ");
    if (k === "iso-8859-1")
      return I.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(I);
    } catch {
      return I;
    }
  }, _ = typeof Symbol == "function" && typeof Symbol.toPrimitive == "symbol", A = Array.prototype.join, F = Array.prototype.toString, T = Object.prototype.toString, D = function j(R, k) {
    if (!R || typeof R != "object" && typeof R != "function" || _ && R[Symbol.toPrimitive] != null)
      return R;
    if (i(R) && R.toString === F && R.join === A) {
      var I = k || t();
      if (I.has(R))
        return "";
      I.set(R, !0);
      for (var B, Y = 0; Y < R.length; Y += 1) {
        var V = R[Y], te = j(V, I);
        if (!B && te !== V) {
          B = [];
          for (var re = 0; re < Y; re += 1)
            B[re] = R[re];
        }
        B && (B[Y] = te);
      }
      return I.delete(R), B || R;
    }
    if (typeof R.toString == "function")
      return R;
    var Q = R.valueOf;
    if (typeof Q == "function") {
      var M = Q.call(R);
      if (!M || typeof M != "object" && typeof M != "function")
        return String(M);
    }
    return T.call(R);
  }, N = 1024, $ = function(R, k, I, B, Y) {
    if (R.length === 0)
      return R;
    var V = R;
    if (typeof R == "symbol" ? V = Symbol.prototype.toString.call(R) : typeof R != "string" && (V = String(D(R))), I === "iso-8859-1")
      return escape(V).replace(/%u[0-9a-f]{4}/gi, function(x) {
        return "%26%23" + parseInt(x.slice(2), 16) + "%3B";
      }).replace(/\+/g, "%2B");
    for (var te = "", re = 0; re < V.length; re += N) {
      var Q = V.length >= N ? V.slice(re, re + N) : V;
      if (re + N < V.length) {
        var M = Q.charCodeAt(Q.length - 1);
        M >= 55296 && M <= 56319 && (Q = Q.slice(0, -1), re -= 1);
      }
      for (var W = [], K = 0; K < Q.length; ++K) {
        var U = Q.charCodeAt(K);
        if (U === 45 || U === 46 || U === 95 || U === 126 && Y !== e.WHATWG || U >= 48 && U <= 57 || U >= 65 && U <= 90 || U >= 97 && U <= 122 || Y === e.RFC1738 && (U === 40 || U === 41) || Y === e.WHATWG && U === 42) {
          W[W.length] = Q.charAt(K);
          continue;
        }
        if (U < 128) {
          W[W.length] = y[U];
          continue;
        }
        if (U < 2048) {
          W[W.length] = y[192 | U >> 6] + y[128 | U & 63];
          continue;
        }
        if (U < 55296 || U >= 57344) {
          W[W.length] = y[224 | U >> 12] + y[128 | U >> 6 & 63] + y[128 | U & 63];
          continue;
        }
        var J = Q.charCodeAt(K + 1);
        U <= 56319 && J >= 56320 && J <= 57343 ? (K += 1, U = 65536 + ((U & 1023) << 10 | J & 1023), W[W.length] = y[240 | U >> 18] + y[128 | U >> 12 & 63] + y[128 | U >> 6 & 63] + y[128 | U & 63]) : W[W.length] = "%EF%BF%BD";
      }
      te += W.join("");
    }
    return te;
  }, G = function(R) {
    for (var k = [{ obj: { o: R }, prop: "o" }], I = t(), B = 0; B < k.length; ++B)
      for (var Y = k[B], V = Y.obj[Y.prop], te = Object.keys(V), re = 0; re < te.length; ++re) {
        var Q = te[re], M = V[Q];
        typeof M == "object" && M !== null && !I.has(M) && (k[k.length] = { obj: V, prop: Q }, I.set(M, !0));
      }
    return O(k), R;
  }, X = function(R) {
    return Object.prototype.toString.call(R) === "[object RegExp]";
  }, Z = function(R) {
    return !R || typeof R != "object" ? !1 : !!(R.constructor && typeof R.constructor.isBuffer == "function" && R.constructor.isBuffer(R));
  }, ce = function(R, k, I, B, Y) {
    if (a(R)) {
      if (Y)
        throw new RangeError("Array limit exceeded. Only " + I + " element" + (I === 1 ? "" : "s") + " allowed in an array.");
      for (var V = i(k) ? k : [k], te = u(R), re = 0; re < V.length; ++re)
        te += 1, R[te] = V[re];
      return f(R, te), R;
    }
    var Q = [].concat(R, k);
    if (Q.length > I) {
      if (Y)
        throw new RangeError("Array limit exceeded. Only " + I + " element" + (I === 1 ? "" : "s") + " allowed in an array.");
      return s(b(Q, { plainObjects: B }), Q.length - 1);
    }
    return Q;
  }, ne = function(R, k) {
    if (i(R)) {
      for (var I = [], B = 0; B < R.length; B += 1)
        I[I.length] = k(R[B]);
      return I;
    }
    return k(R);
  };
  return Ks = {
    arrayToObject: b,
    assign: p,
    combine: ce,
    compact: G,
    decode: S,
    encode: $,
    isBuffer: Z,
    isOverflow: a,
    isRegExp: X,
    markOverflow: s,
    maybeMap: ne,
    merge: v,
    setProperty: C,
    toCoercible: D
  }, Ks;
}
var Ws, ld;
function zm() {
  if (ld) return Ws;
  ld = 1;
  var e = za(), t = /* @__PURE__ */ op(), r = /* @__PURE__ */ Ja(), n = Object.prototype.hasOwnProperty, i = {
    brackets: function(b) {
      return b + "[]";
    },
    comma: "comma",
    indices: function(b, C) {
      return b + "[" + C + "]";
    },
    repeat: function(b) {
      return b;
    }
  }, o = Array.isArray, s = Array.prototype.push, a = function(O, b) {
    s.apply(O, o(b) ? b : [b]);
  }, u = Date.prototype.toISOString, f = r.default, c = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    depth: 1 / 0,
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: f,
    formatter: r.formatters[f],
    // deprecated
    indices: !1,
    serializeDate: function(b) {
      return u.call(b);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, l = function(b) {
    return typeof b == "string" || typeof b == "number" || typeof b == "boolean" || typeof b == "symbol" || typeof b == "bigint";
  }, d = {}, h = function O(b, C, w, E, g, v, p, S, _, A, F, T, D, N, $, G, X, Z, ce, ne) {
    var j = b;
    if (ne > ce)
      throw new RangeError("Input depth exceeded depth option of " + ce);
    for (var R = Z, k = 0, I = !1; (R = R.get(d)) !== void 0 && !I; ) {
      var B = R.get(b);
      if (k += 1, typeof B < "u") {
        if (B === k)
          throw new RangeError("Cyclic object value");
        I = !0;
      }
      typeof R.get(d) > "u" && (k = 0);
    }
    if (j = typeof A == "function" ? A(C, j) : j, j instanceof Date ? j = D(j) : w === "comma" && o(j) && (j = t.maybeMap(j, function(H) {
      return H instanceof Date ? D(H) : H;
    })), j === null) {
      if (v)
        return $(_ && !G ? _(C, c.encoder, X, "key", N) : C);
      j = "";
    }
    if (l(j) || t.isBuffer(j)) {
      if (_) {
        var Y = G ? C : _(C, c.encoder, X, "key", N);
        return [$(Y) + "=" + $(_(j, c.encoder, X, "value", N))];
      }
      return [$(C) + "=" + $(String(j))];
    }
    var V = [];
    if (typeof j > "u")
      return V;
    var te;
    if (w === "comma" && o(j))
      G && _ && (j = t.maybeMap(j, function(H) {
        return H == null ? H : _(H, c.encoder, X, "value", N);
      })), te = [{ value: j.length > 0 ? t.toCoercible(j).join(",") || null : void 0 }];
    else if (o(A))
      te = A;
    else {
      var re = Object.keys(j);
      te = F ? re.sort(F) : re;
    }
    var Q = String(C), M = E && o(j) && j.length === 1 ? Q + "[]" : Q;
    if (g && o(j) && j.length === 0 && Object.keys(j).length === 0)
      return $(_ && !G ? _(M, c.encoder, X, "key", N) : M) + "[]";
    for (var W = 0; W < te.length; ++W) {
      var K = te[W], U = typeof K == "object" && K && typeof K.value < "u" ? K.value : j[K];
      if (!(p && U === null)) {
        var J = T && S ? String(K).replace(/\./g, "%2E") : String(K), x = o(j) ? typeof w == "function" ? w(M, J) : M : M + (T ? "." + J : "[" + J + "]");
        Z.set(b, k);
        var se = e();
        se.set(d, Z), a(V, O(
          U,
          x,
          w,
          E,
          g,
          v,
          p,
          S,
          w === "comma" && G && o(j) ? null : _,
          A,
          F,
          T,
          D,
          N,
          $,
          G,
          X,
          se,
          ce,
          ne + 1
        ));
      }
    }
    return V;
  }, y = function(b) {
    if (!b)
      return c;
    if (typeof b.allowEmptyArrays < "u" && typeof b.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof b.encodeDotInKeys < "u" && typeof b.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (b.encoder !== null && typeof b.encoder < "u" && typeof b.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var C = b.charset || c.charset;
    if (typeof b.charset < "u" && b.charset !== "utf-8" && b.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = r.default;
    if (typeof b.format < "u") {
      if (!n.call(r.formatters, b.format))
        throw new TypeError("Unknown format option provided.");
      w = b.format;
    }
    var E = r.formatters[w], g = c.filter;
    (typeof b.filter == "function" || o(b.filter)) && (g = b.filter);
    var v;
    if (n.call(i, b.arrayFormat) ? v = b.arrayFormat : "indices" in b ? v = b.indices ? "indices" : "repeat" : v = c.arrayFormat, "commaRoundTrip" in b && typeof b.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var p = typeof b.allowDots > "u" ? b.encodeDotInKeys === !0 ? !0 : c.allowDots : !!b.allowDots;
    return {
      addQueryPrefix: typeof b.addQueryPrefix == "boolean" ? b.addQueryPrefix : c.addQueryPrefix,
      allowDots: p,
      allowEmptyArrays: typeof b.allowEmptyArrays == "boolean" ? !!b.allowEmptyArrays : c.allowEmptyArrays,
      arrayFormat: v,
      charset: C,
      charsetSentinel: typeof b.charsetSentinel == "boolean" ? b.charsetSentinel : c.charsetSentinel,
      commaRoundTrip: !!b.commaRoundTrip,
      delimiter: typeof b.delimiter > "u" ? c.delimiter : b.delimiter,
      depth: typeof b.depth == "number" ? b.depth : c.depth,
      encode: typeof b.encode == "boolean" ? b.encode : c.encode,
      encodeDotInKeys: typeof b.encodeDotInKeys == "boolean" ? b.encodeDotInKeys : c.encodeDotInKeys,
      encoder: typeof b.encoder == "function" ? b.encoder : c.encoder,
      encodeValuesOnly: typeof b.encodeValuesOnly == "boolean" ? b.encodeValuesOnly : c.encodeValuesOnly,
      filter: g,
      format: w,
      formatter: E,
      serializeDate: typeof b.serializeDate == "function" ? b.serializeDate : c.serializeDate,
      skipNulls: typeof b.skipNulls == "boolean" ? b.skipNulls : c.skipNulls,
      sort: typeof b.sort == "function" ? b.sort : null,
      strictNullHandling: typeof b.strictNullHandling == "boolean" ? b.strictNullHandling : c.strictNullHandling
    };
  };
  return Ws = function(O, b) {
    var C = O, w = y(b), E, g;
    typeof w.filter == "function" ? (g = w.filter, C = g("", C)) : o(w.filter) && (g = w.filter.slice(), E = g);
    var v = [];
    if (typeof C != "object" || C === null)
      return "";
    var p = i[w.arrayFormat], S = p === "comma" && w.commaRoundTrip;
    E || (E = Object.keys(C)), w.sort && E.sort(w.sort);
    for (var _ = e(), A = 0; A < E.length; ++A) {
      var F = E[A];
      if (!(typeof F > "u" || F === null)) {
        var T = C[F];
        if (!(w.skipNulls && T === null)) {
          var D = w.encodeDotInKeys ? String(F).replace(/\./g, "%2E") : String(F);
          a(v, h(
            T,
            D,
            p,
            S,
            w.allowEmptyArrays,
            w.strictNullHandling,
            w.skipNulls,
            w.encodeDotInKeys,
            w.encode ? w.encoder : null,
            g,
            w.sort,
            w.allowDots,
            w.serializeDate,
            w.format,
            w.formatter,
            w.encodeValuesOnly,
            w.charset,
            _,
            w.depth,
            0
          ));
        }
      }
    }
    var N = v.join(w.delimiter), $ = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? $ += "utf8=%26%2310003%3B" + w.delimiter : $ += "utf8=%E2%9C%93" + w.delimiter), N.length > 0 ? $ + N : "";
  }, Ws;
}
var Gs, dd;
function Jm() {
  if (dd) return Gs;
  dd = 1;
  var e = za(), t = /* @__PURE__ */ op(), r = Object.prototype.hasOwnProperty, n = Array.isArray, i = Object.getPrototypeOf, o = String.fromCharCode, s = function(p) {
    if (!p || typeof p != "object")
      return !1;
    if (n(p))
      return !0;
    var S = i(p);
    return S === Object.prototype || S === null;
  }, a = function(p) {
    if (n(p)) {
      var S = [];
      return S.length = p.length, S;
    }
    return i(p) === null ? { __proto__: null } : {};
  }, u = function(p) {
    for (var S = e(), _ = {}, A = [{ source: p, target: _ }], F = 0; F < A.length; ++F)
      for (var T = A[F].source, D = A[F].target, N = Object.keys(T), $ = 0; $ < N.length; ++$) {
        var G = T[N[$]];
        if (s(G)) {
          if (!S.has(G)) {
            var X = a(G);
            S.set(G, X), A[A.length] = { source: G, target: X };
          }
          t.setProperty(D, N[$], S.get(G));
        } else
          t.setProperty(D, N[$], G);
      }
    return _;
  }, f = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictMerge: !0,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, c = function(v) {
    return v.replace(/&#(\d+);/g, function(p, S) {
      var _ = parseInt(S, 10);
      return _ > 65535 && _ <= 1114111 ? (_ -= 65536, o(55296 | _ >> 10, 56320 | _ & 1023)) : o(_);
    });
  }, l = function(v, p, S) {
    if (v && typeof v == "string" && p.comma && v.indexOf(",") > -1) {
      if (p.throwOnLimitExceeded)
        for (var _ = 0, A = v.indexOf(","); A > -1; ) {
          if (_ += 1, _ >= p.arrayLimit)
            throw new RangeError("Array limit exceeded. Only " + p.arrayLimit + " element" + (p.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          A = v.indexOf(",", A + 1);
        }
      return v.split(",");
    }
    if (p.throwOnLimitExceeded && S >= p.arrayLimit && S > 0)
      throw new RangeError("Array limit exceeded. Only " + p.arrayLimit + " element" + (p.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return v;
  }, d = "utf8=%26%2310003%3B", h = "utf8=%E2%9C%93", y = function(p, S) {
    var _ = { __proto__: null }, A = S.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    A = A.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var F = S.parameterLimit === 1 / 0 ? void 0 : S.parameterLimit, T = A.split(
      S.delimiter,
      S.throwOnLimitExceeded && typeof F < "u" ? F + 1 : F
    );
    if (S.throwOnLimitExceeded && typeof F < "u" && T.length > F)
      throw new RangeError("Parameter limit exceeded. Only " + F + " parameter" + (F === 1 ? "" : "s") + " allowed.");
    var D = -1, N, $ = S.charset;
    if (S.charsetSentinel)
      for (N = 0; N < T.length; ++N)
        T[N].indexOf("utf8=") === 0 && (T[N] === h ? $ = "utf-8" : T[N] === d && ($ = "iso-8859-1"), D = N, N = T.length);
    for (N = 0; N < T.length; ++N)
      if (N !== D) {
        var G = T[N], X = G.indexOf("]="), Z = X === -1 ? G.indexOf("=") : X + 1, ce = Z > 1 && G.slice(Z - 2, Z) === "[]", ne, j;
        if (Z === -1 ? (ne = S.decoder(G, f.decoder, $, "key"), j = S.strictNullHandling ? null : "") : (ne = S.decoder(G.slice(0, Z), f.decoder, $, "key"), ne !== null && (j = t.maybeMap(
          l(
            G.slice(Z + 1),
            S,
            n(_[ne]) && (S.duplicates === "combine" || ce) ? _[ne].length : 0
          ),
          function(k) {
            return S.decoder(k, f.decoder, $, "value");
          }
        ))), j && S.interpretNumericEntities && $ === "iso-8859-1" && (j = t.maybeMap(j, function(k) {
          return k && c(String(k));
        })), ce && (j = n(j) ? [j] : j), S.comma && n(j) && j.length > S.arrayLimit && (j = t.combine([], j, S.arrayLimit, S.plainObjects, S.throwOnLimitExceeded)), ne !== null) {
          var R = r.call(_, ne);
          R && (S.duplicates === "combine" || ce) ? _[ne] = t.combine(
            _[ne],
            j,
            S.arrayLimit,
            S.plainObjects,
            S.throwOnLimitExceeded
          ) : (!R || S.duplicates === "last") && (_[ne] = j);
        }
      }
    return _;
  }, O = function(p) {
    return p.charAt(0) === "[" && p.charAt(p.length - 1) === "]" ? p.slice(1, -1) : p;
  }, b = function(v, p, S, _) {
    var A = 0;
    if (v.length > 0 && v[v.length - 1] === "[]") {
      var F = v.slice(0, -1).join("");
      A = Array.isArray(p) && p[F] ? p[F].length : 0;
    }
    for (var T = _ ? p : l(p, S, A), D = v.length - 1; D >= 0; --D) {
      var N, $ = v[D];
      if ($ === "[]" && S.parseArrays)
        t.isOverflow(T) ? N = T : N = S.allowEmptyArrays && (T === "" || S.strictNullHandling && T === null) ? [] : t.combine(
          [],
          T,
          S.arrayLimit,
          S.plainObjects,
          S.throwOnLimitExceeded
        );
      else {
        N = S.plainObjects ? { __proto__: null } : {};
        var G = O($), X = S.decodeDotInKeys ? G.replace(/%2E/gi, ".") : G, Z = parseInt(X, 10), ce = !isNaN(Z) && $ !== X && String(Z) === X && Z >= 0 && S.parseArrays;
        if (!S.parseArrays && X === "")
          N[0] = T;
        else if (ce && Z < S.arrayLimit)
          N = [], N[Z] = T;
        else {
          if (ce && S.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + S.arrayLimit + " element" + (S.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          ce ? (N[Z] = T, t.markOverflow(N, Z)) : X !== "__proto__" && (N[X] = T);
        }
      }
      T = N;
    }
    return T;
  }, C = function(p) {
    for (var S = "", _ = 0, A = 0; A < p.length; A += 1) {
      var F = p.charCodeAt(A);
      if (F === 91)
        _ += 1, S += "[";
      else if (F === 93)
        _ > 0 && (_ -= 1), S += "]";
      else if (F === 46 && _ === 0 && A + 1 < p.length && p.charCodeAt(A + 1) !== 46 && p.charCodeAt(A + 1) !== 91) {
        for (var T = A + 1, D = T; D < p.length && p.charCodeAt(D) !== 46 && p.charCodeAt(D) !== 91; )
          D += 1;
        S += "[" + p.slice(T, D) + "]", A = D - 1;
      } else
        S += p.charAt(A);
    }
    return S;
  }, w = function(p, S) {
    var _ = S.allowDots ? C(p) : p;
    if (S.depth <= 0)
      return !S.plainObjects && r.call(Object.prototype, O(_)) && !S.allowPrototypes ? void 0 : [_];
    var A = [], F = _.indexOf("["), T = F >= 0 ? _.slice(0, F) : _;
    if (T) {
      if (!S.plainObjects && r.call(Object.prototype, T) && !S.allowPrototypes)
        return;
      A[A.length] = T;
    }
    for (var D = _.length, N = F, $ = 0; N >= 0 && $ < S.depth; ) {
      for (var G = 1, X = N + 1, Z = -1; X < D && Z < 0; ) {
        var ce = _.charCodeAt(X);
        ce === 91 ? G += 1 : ce === 93 && (G -= 1, G === 0 && (Z = X)), X += 1;
      }
      if (Z < 0)
        return A[A.length] = "[" + _.slice(N) + "]", A;
      var ne = _.slice(N, Z + 1), j = ne.slice(1, -1);
      if (!S.plainObjects && r.call(Object.prototype, j) && !S.allowPrototypes)
        return;
      A[A.length] = ne, $ += 1, N = _.indexOf("[", Z + 1);
    }
    if (N >= 0) {
      if (S.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + S.depth + " and strictDepth is true");
      A[A.length] = "[" + _.slice(N) + "]";
    }
    return A;
  }, E = function(p, S, _, A) {
    if (p) {
      var F = w(p, _);
      if (F)
        return b(F, S, _, A);
    }
  }, g = function(p) {
    if (!p)
      return f;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof p.throwOnLimitExceeded < "u" && typeof p.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var S = typeof p.charset > "u" ? f.charset : p.charset, _ = typeof p.duplicates > "u" ? f.duplicates : p.duplicates;
    if (_ !== "combine" && _ !== "first" && _ !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var A = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : f.allowDots : !!p.allowDots;
    return {
      allowDots: A,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : f.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : f.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : f.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : f.arrayLimit,
      charset: S,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : f.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : f.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : f.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : f.decoder,
      delimiter: typeof p.delimiter == "string" || t.isRegExp(p.delimiter) ? p.delimiter : f.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : f.depth,
      duplicates: _,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : f.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : f.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : f.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : f.strictDepth,
      strictMerge: typeof p.strictMerge == "boolean" ? !!p.strictMerge : f.strictMerge,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : f.strictNullHandling,
      throwOnLimitExceeded: typeof p.throwOnLimitExceeded == "boolean" ? p.throwOnLimitExceeded : !1
    };
  };
  return Gs = function(v, p) {
    var S = g(p);
    if (v === "" || v === null || typeof v > "u")
      return S.plainObjects ? { __proto__: null } : {};
    for (var _ = typeof v == "string" ? y(v, S) : u(v), A = S.plainObjects ? { __proto__: null } : {}, F = Object.keys(_), T = 0; T < F.length; ++T) {
      var D = F[T], N = E(D, _[D], S, typeof v == "string");
      A = t.merge(A, N, S);
    }
    return S.allowSparse === !0 ? A : t.compact(A);
  }, Gs;
}
var Vs, hd;
function Qm() {
  if (hd) return Vs;
  hd = 1;
  var e = /* @__PURE__ */ zm(), t = /* @__PURE__ */ Jm(), r = /* @__PURE__ */ Ja();
  return Vs = {
    formats: r,
    parse: t,
    stringify: e
  }, Vs;
}
const pd = (e, t) => {
  const r = Object.assign({}, e);
  return t.forEach((n) => bm(r, n)), r;
}, Xm = (e, t) => t.reduce((r, n) => (e[n] !== void 0 && (r[n] = e[n]), r), {}), Ir = (e) => e && typeof e == "object" && !Array.isArray(e), jr = (e) => Array.isArray(e) ? e.length === 0 : Object.keys(e).length === 0, Ym = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Zm = (e) => !!(e.params && e.params.query && !jr(e.params.query)), kr = (e, t) => (Ir(e) && Object.entries(e).forEach(([r, n]) => (Array.isArray(n) && n.forEach((i) => kr(i, t)), Ir(n) && kr(n, t), t(e, [r, n]))), e), pa = async (e, t) => (Ir(e) && await Promise.all(
  Object.entries(e).map(async ([r, n]) => (Array.isArray(n) && await Promise.all(
    n.map((i) => pa(i, t))
  ), Ir(n) && await pa(n, t), t(e, [r, n])))
), e), sp = (e) => {
  if (typeof e == "function")
    return e;
  const t = Array.isArray(e) ? [] : {};
  for (const r in e) {
    const n = e[r], i = {}.toString.call(n).slice(8, -1);
    i == "Array" || i == "Object" ? t[r] = sp(n) : i == "Date" ? t[r] = new Date(n.getTime()) : i == "RegExp" ? t[r] = RegExp(n.source, ev(n)) : t[r] = n;
  }
  return t;
}, ev = (e) => {
  if (typeof e.source.flags == "string")
    return e.source.flags;
  {
    const t = [];
    return e.global && t.push("g"), e.ignoreCase && t.push("i"), e.multiline && t.push("m"), e.sticky && t.push("y"), e.unicode && t.push("u"), t.join("");
  }
};
function tv(e) {
  return Object.keys(e).reduce((t, r) => {
    const n = e[r];
    return t[r] = {
      overwrite: !1,
      makeKey: (i) => i,
      makeParams: (i) => i,
      ...n
    }, t;
  }, {});
}
const rv = (e) => {
  const t = tv(e);
  return async (r) => {
    if (r.type === "before") {
      if (!nv(r, t))
        return r;
      const [i, o] = iv(
        sp(r.params.query),
        t
      );
      return r.joinSort = o, !jr(o) && r.method === "find" ? (r.result = await sv(
        i,
        o,
        r,
        t
      ), r) : (r.params.query = await ap(i, r, t), r);
    }
    if (!r.joinSort || jr(r.joinSort))
      return r;
    const { joinSort: n } = r;
    return delete r.joinSort, r.method === "find" || r.method === "get" || r.method === "update" || r.id !== null || (r.result = await av(n, r, t)), r;
  };
}, nv = (e, t) => {
  if (!Zm(e))
    return !1;
  let r = !1;
  return kr(e.params.query, (n, [i]) => {
    Qt(i, t) && (r = !0);
  }), r;
}, iv = (e, t) => {
  if (!e.$sort)
    return [e, {}];
  const r = Object.keys(e.$sort).filter((s) => Qt(s, t)), n = Xm(e.$sort, r), i = pd(e.$sort, r), o = pd(e, ["$sort"]);
  return jr(i) || (o.$sort = i), [o, n];
}, Qt = (e, t) => {
  const [r] = e.split(".");
  return !!t[r];
}, Qa = (e) => {
  const [t, ...r] = e.split("."), n = r.join(".");
  return [t, n];
}, ov = (e, t) => (kr(e, (r, [n, i]) => {
  if (!Qt(n, t))
    return;
  const [o, s] = Qa(n);
  s ? (delete r[n], r[o] = {
    ...r[o],
    [s]: i
  }) : r[o] = {
    ...r[o],
    ...i
  };
}), Object.entries(e).forEach(([r, n]) => {
  !Qt(r, t) || t[r].overwrite === !0 || (delete e[r], e.$and = e.$and || [], e.$and.push({ [r]: n }));
}), e), ap = async (e, t, r) => {
  const n = ov(e, r);
  return await pa(n, async (i, [o, s]) => {
    if (!Qt(o, r))
      return;
    delete i[o];
    const a = r[o], u = {
      paginate: !1,
      query: { $select: [a.targetKey], ...s }
    }, f = await a.makeParams(u, t, a), c = await t.app.service(a.service).find(f);
    return i[a.foreignKey] = {
      $in: cv(c.data || c, a)
    }, i;
  }), e;
}, sv = async (e, t, r, n) => {
  const i = await ap(
    e,
    r,
    n
  ), o = r.service.find({
    paginate: !1,
    query: i
  }), [s, ...a] = await Promise.all([
    o,
    ...up(t, r, n)
  ]), u = cp(
    t,
    n,
    a,
    s
  );
  return uv(r, u);
}, av = async (e, t, r) => {
  const n = await Promise.all(
    up(e, t, r)
  );
  return cp(
    e,
    r,
    n,
    t.result
  );
}, up = (e, t, r) => Object.entries(e).map(async ([n, i]) => {
  const [o, s] = Qa(n), { service: a, targetKey: u } = r[o];
  return await t.app.service(a).find({
    paginate: !1,
    query: { $select: [u], $sort: { [s]: i } }
  });
}), cp = (e, t, r, n) => {
  const i = [...n];
  return r.forEach((o, s) => {
    const [a] = Qa(Object.keys(e)[s]), { makeKey: u, foreignKey: f, targetKey: c } = t[a], l = o.map((d) => u(d[c]));
    i.sort((d, h) => {
      const y = u(d[f]), O = u(h[f]);
      return l.indexOf(y) - l.indexOf(O);
    });
  }), i;
}, uv = (e, t) => {
  const r = e.service && e.service.options && e.service.options.paginate, n = e.params && e.params.paginate, i = e.params && e.params.query, o = i && Ym(i, "$limit"), s = i && i.$limit, a = i && i.$skip || 0, u = t.length, f = {
    skip: a,
    limit: s,
    total: u
  };
  return !r || n === !1 ? o ? s === -1 ? [] : t.slice(a) : t : o ? s === -1 ? {
    ...f,
    data: []
  } : i.$limit > r.max ? {
    ...f,
    data: t.slice(a, r.max + 1)
  } : {
    ...f,
    data: t.slice(a, s + 1)
  } : {
    ...f,
    data: t.slice(a, r.default + 1)
  };
}, cv = (e, { makeKey: t, targetKey: r }) => e.map((n) => t(n[r])).filter((n, i, o) => n && o.indexOf(n) === i), m0 = ({ service: e, foreignKey: t, targetKey: r, label: n = "guardianCustomer" }) => rv({
  [n]: {
    service: e,
    foreignKey: t,
    targetKey: r,
    makeParams: (i, o) => {
      const s = o.app.get("logger");
      s.info("reached the joinQuery makeParams hook"), s.info({ ...o.logCtx, message: "joinQuery makeParams - Default params", query: i == null ? void 0 : i.query });
      const a = {
        ...i,
        query: { ...i == null ? void 0 : i.query, c360Id: { $ne: null } },
        // Pass along authentication context from original request
        user: o.params.user,
        authentication: o.params.authentication,
        authenticated: o.params.authenticated,
        provider: o.params.provider
      };
      return s.info({ ...o.logCtx, message: "joinQuery makeParams - Final params to Guardian service", query: a == null ? void 0 : a.query }), s.info({ ...o.logCtx, message: "joinQuery makeParams hook completed successfully" }), a;
    }
  }
}), v0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getUserAccountTags hook");
  try {
    const { app: r, params: n } = e, i = n.user;
    if (!i || !i.companies || !Array.isArray(i.companies))
      return t.info({ ...e.logCtx, message: "No admin user or companies found, setting empty account tags" }), e.params.allowedAccountTags = [], e;
    const o = [], s = [];
    if (i.companies.forEach((c) => {
      c.lob && Array.isArray(c.lob) && (s.push(c.company.toString()), o.push(...c.lob.map((l) => l.toString())));
    }), o.length === 0 && s.length === 0)
      return t.info({ ...e.logCtx, message: "No Company or LOBs found for user, setting empty account tags" }), e.params.allowedAccountTags = [], e;
    const f = (await r.service("source-systems").find({
      query: {
        lobs: { $in: o },
        companies: { $in: s }
      },
      paginate: !1
      // Get all matching source systems
    })).filter((c) => c.accounts_tags).map((c) => c.accounts_tags);
    return e.params.allowedAccountTags = f, t.info({ ...e.logCtx, message: "getUserAccountTags hook completed successfully", accountTags: f }), e;
  } catch (r) {
    return t.error({ ...e.logCtx, message: "Error in getUserAccountTags hook", error: r }), e.params.allowedAccountTags = [], e;
  }
}, b0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getUserCompanies hook");
  const { params: r } = e, n = r.user;
  if (!n || !(n != null && n.companies) || !Array.isArray(n == null ? void 0 : n.companies))
    return t.info({ ...e.logCtx, message: "No admin user or companies found, setting empty user company codes" }), e;
  const i = n.companies.map((u) => u.company), o = await e.app.service("companies").find({
    query: {
      _id: { $in: i }
    },
    paginate: !1
  }), a = (Array.isArray(o) ? o : (o == null ? void 0 : o.data) || []).map((u) => u.code.toLowerCase());
  return e.params.userCompanyCodes = a, t.info({ ...e.logCtx, message: "getUserCompanies hook completed successfully", userCompanyCodes: a }), e;
}, fv = ["c360Id", "masterId", "_id"], _0 = async (e, t = fv) => {
  var i;
  const r = e.app.get("logger");
  r.info("reached the TransformQSearchquery hook"), r.info({ ...e.logCtx, message: "reached the TransformQSearchquery", userFields: t });
  const { q: n } = e.params.query ?? {};
  if (n) {
    const o = (i = n == null ? void 0 : n.trim()) == null ? void 0 : i.includes(" "), s = t.find((f) => f === "firstName" || f.endsWith(".firstName")), a = t.find((f) => f === "lastName" || f.endsWith(".lastName")), u = t.filter((f) => f !== s && f !== a);
    if (o) {
      const [f, ...c] = n.trim().split(" "), l = c.join(" "), d = u.map((h) => ({ [h]: new RegExp(n, "i") }));
      s && a && d.push({
        [s]: new RegExp(`^${f}`, "i"),
        [a]: new RegExp(`^${l}`, "i")
      }), e.params.query.$or = d;
    } else {
      const f = u.map((c) => ({ [c]: new RegExp(n, "i") }));
      s && f.push({ [s]: new RegExp(`^${n}`, "i") }), a && f.push({ [a]: new RegExp(`^${n}`, "i") }), e.params.query.$or = f;
    }
    delete e.params.query.q;
  }
  return r.info({ ...e.logCtx, message: "context query after TransformQSearchquery in the hook", query: e.params.query }), e;
}, w0 = async (e, t = []) => {
  var i;
  const r = e.app.get("logger");
  if (r.info({ ...e.logCtx, message: "reached the TransformCaseInsensitiveFilters hook", fields: t }), !((i = e.params) != null && i.query) || t.length === 0)
    return r.info({ ...e.logCtx, message: "TransformCaseInsensitiveFilters skipped", query: e.params.query }), e;
  const n = e.params.query;
  return t.forEach((o) => {
    const s = n[o];
    if (s && typeof s == "string" && s.trim()) {
      const a = s.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      n[o] = new RegExp(a, "i");
    }
  }), r.info({ ...e.logCtx, message: "TransformCaseInsensitiveFilters hook completed successfully", query: e.params.query }), e;
}, S0 = async (e) => {
  const t = e.params.query || {};
  console.log("query in convertDateRange: ", JSON.stringify(t, null, 2));
  const { createdAt_from: r, createdAt_to: n, ...i } = t;
  if (r || n) {
    const o = {};
    r && (o.$gte = /* @__PURE__ */ new Date(`${r}T00:00:00.000Z`)), n && (o.$lte = /* @__PURE__ */ new Date(`${n}T23:59:59.999Z`)), e.params.query = {
      ...i,
      createdAt: o
    };
  } else
    e.params.query = i;
  return e;
}, O0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getUserTerritories hook");
  const { params: r } = e, n = r.user;
  if (!n || !(n != null && n.territories) || !Array.isArray(n == null ? void 0 : n.territories))
    return t.info({ ...e.logCtx, message: "No admin user or territories found, setting empty user territories" }), e;
  const i = (n == null ? void 0 : n.territories) || [], o = await e.app.service("territories").find({
    query: {
      _id: { $in: i }
    },
    paginate: !1
  }), a = (Array.isArray(o) ? o : (o == null ? void 0 : o.data) || []).map((u) => u.alpha2);
  return e.params.territories = a, t.info({ ...e.logCtx, message: "getUserTerritories hook completed successfully", territories: a }), e;
}, A0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getUserRolesHook hook");
  const { params: r } = e, n = r.user;
  if (!n || !n.role || !Array.isArray(n.role))
    return t.info({ ...e.logCtx, message: "No admin user or roles found, setting empty user roles" }), e;
  const i = n.role, o = await e.app.service("roles").find({
    query: {
      _id: { $in: i }
    },
    paginate: !1
  });
  return e.params.userRoles = o, t.info({ ...e.logCtx, message: "getUserRolesHook hook completed successfully" }), e;
}, C0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the getAllAccountTags hook");
  try {
    const { app: r, params: n } = e, i = n.user;
    if (!i || !i.companies || !Array.isArray(i.companies))
      return t.info({ ...e.logCtx, message: "No admin user or companies found, setting empty account tags" }), e.params.allowedAccountTags = [], e;
    const s = await r.service("source-systems").find({ paginate: !1 }), a = [...new Set(s.map((u) => u.accounts_tags))];
    return e.params.allAccountTags = a, t.info({ ...e.logCtx, message: "getAllAccountTags hook completed successfully", accountTags: a }), e;
  } catch (r) {
    return t.error({ ...e.logCtx, message: "Error in getAllAccountTags hook", error: r }), e.params.allAccountTags = [], e;
  }
}, E0 = async (e) => {
  const t = e.app.get("logger");
  try {
    t.info("reached the getAllLobs hook");
    const { app: r, params: n } = e, i = n.user;
    if (!i || !i.companies || !Array.isArray(i.companies))
      return t.info({ ...e.logCtx, message: "No admin user or companies found, setting empty lobs" }), e.params.allLobCodes = [], e;
    const s = await r.service("lobs").find({ paginate: !1 }), a = [...new Set(s.map((u) => u.code))];
    return e.params.allLobCodes = a, t.info({ ...e.logCtx, message: "getAllLobs hook completed successfully", lobCodes: a }), e;
  } catch (r) {
    return t.error({ ...e.logCtx, message: "Error in getAllLobs hook", error: r }), e.params.allLobCodes = [], e;
  }
};
var dr, lv = new Uint8Array(16);
function dv() {
  if (!dr && (dr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !dr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return dr(lv);
}
const hv = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function pv(e) {
  return typeof e == "string" && hv.test(e);
}
var Oe = [];
for (var zs = 0; zs < 256; ++zs)
  Oe.push((zs + 256).toString(16).substr(1));
function yv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Oe[e[t + 0]] + Oe[e[t + 1]] + Oe[e[t + 2]] + Oe[e[t + 3]] + "-" + Oe[e[t + 4]] + Oe[e[t + 5]] + "-" + Oe[e[t + 6]] + Oe[e[t + 7]] + "-" + Oe[e[t + 8]] + Oe[e[t + 9]] + "-" + Oe[e[t + 10]] + Oe[e[t + 11]] + Oe[e[t + 12]] + Oe[e[t + 13]] + Oe[e[t + 14]] + Oe[e[t + 15]]).toLowerCase();
  if (!pv(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function gv(e, t, r) {
  e = e || {};
  var n = e.random || (e.rng || dv)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, yv(n);
}
function R0(e) {
  const t = gv(), n = (e.params ?? {})["x-request-id"] ?? t;
  e.params.requestId = n;
  const i = {
    reqId: n
  };
  return e.logCtx = i, e;
}
const q0 = async (e) => {
  const t = e.app.get("logger");
  t.info("reached the addCountries hook");
  const r = e.params.territories;
  return !r || r.length === 0 ? (t.info({ ...e.logCtx, message: "No territories found, skipping addCountries hook" }), e) : (e.params.fullAccess === !1 && (e.params.query["addresses.country"] = { $in: r }), t.info({ ...e.logCtx, message: "addCountries hook completed successfully", query: e.params.query }), e);
}, P0 = async (e) => {
  e.data.createdAt = /* @__PURE__ */ new Date();
  const t = {
    query: { free: !0 }
  }, r = { userId: e.result._id, progress: "0" };
  return await (await e.app.service("guardian-customers").find(t)).data.map((i) => {
    e.app.service("guardian-customers").patch(i._id, { $push: { users: r } });
  }), e;
};
async function T0(e, t = "resources", r = {}) {
  var i, o;
  const n = e.service(t);
  for (const [s, a] of Object.entries(e.services)) {
    if (s === t || s.includes("/")) continue;
    const u = mv(a), f = ((o = (i = a.options) == null ? void 0 : i.docs) == null ? void 0 : o.description) ?? `Service for ${s}`;
    await vv(n, s, u, f, r);
  }
}
function mv(e) {
  const t = ["find", "get", "create", "update", "patch", "remove", "fullAccess"], r = [
    "approve",
    "reject",
    "return",
    "undo",
    "merge",
    "flagForResend",
    "manualUpdate",
    "revertManualUpdate"
  ];
  return [...t, ...r].filter((i) => typeof e[i] == "function");
}
async function vv(e, t, r, n, i) {
  try {
    const o = await e.find({
      ...i,
      query: { serviceName: t },
      paginate: !1
    }), s = Array.isArray(o) ? o : o == null ? void 0 : o.data;
    if (Array.isArray(s) && s.length > 0) {
      const a = s[0]._id;
      await e.patch(a, { serviceName: t, methods: r, description: n }, i);
    } else
      await e.create({ serviceName: t, methods: r, description: n }, i);
  } catch (o) {
    console.error(`[register-resource] Failed to register service "${t}":`, o);
  }
}
function fp(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: bv } = Object.prototype, { getPrototypeOf: xe } = Object, { iterator: er, toStringTag: lp } = Symbol, He = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), dp = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), Kr = (e, t, r) => e === Object.prototype || !r && t === null, _v = (e) => {
  if (!Object.isExtensible(e))
    return !1;
  const t = Object.getOwnPropertyNames(e);
  return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((r) => {
    if (dp(r))
      return !1;
    const n = Object.getOwnPropertyDescriptor(e, r);
    return !!n && n.configurable && n.writable === !0;
  });
}, Xa = (e, t) => {
  let r = e;
  const n = [];
  for (; r != null; ) {
    if (n.indexOf(r) !== -1)
      return !1;
    n.push(r);
    const i = xe(r);
    if (Kr(r, i, r === e))
      return !1;
    if (He(r, t))
      return !0;
    r = i;
  }
  return !1;
}, wv = (e, t) => e != null && Xa(e, t) ? e[t] : void 0, Sv = (e) => {
  if (e == null || typeof e != "object" && typeof e != "function")
    return e;
  const t = xe(e);
  if (t === null && _v(e))
    return e;
  const r = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), i = [];
  let o = e;
  for (; o != null && i.indexOf(o) === -1; ) {
    i.push(o);
    const s = o === e ? t : xe(o);
    if (Kr(o, s, o === e))
      break;
    const a = Object.getOwnPropertyNames(o);
    Object.getOwnPropertySymbols && a.push(...Object.getOwnPropertySymbols(o));
    for (const u of a)
      dp(u) || He(n, u) || (r[u] = e[u], n[u] = !0);
    o = s;
  }
  return r;
}, Ya = /* @__PURE__ */ ((e) => (t) => {
  const r = bv.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Te = (e) => (e = e.toLowerCase(), (t) => Ya(t) === e), Wr = (e) => (t) => typeof t === e, { isArray: it } = Array, ot = Wr("undefined");
function At(e) {
  return e !== null && !ot(e) && e.constructor !== null && !ot(e.constructor) && Ae(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const hp = Te("ArrayBuffer");
function Ov(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && hp(e.buffer), t;
}
const Av = Wr("string"), Ae = Wr("function"), Cv = Wr("number"), Ct = (e) => e !== null && typeof e == "object", Ev = (e) => e === !0 || e === !1, Or = (e) => {
  if (!Ct(e))
    return !1;
  const t = xe(e);
  return (t === null || t === Object.prototype || xe(t) === null) && // Treat own Symbol.toStringTag or Symbol.iterator members as evidence the
  // value is tagged/iterable, ignoring members reachable only through shared
  // or terminal prototype boundaries. This is exactly what
  // hasOwnInPrototypeChain(val, prop) computes here: every prototype admitted
  // above (null, Object.prototype, or a terminal null-prototype template) is
  // a boundary, so the walk never inspects anything but `val`'s own members,
  // and stops before even those when `val` is itself the boundary
  // Object.prototype. Checking that inline avoids allocating the walker's
  // `seen` list twice per call on the mergeConfig / merge hot path.
  (Kr(e, t, !0) || !He(e, lp) && !He(e, er));
}, Rv = (e) => {
  if (!Ct(e) || At(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, qv = Te("Date"), Pv = Te("File"), Tv = (e) => !!(e && typeof e.uri < "u"), Fv = (e) => e && typeof e.getParts < "u", Iv = Te("Blob"), jv = Te("FileList"), kv = Te("Set"), Nv = (e) => Ct(e) && Ae(e.pipe);
function Lv() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const yd = Lv(), gd = typeof yd.FormData < "u" ? yd.FormData : void 0, Dv = (e) => {
  if (!e) return !1;
  if (gd && e instanceof gd) return !0;
  const t = xe(e);
  if (!t || t === Object.prototype || !Ae(e.append)) return !1;
  const r = Ya(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Ae(e.toString) && e.toString() === "[object FormData]";
}, Mv = Te("URLSearchParams"), [Bv, $v, Uv, xv] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Te), Hv = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function tr(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, i;
  if (typeof e != "object" && (e = [e]), it(e))
    for (n = 0, i = e.length; n < i; n++)
      t.call(null, e[n], n, e);
  else {
    if (At(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let a;
    for (n = 0; n < s; n++)
      a = o[n], t.call(null, e[a], a, e);
  }
}
function Kv(e, t) {
  if (At(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, i;
  for (; n-- > 0; )
    if (i = r[n], t === i.toLowerCase())
      return i;
  return null;
}
const rt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, pp = (e) => !ot(e) && e !== rt;
function ya(...e) {
  const { caseless: t, skipUndefined: r } = pp(this) && this || {}, n = {}, i = t ? /* @__PURE__ */ Object.create(null) : null, o = (s, a) => {
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    let u = a;
    if (i && typeof a == "string") {
      const c = a.toLowerCase(), l = i[c];
      l !== void 0 && He(n, l) ? u = l : i[c] = a;
    }
    const f = He(n, u) ? n[u] : void 0;
    Or(f) && Or(s) ? n[u] = ya(f, s) : Or(s) ? n[u] = ya({}, s) : it(s) ? n[u] = s.slice() : (!r || !ot(s)) && (n[u] = s);
  };
  for (let s = 0, a = e.length; s < a; s++) {
    const u = e[s];
    if (!u || At(u) || (tr(u, o), typeof u != "object" || it(u) || !Object.getOwnPropertySymbols))
      continue;
    const f = Object.getOwnPropertySymbols(u);
    for (let c = 0; c < f.length; c++) {
      const l = f[c];
      rb.call(u, l) && o(u[l], l);
    }
  }
  return n;
}
const Wv = (e, t, r, { allOwnKeys: n } = {}) => (tr(
  t,
  (i, o) => {
    r && Ae(i) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: fp(i, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: i,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: n }
), e), Gv = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Vv = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, zv = (e, t, r, n) => {
  let i, o, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      s = i[o], (!n || n(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = r !== !1 && xe(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Jv = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Qv = (e) => {
  if (!e) return null;
  if (it(e)) return e;
  let t = e.length;
  if (!Number.isSafeInteger(t) || t < 0 || t > 4294967295) return null;
  const r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  let i = e;
  for (; i != null && r.size < t; ) {
    if (n.has(i)) return null;
    n.add(i);
    const s = xe(i);
    if (Kr(i, s, i === e)) break;
    Object.getOwnPropertyNames(i).forEach((a) => {
      const u = +a;
      Number.isInteger(u) && u >= 0 && u < t && String(u) === a && He(i, a) && r.add(u);
    }), i = s;
  }
  if (r.size !== t) return null;
  const o = new Array(t);
  for (; t-- > 0; )
    o[t] = e[t];
  return o;
}, Xv = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && xe(Uint8Array)), Yv = (e, t) => {
  const n = (e && e[er]).call(e);
  let i;
  for (; (i = n.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, Zv = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, eb = Te("HTMLFormElement"), tb = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, n, i) {
  return n.toUpperCase() + i;
}), { propertyIsEnumerable: rb } = Object.prototype, nb = Te("RegExp"), yp = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  tr(r, (i, o) => {
    let s;
    (s = t(i, o, e)) !== !1 && (n[o] = s || i);
  }), Object.defineProperties(e, n);
}, ib = (e) => {
  yp(e, (t, r) => {
    if (Ae(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const n = e[r];
    if (Ae(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, ob = (e, t) => {
  const r = {}, n = (i) => {
    i.forEach((o) => {
      r[o] = !0;
    });
  };
  return it(e) ? n(e) : n(String(e).split(t)), r;
}, sb = () => {
}, ab = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function ub(e) {
  return !!(e && Ae(e.append) && e[lp] === "FormData" && e[er]);
}
const cb = (e) => {
  const t = /* @__PURE__ */ new WeakSet(), r = (n) => {
    if (Ct(n)) {
      if (t.has(n))
        return;
      if (At(n))
        return n;
      if (!("toJSON" in n)) {
        t.add(n);
        let i;
        if (kv(n)) {
          i = [];
          for (const o of n) {
            const s = r(o);
            !ot(s) && i.push(s);
          }
        } else
          i = it(n) ? [] : {}, tr(n, (o, s) => {
            const a = r(o);
            !ot(a) && (i[s] = a);
          });
        return t.delete(n), i;
      }
    }
    return n;
  };
  return r(e);
}, fb = Te("AsyncFunction"), lb = (e) => e && (Ct(e) || Ae(e)) && Ae(e.then) && Ae(e.catch), gp = ((e, t) => e ? setImmediate : t ? ((r, n) => (rt.addEventListener(
  "message",
  ({ source: i, data: o }) => {
    i === rt && o === r && n.length && n.shift()();
  },
  !1
), (i) => {
  n.push(i), rt.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Ae(rt.postMessage)), db = typeof queueMicrotask < "u" ? queueMicrotask.bind(rt) : typeof process < "u" && process.nextTick || gp, mp = (e) => e != null && Ae(e[er]), hb = (e) => e != null && Xa(e, er) && mp(e), m = {
  isArray: it,
  isArrayBuffer: hp,
  isBuffer: At,
  isFormData: Dv,
  isArrayBufferView: Ov,
  isString: Av,
  isNumber: Cv,
  isBoolean: Ev,
  isObject: Ct,
  isPlainObject: Or,
  isEmptyObject: Rv,
  isReadableStream: Bv,
  isRequest: $v,
  isResponse: Uv,
  isHeaders: xv,
  isUndefined: ot,
  isDate: qv,
  isFile: Pv,
  isReactNativeBlob: Tv,
  isReactNative: Fv,
  isBlob: Iv,
  isRegExp: nb,
  isFunction: Ae,
  isStream: Nv,
  isURLSearchParams: Mv,
  isTypedArray: Xv,
  isFileList: jv,
  forEach: tr,
  merge: ya,
  extend: Wv,
  trim: Hv,
  stripBOM: Gv,
  inherits: Vv,
  toFlatObject: zv,
  kindOf: Ya,
  kindOfTest: Te,
  endsWith: Jv,
  toArray: Qv,
  forEachEntry: Yv,
  matchAll: Zv,
  isHTMLForm: eb,
  hasOwnProperty: He,
  hasOwnProp: He,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Xa,
  getSafeProp: wv,
  toSafeFlatObject: Sv,
  reduceDescriptors: yp,
  freezeMethods: ib,
  toObjectSet: ob,
  toCamelCase: tb,
  noop: sb,
  toFiniteNumber: ab,
  findKey: Kv,
  global: rt,
  isContextDefined: pp,
  isSpecCompliantForm: ub,
  toJSONObject: cb,
  isAsyncFn: fb,
  isThenable: lb,
  setImmediate: gp,
  asap: db,
  isIterable: mp,
  isSafeIterable: hb
}, pb = m.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), yb = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  let r, n, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), r = s.substring(0, i).trim().toLowerCase(), n = s.substring(i + 1).trim();
    const a = m.hasOwnProp(t, r);
    !r || a && m.hasOwnProp(pb, r) || (r === "set-cookie" ? a ? t[r].push(n) : t[r] = [n] : t[r] = a ? t[r] + ", " + n : n);
  }), t;
};
function gb(e) {
  let t = 0, r = e.length;
  for (; t < r; ) {
    const n = e.charCodeAt(t);
    if (n !== 9 && n !== 32)
      break;
    t += 1;
  }
  for (; r > t; ) {
    const n = e.charCodeAt(r - 1);
    if (n !== 9 && n !== 32)
      break;
    r -= 1;
  }
  return t === 0 && r === e.length ? e : e.slice(t, r);
}
const mb = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), vb = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Za(e, t) {
  return m.isArray(e) ? e.map((r) => Za(r, t)) : gb(String(e).replace(t, ""));
}
const bb = (e) => Za(e, mb), _b = (e) => Za(e, vb);
function vp(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return m.forEach(e.toJSON(), (r, n) => {
    t[n] = _b(r);
  }), t;
}
const md = Symbol("internals");
function Pt(e) {
  return e && String(e).trim().toLowerCase();
}
function Ar(e) {
  return e === !1 || e == null ? e : m.isArray(e) ? e.map(Ar) : bb(String(e));
}
function wb(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Sb = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function Js(e) {
  let t = 0, r = e.length;
  for (; t < r; ) {
    const n = e.charCodeAt(t);
    if (n !== 9 && n !== 32)
      break;
    t += 1;
  }
  for (; r > t; ) {
    const n = e.charCodeAt(r - 1);
    if (n !== 9 && n !== 32)
      break;
    r -= 1;
  }
  return t === 0 && r === e.length ? e : e.slice(t, r);
}
function Ob(e) {
  const t = e.length - 1;
  if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34)
    return e;
  let r = "";
  for (let n = 1; n < t; n++) {
    const i = e.charCodeAt(n);
    if (i === 34 || i === 92 && (n += 1, n >= t))
      return e;
    r += e[n];
  }
  return r;
}
function Ab(e) {
  const t = /* @__PURE__ */ Object.create(null), r = String(e);
  let n = 0, i = !1, o = !1;
  function s(a) {
    const u = Js(r.slice(n, a)), f = u.indexOf("=");
    if (f < 1)
      return;
    const c = Js(u.slice(0, f));
    if (!Sb.test(c))
      return;
    const l = c.toLowerCase();
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    const d = Js(u.slice(f + 1));
    t[l] = Ob(d);
  }
  for (let a = 0; a < r.length; a++) {
    const u = r.charCodeAt(a);
    i ? o ? o = !1 : u === 92 ? o = !0 : u === 34 && (i = !1) : u === 34 ? i = !0 : (u === 44 || u === 59) && (s(a), n = a + 1);
  }
  return s(r.length), t;
}
const Cb = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim()), Eb = "__Proto__", vd = (e) => e === "__proto__" ? Eb : e;
function Qs(e, t, r, n, i) {
  if (m.isFunction(n))
    return n.call(e, t, r);
  if (i && (t = r), !!m.isString(t)) {
    if (m.isString(n))
      return t.indexOf(n) !== -1;
    if (m.isRegExp(n))
      return n.test(t);
  }
}
function Rb(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function qb(e, t) {
  const r = m.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(i, o, s) {
        return this[n].call(this, t, i, o, s);
      },
      configurable: !0
    });
  });
}
let we = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const i = this;
    function o(a, u, f) {
      const c = Pt(u);
      if (!c)
        return;
      const l = m.findKey(i, c);
      (!l || i[l] === void 0 || f === !0 || f === void 0 && i[l] !== !1) && (i[vd(l || u)] = Ar(a));
    }
    const s = (a, u) => m.forEach(a, (f, c) => o(f, c, u));
    if (m.isPlainObject(t) || t instanceof this.constructor)
      s(t, r);
    else if (m.isString(t) && (t = t.trim()) && !Cb(t))
      s(yb(t), r);
    else if (m.isObject(t) && m.isSafeIterable(t)) {
      let a = /* @__PURE__ */ Object.create(null), u, f;
      for (const c of t) {
        if (!m.isArray(c))
          throw new TypeError("Object iterator must return a key-value pair");
        f = c[0], m.hasOwnProp(a, f) ? (u = a[f], a[f] = m.isArray(u) ? [...u, c[1]] : [u, c[1]]) : a[f] = c[1];
      }
      s(a, r);
    } else
      t != null && o(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Pt(t), t) {
      const n = m.findKey(this, t);
      if (n) {
        const i = this[n];
        if (!r)
          return i;
        if (r === !0)
          return wb(i);
        if (m.isFunction(r))
          return r.call(this, i, n);
        if (m.isRegExp(r))
          return r.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Pt(t), t) {
      const n = m.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Qs(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let i = !1;
    function o(s) {
      if (s = Pt(s), s) {
        const a = m.findKey(n, s);
        a && (!r || Qs(n, n[a], a, r)) && (delete n[a], i = !0);
      }
    }
    return m.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, i = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || Qs(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const r = this, n = /* @__PURE__ */ Object.create(null);
    return m.forEach(this, (i, o) => {
      const s = m.findKey(n, o);
      if (s) {
        r[s] = Ar(i), delete r[o];
        return;
      }
      const a = vd(t ? Rb(o) : String(o).trim());
      a !== o && delete r[o], r[a] = Ar(i), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return m.forEach(this, (n, i) => {
      n != null && n !== !1 && (r[i] = t && m.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    const t = this.get("set-cookie");
    return m.isArray(t) ? t : t == null || t === !1 ? [] : [t];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static parseParameters(t) {
    return Ab(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((i) => n.set(i)), n;
  }
  static accessor(t) {
    const n = (this[md] = this[md] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(s) {
      const a = Pt(s);
      n[a] || (qb(i, s), n[a] = !0);
    }
    return m.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
we.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
m.reduceDescriptors(we.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
m.freezeMethods(we);
const Nr = "[REDACTED ****]";
function Pb(e) {
  if (m.hasOwnProp(e, "toJSON"))
    return !0;
  let t = Object.getPrototypeOf(e);
  for (; t && t !== Object.prototype; ) {
    if (m.hasOwnProp(t, "toJSON"))
      return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
function Tb(e, t) {
  const r = new Set(t.map((o) => String(o).toLowerCase())), n = [], i = (o) => {
    if (o === null || typeof o != "object" || m.isBuffer(o)) return o;
    if (n.indexOf(o) !== -1) return;
    o instanceof we && (o = o.toJSON()), n.push(o);
    let s;
    if (m.isArray(o))
      s = [], o.forEach((a, u) => {
        const f = i(a);
        m.isUndefined(f) || (s[u] = f);
      });
    else {
      if (!m.isPlainObject(o) && Pb(o))
        return n.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [a, u] of Object.entries(o)) {
        const f = r.has(a.toLowerCase()) ? Nr : i(u);
        m.isUndefined(f) || (s[a] = f);
      }
    }
    return n.pop(), s;
  };
  return i(e);
}
function bd(e) {
  try {
    return String(e);
  } catch {
    return "";
  }
}
function Fb(e) {
  return e.errors.map((r) => {
    try {
      return r && r.message ? bd(r.message) : bd(r);
    } catch {
      return "";
    }
  }).filter(Boolean).join("; ") || e.name || "AggregateError";
}
const Ib = `
Caused by: `, ga = Symbol("causeStack");
function jb(e, t) {
  const r = m.hasOwnProp(e, ga) && e[ga];
  return r && t.endsWith(r) ? t.length - r.length : -1;
}
function kb(e, t) {
  try {
    const r = t && t.stack;
    if (typeof r != "string" || !r)
      return;
    const n = e.stack;
    if (typeof n != "string" || !n)
      return;
    const i = Ib + r;
    e.stack = n + i, Object.defineProperty(e, ga, { __proto__: null, value: i });
  } catch {
  }
}
let L = class bp extends Error {
  static from(t, r, n, i, o, s) {
    let a = t.message;
    !a && m.isArray(t.errors) && t.errors.length && (a = Fb(t));
    const u = new bp(a, r || t.code, n, i, o);
    return Object.defineProperty(u, "cause", {
      __proto__: null,
      value: t,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), u.name = t.name, kb(u, t), t.status != null && u.status == null && (u.status = t.status), s && Object.assign(u, s), u;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, r, n, i, o) {
    super(t), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), n && (this.config = n), i && (this.request = i), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const t = this.config, r = t && m.hasOwnProp(t, "redact") ? t.redact : void 0, n = m.isArray(r) && r.length > 0 ? Tb(t, r) : m.toJSONObject(t);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: n,
      code: this.code,
      status: this.status
    };
  }
};
L.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
L.ERR_BAD_OPTION = "ERR_BAD_OPTION";
L.ECONNABORTED = "ECONNABORTED";
L.ETIMEDOUT = "ETIMEDOUT";
L.ECONNREFUSED = "ECONNREFUSED";
L.ERR_NETWORK = "ERR_NETWORK";
L.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
L.ERR_DEPRECATED = "ERR_DEPRECATED";
L.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
L.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
L.ERR_CANCELED = "ERR_CANCELED";
L.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
L.ERR_INVALID_URL = "ERR_INVALID_URL";
L.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const Nb = null, _p = 100;
function ma(e) {
  return m.isPlainObject(e) || m.isArray(e);
}
function wp(e) {
  return m.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Xs(e, t, r) {
  return e ? e.concat(t).map(function(i, o) {
    return i = wp(i), !r && o ? "[" + i + "]" : i;
  }).join(r ? "." : "") : t;
}
function Lb(e) {
  return m.isArray(e) && !e.some(ma);
}
const Db = m.toFlatObject(m, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Gr(e, t, r) {
  if (!m.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData();
  const n = (w, E) => {
    const g = m.getSafeProp(r, w);
    return m.isUndefined(g) ? E : g;
  }, i = n("metaTokens", !0), o = n("visitor") || O, s = n("dots", !1), a = n("indexes", !1), u = n("Blob") || typeof Blob < "u" && Blob, f = n("maxDepth", _p), c = u && m.isSpecCompliantForm(t), l = [];
  if (!m.isFunction(o))
    throw new TypeError("visitor must be a function");
  function d(w) {
    if (w === null) return "";
    if (m.isDate(w))
      return w.toISOString();
    if (m.isBoolean(w))
      return w.toString();
    if (!c && m.isBlob(w))
      throw new L("Blob is not supported. Use a Buffer instead.");
    if (m.isArrayBuffer(w) || m.isTypedArray(w)) {
      if (c && typeof u == "function")
        return new u([w]);
      throw new L(
        "Blob is not supported. Use a Buffer instead.",
        L.ERR_NOT_SUPPORT
      );
    }
    return w;
  }
  function h(w) {
    if (w > f)
      throw new L(
        "Object is too deeply nested (" + w + " levels). Max depth: " + f,
        L.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function y(w, E) {
    if (f === 1 / 0)
      return JSON.stringify(w);
    const g = [];
    return JSON.stringify(w, function(p, S) {
      if (!m.isObject(S))
        return S;
      for (; g.length && g[g.length - 1] !== this; )
        g.pop();
      return g.push(S), h(E + g.length - 1), S;
    });
  }
  function O(w, E, g) {
    let v = w;
    if (m.isReactNative(t) && m.isReactNativeBlob(w))
      return t.append(Xs(g, E, s), d(w)), !1;
    if (w && !g && typeof w == "object") {
      if (m.endsWith(E, "{}"))
        E = i ? E : E.slice(0, -2), w = y(w, 1);
      else if (m.isArray(w) && Lb(w) || (m.isFileList(w) || m.endsWith(E, "[]")) && (v = m.toArray(w)))
        return E = wp(E), v.forEach(function(S, _) {
          !(m.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Xs([E], _, s) : a === null ? E : E + "[]",
            d(S)
          );
        }), !1;
    }
    return ma(w) ? !0 : (t.append(Xs(g, E, s), d(w)), !1);
  }
  const b = Object.assign(Db, {
    defaultVisitor: O,
    convertValue: d,
    isVisitable: ma
  });
  function C(w, E, g = 0) {
    if (!m.isUndefined(w)) {
      if (h(g), l.indexOf(w) !== -1)
        throw new Error("Circular reference detected in " + E.join("."));
      l.push(w), m.forEach(w, function(p, S) {
        (!(m.isUndefined(p) || p === null) && o.call(t, p, m.isString(S) ? S.trim() : S, E, b)) === !0 && C(p, E ? E.concat(S) : [S], g + 1);
      }), l.pop();
    }
  }
  if (!m.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), t;
}
function _d(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(n) {
    return t[n];
  });
}
function eu(e, t) {
  this._pairs = [], e && Gr(e, this, t);
}
const Sp = eu.prototype;
Sp.append = function(t, r) {
  this._pairs.push([t, r]);
};
Sp.toString = function(t) {
  const r = t ? (n) => t.call(this, n, _d) : _d;
  return this._pairs.map(function(i) {
    return r(i[0]) + "=" + r(i[1]);
  }, "").join("&");
};
function Mb(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Op(e, t, r) {
  if (!t)
    return e;
  e = e || "";
  const n = m.isFunction(r) ? {
    serialize: r
  } : r, i = m.getSafeProp(n, "encode") || Mb, o = m.getSafeProp(n, "serialize");
  let s;
  if (o ? s = o(t, n) : s = m.isURLSearchParams(t) ? t.toString() : new eu(t, n).toString(i), s) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
const Tt = Symbol("internals");
function Ap(e) {
  return e ? e.length : 0;
}
function wd(e) {
  if (e)
    for (; e.length && e[e.length - 1] === null; )
      e.pop();
}
function Bb(e) {
  return typeof e == "string" && e !== "" && String(Number(e)) === e ? Number(e) : e;
}
function Ft(e, t) {
  const r = e.handlers, n = Ap(r);
  r !== t.handlersRef ? (t.handlersRef = r, t.handlerEntries.clear()) : n !== t.handlersLength && (n ? t.handlerEntries.forEach(function(o, s) {
    r[o.index] !== o.handler && t.handlerEntries.delete(s);
  }) : t.handlerEntries.clear()), t.handlersLength = n;
}
class Sd {
  constructor() {
    this.handlers = [], this[Tt] = {
      handlersRef: this.handlers,
      handlersLength: this.handlers.length,
      handlerEntries: /* @__PURE__ */ new Map(),
      iterationDepth: 0,
      nextId: 0
    };
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    const i = {
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }, o = this[Tt];
    this.handlers == null && (this.handlers = []), Ft(this, o);
    const s = o.nextId++;
    return this.handlers.push(i), o.handlerEntries.set(s, {
      handler: i,
      index: this.handlers.length - 1
    }), o.handlersLength = this.handlers.length, s;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    const r = this[Tt];
    Ft(this, r);
    const n = Bb(t), i = r.handlerEntries.get(n);
    if (i) {
      if (r.handlerEntries.delete(n), this.handlers[i.index] !== i.handler)
        return;
      this.handlers[i.index] = null, r.iterationDepth || (wd(this.handlers), r.handlersLength = this.handlers.length);
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = [], Ft(this, this[Tt]));
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    const r = this[Tt];
    Ft(this, r), r.iterationDepth++;
    try {
      m.forEach(this.handlers, function(i) {
        i !== null && t(i);
      });
    } finally {
      --r.iterationDepth || (Ft(this, r), wd(this.handlers), r.handlersLength = Ap(this.handlers));
    }
  }
}
const tu = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0,
  encodeBasicAuthUsername: !1
}, $b = typeof URLSearchParams < "u" ? URLSearchParams : eu, Ub = typeof FormData < "u" ? FormData : null, xb = typeof Blob < "u" ? Blob : null, Hb = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $b,
    FormData: Ub,
    Blob: xb
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ru = typeof window < "u" && typeof document < "u", va = typeof navigator == "object" && navigator || void 0, Kb = ru && (!va || ["ReactNative", "NativeScript", "NS"].indexOf(va.product) < 0), Wb = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Gb = ru && window.location.href || "http://localhost", Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ru,
  hasStandardBrowserEnv: Kb,
  hasStandardBrowserWebWorkerEnv: Wb,
  navigator: va,
  origin: Gb
}, Symbol.toStringTag, { value: "Module" })), me = {
  ...Vb,
  ...Hb
};
function zb(e, t) {
  return Gr(e, new me.classes.URLSearchParams(), {
    visitor: function(r, n, i, o) {
      return me.isNode && m.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
const Od = _p;
function Cp(e) {
  if (e > Od)
    throw new L(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + Od,
      L.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function Jb(e) {
  const t = [], r = /[^.[\]]+|\[([^.[\]]*)]/g;
  let n;
  for (; (n = r.exec(e)) !== null; )
    Cp(t.length), t.push(n[0] === "[]" ? "" : n[1] || n[0]);
  return t;
}
function Ep(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const i = r.length;
  let o;
  for (n = 0; n < i; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function Rp(e) {
  if (!m.isArray(e)) return e;
  const t = Object.keys(e);
  return t.length !== e.length || t.some((r, n) => r !== String(n)) ? Ep(e) : e;
}
function Qb(e) {
  const t = [e];
  for (; t.length; ) {
    const r = t.pop();
    Object.keys(r).forEach((n) => {
      const i = r[n] = Rp(r[n]);
      (m.isArray(i) || m.isPlainObject(i)) && t.push(i);
    });
  }
  return e;
}
function qp(e) {
  function t(r, n, i, o) {
    Cp(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), u = o >= r.length;
    return s = !s && m.isArray(i) ? i.length : s, u ? (m.hasOwnProp(i, s) ? (i[s] = Rp(i[s]), i[s] = m.isArray(i[s]) ? i[s].concat(n) : [i[s], n]) : i[s] = n, !a) : ((!m.hasOwnProp(i, s) || !m.isObject(i[s])) && (i[s] = []), t(r, n, i[s], o) && m.isArray(i[s]) && (i[s] = Ep(i[s])), !a);
  }
  if (m.isFormData(e) && m.isFunction(e.entries)) {
    const r = {};
    return m.forEachEntry(e, (n, i) => {
      t(Jb(n), i, r, 0);
    }), Qb(r);
  }
  return null;
}
const Pp = Object.freeze([
  "get",
  "delete",
  "head",
  "options",
  "post",
  "put",
  "patch",
  "purge",
  "link",
  "unlink",
  "query"
]), dt = (e, t) => e != null && m.hasOwnProp(e, t) ? e[t] : void 0;
function Xb(e, t, r) {
  if (m.isString(e))
    try {
      return (t || JSON.parse)(e), m.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const rr = {
  transitional: tu,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, r) {
      const n = r.getContentType() || "", i = n.indexOf("application/json") > -1, o = m.isObject(t);
      if (o && m.isHTMLForm(t) && (t = new FormData(t)), m.isFormData(t))
        return i ? JSON.stringify(qp(t)) : t;
      if (m.isArrayBuffer(t) || m.isBuffer(t) || m.isStream(t) || m.isFile(t) || m.isBlob(t) || m.isReadableStream(t))
        return t;
      if (m.isArrayBufferView(t))
        return t.buffer;
      if (m.isURLSearchParams(t))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let a;
      if (o) {
        const u = dt(this, "formSerializer");
        if (n.indexOf("application/x-www-form-urlencoded") > -1)
          return zb(t, u).toString();
        if ((a = m.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
          const f = dt(this, "env"), c = f && f.FormData;
          return Gr(
            a ? { "files[]": t } : t,
            c && new c(),
            u
          );
        }
      }
      return o || i ? (r.setContentType("application/json", !1), Xb(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const r = dt(this, "transitional") || rr.transitional, n = r && r.forcedJSONParsing, i = dt(this, "responseType"), o = i === "json";
      if (m.isResponse(t) || m.isReadableStream(t))
        return t;
      if (t && m.isString(t) && (n && !i || o)) {
        const a = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(t, dt(this, "parseReviver"));
        } catch (u) {
          if (a)
            throw u.name === "SyntaxError" ? L.from(u, L.ERR_BAD_RESPONSE, this, null, dt(this, "response")) : u;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: me.classes.FormData,
    Blob: me.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
m.forEach(Pp, (e) => {
  rr.headers[e] = {};
});
function Ys(e, t) {
  const r = this || rr, n = t || r, i = we.from(n.headers);
  let o = n.data;
  return m.forEach(e, function(a) {
    o = a.call(r, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function Tp(e) {
  return !!(e && e.__CANCEL__);
}
let nr = class extends L {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, r, n) {
    super(t ?? "canceled", L.ERR_CANCELED, r, n), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Fp(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new L(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? L.ERR_BAD_REQUEST : L.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
const Yb = /[\t\n\r]/g;
function Ip(e) {
  if (typeof e != "string")
    return e;
  let t = 0;
  for (; t < e.length && e.charCodeAt(t) <= 32; )
    t++;
  return e.slice(t).replace(Yb, "");
}
function Zs(e) {
  const t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return t && t[1].toLowerCase() || "";
}
const Ad = (e) => {
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, jp = me.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, i, o, s) {
      if (typeof document > "u") return;
      const a = [`${e}=${encodeURIComponent(t)}`];
      m.isNumber(r) && a.push(`expires=${new Date(r).toUTCString()}`), m.isString(n) && a.push(`path=${n}`), m.isString(i) && a.push(`domain=${i}`), o === !0 && a.push("secure"), m.isString(s) && a.push(`SameSite=${s}`), document.cookie = a.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie;
      if (!t) return null;
      const r = t.split(";");
      for (let n = 0; n < r.length; n++) {
        const i = r[n].replace(/^\s+/, ""), o = i.indexOf("=");
        if (o !== -1 && i.slice(0, o) === e)
          return Ad(i.slice(o + 1));
      }
      return null;
    },
    async readAsync(e) {
      try {
        const t = typeof window < "u" && window.cookieStore;
        if (t && m.isFunction(t.get)) {
          const r = await t.get(e);
          return r ? Ad(r.value) : null;
        }
      } catch {
      }
      return this.read(e);
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    async readAsync() {
      return null;
    },
    remove() {
    }
  }
);
function Zb(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let i = 0, o = 0, s;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const f = Date.now(), c = n[o];
    s || (s = f), r[i] = u, n[i] = f;
    let l = o, d = 0;
    for (; l !== i; )
      d += r[l++], l = l % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), f - s < t)
      return;
    const h = c && f - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function e_(e, t) {
  let r = 0, n = 1e3 / t, i, o;
  const s = (c, l = Date.now()) => {
    r = l, i = null, o && (clearTimeout(o), o = null), e(...c);
  };
  return [(...c) => {
    const l = Date.now(), d = l - r;
    d >= n ? s(c, l) : (i = c, o || (o = setTimeout(() => {
      o = null, s(i);
    }, n - d)));
  }, () => i && s(i), (...c) => s(c)];
}
const Lr = (e, t, r = 3) => {
  let n = 0;
  const i = Zb(50, 250);
  return e_((o) => {
    if (!o || !m.isNumber(o.loaded))
      return;
    const s = o.loaded, a = o.lengthComputable ? o.total : void 0, u = Math.max(0, a != null ? Math.min(s, a) : s), f = Math.max(0, u - n), c = i(f);
    n = Math.max(n, u);
    const l = {
      loaded: u,
      total: a,
      progress: a ? u / a : void 0,
      bytes: f,
      rate: c || void 0,
      estimated: c && a ? (a - u) / c : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(l);
  }, r);
}, Cd = (e, t) => {
  const r = e != null;
  return [
    (n) => t[0]({
      lengthComputable: r,
      total: e,
      loaded: n
    }),
    t[1]
  ];
}, Ed = (e, t = m.asap) => (...r) => t(() => e(...r)), t_ = me.hasStandardBrowserEnv ? /* @__PURE__ */ ((e) => (t) => (t = new URL(t, document.baseURI || me.origin), e.protocol === t.protocol && e.host === t.host && e.port === t.port))(new URL(me.origin)) : () => !0;
function r_(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function n_(e, t) {
  if (!t)
    return e;
  let r = e.length;
  for (; r > 0 && e.charCodeAt(r - 1) === 47; )
    r--;
  return e.slice(0, r) + "/" + t.replace(/^\/+/, "");
}
const i_ = /^https?:(?!\/\/)/i;
function o_(e) {
  return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (t, r, n = "") => `${r}${n}${Nr}`);
}
function s_(e) {
  const t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${Nr}@`), r = t.indexOf("#"), i = (r === -1 ? t : t.slice(0, r)).replace(
    /([?&][^=&#]*=)[^&#]*/g,
    `$1${Nr}`
  );
  return r === -1 ? i : `${i}#${o_(t.slice(r + 1))}`;
}
function Rd(e, t) {
  if (typeof e == "string") {
    const r = Ip(e);
    if (i_.test(r))
      throw new L(
        `Invalid URL ${JSON.stringify(s_(r))}: missing "//" after protocol`,
        L.ERR_INVALID_URL,
        t
      );
  }
}
function kp(e, t, r, n) {
  Rd(t, n);
  let i = !r_(t);
  return e && (i || r === !1) ? (Rd(e, n), n_(e, t)) : t;
}
function a_(e) {
  const t = [{ value: e }], r = /* @__PURE__ */ new WeakSet(), n = /* @__PURE__ */ new WeakSet();
  for (; t.length; ) {
    const { value: i, done: o } = t.pop();
    if (!m.isPlainObject(i) && !m.isArray(i)) continue;
    if (o) {
      r.delete(i);
      continue;
    }
    if (r.has(i))
      throw new L(
        "Circular reference detected in params",
        L.ERR_BAD_OPTION_VALUE
      );
    if (n.has(i)) continue;
    n.add(i), r.add(i), t.push({ value: i, done: !0 });
    const s = Object.keys(i);
    Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor && Object.getOwnPropertySymbols(i).forEach((a) => {
      const u = Object.getOwnPropertyDescriptor(i, a);
      u && u.enumerable && s.push(a);
    }), s.forEach((a) => {
      if (a === "__proto__" || a === "constructor" || a === "prototype") {
        const u = Object.getOwnPropertyDescriptor(i, a);
        u && m.hasOwnProp(u, "value") && t.push({ value: u.value });
      } else
        t.push({ value: i[a] });
    });
  }
}
const qd = (e) => e instanceof we ? { ...e } : e, ba = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(
  Object.getOwnPropertySymbols(e).filter((t) => {
    const r = Object.getOwnPropertyDescriptor(e, t);
    return r && r.enumerable;
  })
) : Object.keys(e);
function u_(e, t) {
  const r = [], n = /* @__PURE__ */ new WeakMap(), i = {};
  function o(a, u) {
    if (!m.isPlainObject(u))
      return m.isArray(u) ? u.slice() : u;
    const f = m.isPlainObject(a) ? a : i;
    let c = n.get(u);
    if (c || (c = /* @__PURE__ */ new WeakMap(), n.set(u, c)), c.has(f)) return c.get(f);
    const l = {};
    return c.set(f, l), r.push({ base: f, source: u, result: l }), l;
  }
  const s = m.isUndefined(t) ? o(void 0, e) : o(e, t);
  for (; r.length; ) {
    const { base: a, source: u, result: f } = r.pop(), c = new Set(ba(a)), l = new Set(ba(u));
    (/* @__PURE__ */ new Set([...c, ...l])).forEach((h) => {
      if (h === "__proto__" || h === "constructor" || h === "prototype") return;
      const y = l.has(h), O = y ? u[h] : void 0, b = (!y || m.isPlainObject(O)) && c.has(h) ? a[h] : void 0;
      f[h] = y ? o(b, O) : o(void 0, b);
    });
  }
  return a_(s), s;
}
function Ve(e, t, r, n) {
  return m.isPlainObject(e) && m.isPlainObject(t) ? m.merge.call({ caseless: n }, e, t) : m.isPlainObject(t) ? m.merge({}, t) : m.isArray(t) ? t.slice() : t;
}
function Np(e, t, r, n) {
  if (m.isUndefined(t)) {
    if (!m.isUndefined(e))
      return Ve(void 0, e, r, n);
  } else return Ve(e, t, r, n);
}
function ea(e, t) {
  if (!m.isUndefined(t))
    return Ve(void 0, t);
}
function de(e, t) {
  if (m.isUndefined(t)) {
    if (!m.isUndefined(e))
      return Ve(void 0, e);
  } else return Ve(void 0, t);
}
function c_(e, t, r) {
  const n = m.hasOwnProp(t, "transitional") ? t.transitional : void 0;
  if (!m.isUndefined(n))
    if (m.isPlainObject(n)) {
      if (m.hasOwnProp(n, r))
        return n[r];
    } else
      return;
  const i = m.hasOwnProp(e, "transitional") ? e.transitional : void 0;
  if (m.isPlainObject(i) && m.hasOwnProp(i, r))
    return i[r];
}
function _a(e, t, r, n, i) {
  if (m.hasOwnProp(i, r))
    return Ve(e, t);
  if (m.hasOwnProp(n, r))
    return Ve(void 0, e);
}
function f_(e, t, r) {
  return Np(qd(e), qd(t), r, !0);
}
const l_ = Object.freeze({
  __proto__: null,
  value: Object.prototype.hasOwnProperty,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), Pd = {
  url: ea,
  method: ea,
  data: ea,
  baseURL: de,
  transformRequest: de,
  transformResponse: de,
  params: u_,
  paramsSerializer: de,
  timeout: de,
  timeoutErrorMessage: de,
  withCredentials: de,
  withXSRFToken: de,
  adapter: de,
  responseType: de,
  xsrfCookieName: de,
  xsrfHeaderName: de,
  onUploadProgress: de,
  onDownloadProgress: de,
  decompress: de,
  maxContentLength: de,
  maxBodyLength: de,
  beforeRedirect: de,
  transport: de,
  httpAgent: de,
  httpsAgent: de,
  cancelToken: de,
  socketPath: de,
  allowedSocketPaths: de,
  responseEncoding: de,
  validateStatus: _a,
  headers: f_
};
function st(e, t) {
  e = e || {}, t = t || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", l_);
  const n = ba({ ...e, ...t });
  for (let i = 0, o = n.length; i < o; i++) {
    const s = n[i];
    if (s === "__proto__" || s === "constructor" || s === "prototype") continue;
    const a = m.hasOwnProp(Pd, s) ? Pd[s] : Np, u = m.hasOwnProp(e, s) ? e[s] : void 0, f = m.hasOwnProp(t, s) ? t[s] : void 0, c = a === _a ? a(u, f, s, e, t) : a(u, f, s);
    m.isUndefined(c) && a !== _a || (r[s] = c);
  }
  return m.hasOwnProp(t, "validateStatus") && m.isUndefined(t.validateStatus) && c_(e, t, "validateStatusUndefinedResolves") === !1 && (m.hasOwnProp(e, "validateStatus") ? r.validateStatus = Ve(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const d_ = ["content-type", "content-length"];
function h_(e, t, r) {
  if (r !== "content-only") {
    e.set(t);
    return;
  }
  Object.entries(t || {}).forEach(([n, i]) => {
    d_.includes(n.toLowerCase()) && e.set(n, i);
  });
}
const Td = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (t, r) => String.fromCharCode(parseInt(r, 16))
), p_ = (e) => jp.read(e);
function Lp(e, t = p_) {
  const r = st({}, e), n = (h) => m.hasOwnProp(r, h) ? r[h] : void 0, i = n("data");
  let o = n("withXSRFToken");
  const s = n("xsrfHeaderName"), a = n("xsrfCookieName");
  let u = n("headers");
  const f = n("auth"), c = n("baseURL"), l = n("allowAbsoluteUrls"), d = n("url");
  if (r.headers = u = we.from(u), r.url = Op(
    kp(c, d, l, r),
    n("params"),
    n("paramsSerializer")
  ), f) {
    const h = m.getSafeProp(f, "username") || "", y = m.getSafeProp(f, "password") || "", O = n("transitional"), b = O && m.hasOwnProp(O, "encodeBasicAuthUsername") && O.encodeBasicAuthUsername === !0;
    try {
      u.set(
        "Authorization",
        // Preserve legacy username bytes unless the caller opts in to UTF-8.
        "Basic " + btoa(
          (b ? Td(h) : h) + ":" + (y ? Td(y) : "")
        )
      );
    } catch (C) {
      throw L.from(C, L.ERR_BAD_OPTION_VALUE, e);
    }
  }
  if (m.isFormData(i)) {
    const h = m.getSafeProp(i, "getHeaders");
    me.hasStandardBrowserEnv || me.hasStandardBrowserWebWorkerEnv || m.isReactNative(i) ? u.setContentType(void 0) : m.isFunction(h) && h_(u, h.call(i), n("formDataHeaderPolicy"));
  }
  if (me.hasStandardBrowserEnv && (m.isFunction(o) && (o = o(r)), o === !0 || o == null && t_(r.url))) {
    const y = s && a && t(a);
    y && u.set(s, y);
  }
  return r;
}
const y_ = typeof XMLHttpRequest < "u", g_ = y_ && function(e) {
  return new Promise(function(r, n) {
    let i;
    try {
      const _ = me.hasStandardBrowserEnv && typeof window < "u" && window.cookieStore;
      i = _ && m.isFunction(_.get);
    } catch {
    }
    let o;
    const s = Lp(
      e,
      i ? (_) => (o = _, null) : void 0
    );
    let a = s.data;
    const u = we.from(s.headers).normalize();
    let { responseType: f, onUploadProgress: c, onDownloadProgress: l } = s, d, h, y, O, b, C, w;
    function E() {
      clearTimeout(h);
      try {
        b && b();
      } catch (_) {
        setTimeout(() => {
          throw _;
        });
      }
      try {
        C && C();
      } catch (_) {
        setTimeout(() => {
          throw _;
        });
      }
      g && (O && g.removeEventListener("progress", O), g.upload && (y && g.upload.removeEventListener("progress", y), b && g.upload.removeEventListener("loadend", b))), s.cancelToken && s.cancelToken.unsubscribe(d), s.signal && s.signal.removeEventListener("abort", d);
    }
    let g = new XMLHttpRequest();
    g.open(s.method.toUpperCase(), s.url, !0), g.timeout = s.timeout;
    function v(_) {
      if (!g)
        return;
      if (g.status === 0 && (Zs(Ip(s.url)) || Zs(me.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
        n(new L("Request aborted", L.ECONNABORTED, e, g)), E(), g = null;
        return;
      }
      try {
        _ ? w && w(_) : C && C();
      } catch (D) {
        setTimeout(() => {
          throw D;
        });
      }
      if (!g)
        return;
      const A = we.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), T = {
        data: !f || f === "text" || f === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: A,
        config: e,
        request: g
      };
      Fp(
        function(N) {
          r(N), E();
        },
        function(N) {
          n(N), E();
        },
        T
      ), g = null;
    }
    if ("onloadend" in g ? g.onloadend = v : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.startsWith("file:")) || setTimeout(v);
    }, g.onabort = function() {
      g && (n(new L("Request aborted", L.ECONNABORTED, e, g)), E(), g = null);
    }, g.onerror = function(A) {
      const F = A && A.message ? A.message : "Network Error", T = new L(F, L.ERR_NETWORK, e, g);
      T.event = A || null, n(T), E(), g = null;
    }, g.ontimeout = function() {
      if (!g) return;
      let A = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const F = s.transitional || tu;
      s.timeoutErrorMessage && (A = s.timeoutErrorMessage), n(
        new L(
          A,
          F.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED,
          e,
          g
        )
      ), E(), g = null;
    }, a === void 0 && u.setContentType(null), m.isUndefined(s.withCredentials) || (g.withCredentials = !!s.withCredentials), f && f !== "json" && (g.responseType = s.responseType), l && ([O, C, w] = Lr(
      l,
      !0
    ), g.addEventListener("progress", O)), c && g.upload && ([y, b] = Lr(c), g.upload.addEventListener("progress", y), g.upload.addEventListener("loadend", b)), s.cancelToken || s.signal) {
      if (d = (_) => {
        if (!g)
          return;
        n(!_ || _.type ? new nr(null, e, g) : _);
        const A = g;
        E(), g = null, A.abort();
      }, s.cancelToken && s.cancelToken.subscribe(d), !g) return;
      s.signal && (s.signal.aborted ? d() : s.signal.addEventListener("abort", d));
    }
    if (!g) return;
    const p = Zs(s.url);
    if (p && !me.protocols.includes(p)) {
      n(
        new L(
          "Unsupported protocol " + p + ":",
          L.ERR_BAD_REQUEST,
          e
        )
      ), E();
      return;
    }
    const S = () => {
      g && ("setRequestHeader" in g && m.forEach(
        vp(u),
        function(A, F) {
          g.setRequestHeader(F, A);
        }
      ), g.send(a || null));
    };
    if (o) {
      const _ = typeof performance < "u" && m.isFunction(performance.now) ? () => performance.now() : Date.now, A = g.timeout > 0 ? _() + Number(g.timeout) : void 0, F = () => {
        if (!g) return;
        const T = g;
        T.ontimeout(), T.abort();
      };
      if (A !== void 0) {
        const T = () => {
          const D = A - _();
          D > 0 ? h = setTimeout(T, Math.min(D, 2147483647)) : F();
        };
        T();
      }
      jp.readAsync(o).then((T) => {
        if (g) {
          if (A !== void 0 && _() >= A) {
            F();
            return;
          }
          if (T) {
            const D = m.hasOwnProp(s, "xsrfHeaderName") && s.xsrfHeaderName;
            u.set(D, T);
          }
          S();
        }
      }).catch((T) => {
        g && (n(L.from(T, null, e, g)), E(), g = null);
      });
    } else
      S();
  });
}, m_ = (e, t) => {
  if (e = e ? e.filter(Boolean) : [], !t && !e.length)
    return;
  const r = new AbortController();
  let n = !1;
  const i = function(u) {
    if (!n) {
      n = !0, s();
      const f = u instanceof Error ? u : this.reason;
      r.abort(
        f instanceof L ? f : new nr(f instanceof Error ? f.message : f)
      );
    }
  };
  let o = t && setTimeout(() => {
    o = null, i(new L(`timeout of ${t}ms exceeded`, L.ETIMEDOUT));
  }, t);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((u) => {
      const f = m.getSafeProp(u, "unsubscribe");
      m.isFunction(f) ? f.call(u, i) : u.removeEventListener("abort", i);
    }), e = null);
  };
  e.forEach((u) => {
    if (!n) {
      if (u.aborted) {
        i.call(u);
        return;
      }
      u.addEventListener("abort", i, { once: !0 });
    }
  });
  const { signal: a } = r;
  return a.unsubscribe = () => m.asap(s), a;
}, v_ = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, i;
  for (; n < r; )
    i = n + t, yield e.slice(n, i), n = i;
}, b_ = async function* (e, t) {
  for await (const r of __(e))
    yield* v_(r, t);
}, __ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, Fd = (e, t, r, n) => {
  const i = b_(e, t);
  let o = 0, s, a = (u) => {
    s || (s = !0, n && n(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: f, value: c } = await i.next();
          if (f) {
            a(), u.close();
            return;
          }
          let l = c.byteLength;
          if (r) {
            let d = o += l;
            r(d);
          }
          u.enqueue(new Uint8Array(c));
        } catch (f) {
          throw a(f), f;
        }
      },
      cancel(u) {
        return a(u), i.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Ge = `\r
`, Id = (e) => String(e).replace(/\r\n|\r|\n/g, Ge), jd = (e) => String(e).replace(
  /[\r\n"]/g,
  (t) => t === "\r" ? "%0D" : t === `
` ? "%0A" : "%22"
), It = (e, t) => {
  let r = 0;
  for (let n = 0; n < e.length; n++) {
    const i = e.charCodeAt(n);
    t && (i === 13 || i === 10) ? (i === 13 && e.charCodeAt(n + 1) === 10 && n++, r += 2) : i < 128 ? r++ : i < 2048 ? r += 2 : i >= 55296 && i <= 56319 && e.charCodeAt(n + 1) >= 56320 && e.charCodeAt(n + 1) <= 57343 ? (r += 4, n++) : r += 3;
  }
  return r;
};
class Cr extends TypeError {
  constructor(t, r) {
    super(t), this.name = "FormDataError", this.reason = r;
  }
}
function w_(e, t, r, n, i) {
  if (!m.isFunction(t))
    throw new Cr("Blob is not supported", "blob");
  if (!m.isString(i) || !/^[A-Za-z0-9'()+_,./:=? -]{1,70}$/.test(i) || / $/.test(i))
    throw new Cr("Invalid multipart boundary", "boundary");
  const o = "--" + i + "--" + Ge;
  let s = o.length;
  const a = [], u = (c) => {
    if (s + c > r) throw n();
  };
  u(0);
  for (const [c, l] of e) {
    const d = m.isString(l), h = d ? It(l, !0) : l.size;
    if (!Number.isFinite(h) || h < 0)
      throw new Cr("Unsupported FormData part size", "part");
    u(
      h + It(c, !0) + (!d && l.name ? It(l.name, !1) : 0) + (!d && l.type ? It(l.type, !1) : 0)
    );
    let y = "--" + i + Ge + 'Content-Disposition: form-data; name="' + jd(Id(c)) + '"';
    d || (y += '; filename="' + jd(m.isString(l.name) ? l.name : "blob") + '"' + Ge + "Content-Type: " + String(l.type || "application/octet-stream").replace(/[\r\n]/g, "")), y += Ge + Ge;
    const O = It(y, !1) + h + Ge.length;
    u(O), s += O, a.push({ header: y, value: l, isString: d });
  }
  const f = [];
  for (const c of a)
    f.push(c.header, c.isString ? Id(c.value) : c.value, Ge);
  return f.push(o), new t(f, { type: "multipart/form-data; boundary=" + i });
}
function S_(e, t, r, n, i) {
  if (!m.isFunction(t))
    throw new L("Blob is not supported", L.ERR_NOT_SUPPORT);
  if (i === void 0)
    if (m.isFunction(me.generateString))
      i = "axios-" + me.generateString(36, "0123456789abcdef");
    else {
      const o = m.global.crypto;
      if (!o || !m.isFunction(o.getRandomValues))
        throw new L("Random byte generation is not supported", L.ERR_NOT_SUPPORT);
      const s = new Uint8Array(18);
      o.getRandomValues(s), i = "axios-" + Array.from(s, (a) => ("0" + a.toString(16)).slice(-2)).join("");
    }
  try {
    return w_(e, t, r, n, i);
  } catch (o) {
    if (o instanceof Cr) {
      const s = o.reason === "boundary" ? L.ERR_BAD_OPTION_VALUE : L.ERR_BAD_REQUEST;
      throw new L(o.message, s);
    }
    throw o;
  }
}
const kd = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Dp = (e, t, r) => t + 2 < r && kd(e.charCodeAt(t + 1)) && kd(e.charCodeAt(t + 2)), Nd = (e) => e <= 57 ? e - 48 : (e & 223) - 55, O_ = (e) => e >= 65 && e <= 90 || // A-Z
e >= 97 && e <= 122 || // a-z
e >= 48 && e <= 57 || // 0-9
e === 43 || // +
e === 47 || // /
e === 45 || // - (base64url)
e === 95, A_ = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, C_ = (e) => {
  const t = Math.floor(e / 4), r = e % 4;
  return t * 3 + (r === 2 ? 1 : r === 3 ? 2 : 0);
}, E_ = (e) => {
  const t = e.length;
  let r = 0;
  return t > 0 && e.charCodeAt(t - 1) === 61 && (r++, t > 1 && e.charCodeAt(t - 2) === 61 && r++), Math.floor((t - r) * 3 / 4);
}, R_ = (e) => {
  const t = e.length;
  let r = 0, n = 0, i = !1;
  for (let o = 0; o < t; o++) {
    let s = e.charCodeAt(o);
    if (s === 37 && Dp(e, o, t) && (s = Nd(e.charCodeAt(o + 1)) * 16 + Nd(e.charCodeAt(o + 2)), o += 2), !A_(s)) {
      if (s === 61) {
        n++;
        continue;
      }
      if (!O_(s) || n > 0) {
        i = !0;
        continue;
      }
      r++;
    }
  }
  return i || n > 2 || n > 0 && (r + n) % 4 !== 0 || r % 4 === 1 ? E_(e) : C_(r);
}, q_ = (e, t, r) => {
  if (!e || typeof e != "string" || !/^data:/i.test(e)) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const i = e.slice(5, n), o = e.slice(n + 1);
  if (r.test(i))
    return t(o);
  let a = 0;
  for (let u = 0, f = o.length; u < f; u++) {
    const c = o.charCodeAt(u);
    if (c === 37 && Dp(o, u, f))
      a += 1, u += 2;
    else if (c < 128)
      a += 1;
    else if (c < 2048)
      a += 2;
    else if (c >= 55296 && c <= 56319 && u + 1 < f) {
      const l = o.charCodeAt(u + 1);
      l >= 56320 && l <= 57343 ? (a += 4, u++) : a += 3;
    } else
      a += 3;
  }
  return a;
};
function P_(e) {
  const t = typeof e == "string" ? e.indexOf("#") : -1;
  return q_(
    t === -1 ? e : e.slice(0, t),
    R_,
    /; *base64[\t\n\f\r ]*$/i
  );
}
const nu = "1.21.0", Ld = 64 * 1024, Dd = {
  cache: "default",
  redirect: "follow",
  referrer: "about:client",
  referrerPolicy: "",
  mode: "cors",
  integrity: "",
  keepalive: !1,
  priority: "auto",
  window: null
}, { isFunction: hr } = m, T_ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (t, r) => String.fromCharCode(parseInt(r, 16))
), Md = (e) => {
  if (!m.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, pr = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, F_ = (e) => {
  const t = e.indexOf("://");
  let r = e;
  return t !== -1 && (r = r.slice(t + 3)), r.includes("@") || r.includes(":");
}, I_ = (e) => {
  const t = m.global !== void 0 && m.global !== null ? m.global : globalThis, { ReadableStream: r, TextEncoder: n } = t;
  e = m.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: t.Request,
      Response: t.Response,
      Blob: t.Blob
    },
    e
  );
  const i = m.hasOwnProp(e, "fetch") ? e.fetch : void 0, { Request: o, Response: s, Blob: a } = e, u = i ? hr(i) : typeof fetch == "function", f = hr(o), c = hr(s);
  if (!u)
    return !1;
  const l = u && hr(r), d = u && (typeof n == "function" ? /* @__PURE__ */ ((E) => (g) => E.encode(g))(new n()) : async (E) => new Uint8Array(await new o(E).arrayBuffer())), h = f && l && pr(() => {
    let E = !1;
    const g = new o(me.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return E = !0, "half";
      }
    }), v = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), E && !v;
  }), y = c && l && pr(() => m.isReadableStream(new s("").body)), O = Object.assign(/* @__PURE__ */ Object.create(null), Dd);
  f && !pr(() => new o(me.origin, O)) && (delete O.cache, pr(() => new o(me.origin, O)) || (O.cache = Dd.cache));
  const b = {
    stream: y && ((E) => E.body)
  };
  u && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((E) => {
    !b[E] && (b[E] = (g, v) => {
      let p = g && g[E];
      if (p)
        return p.call(g);
      throw new L(
        `Response type '${E}' is not supported`,
        L.ERR_NOT_SUPPORT,
        v
      );
    });
  });
  const C = async (E) => {
    if (E == null)
      return 0;
    if (m.isBlob(E))
      return E.size;
    if (m.isArrayBufferView(E) || m.isArrayBuffer(E))
      return E.byteLength;
    if (m.isURLSearchParams(E) && (E = E + ""), m.isString(E))
      return (await d(E)).byteLength;
  }, w = async (E, g) => {
    const v = m.toFiniteNumber(E.getContentLength());
    return v ?? C(g);
  };
  return async (E) => {
    let {
      url: g,
      method: v,
      data: p,
      signal: S,
      cancelToken: _,
      timeout: A,
      onDownloadProgress: F,
      onUploadProgress: T,
      responseType: D,
      headers: N,
      withCredentials: $ = "same-origin",
      fetchOptions: G,
      maxContentLength: X,
      maxBodyLength: Z,
      maxRedirects: ce
    } = Lp(E);
    const ne = m.isNumber(X) && X > -1, j = m.isNumber(Z) && Z > -1, R = (M) => m.hasOwnProp(E, M) ? E[M] : void 0;
    let k = i || fetch;
    D = D ? (D + "").toLowerCase() : "text";
    let I = m_(
      [S, _ && _.toAbortSignal()],
      A
    ), B = null;
    const Y = I && I.unsubscribe && (() => {
      I.unsubscribe();
    });
    let V, te = null, re = null;
    const Q = () => new L(
      "Request body larger than maxBodyLength limit",
      L.ERR_BAD_REQUEST,
      E,
      B
    );
    try {
      let M;
      const W = R("auth");
      if (W) {
        const z = m.getSafeProp(W, "username") || "", pe = m.getSafeProp(W, "password") || "";
        M = {
          username: z,
          password: pe
        };
      }
      let K;
      if (F_(g)) {
        if (K = new URL(g, me.origin), !M && (K.username || K.password)) {
          const z = Md(K.username), pe = Md(K.password);
          M = {
            username: z,
            password: pe
          };
        }
        (K.username || K.password) && (K.username = "", K.password = "", g = K.href);
      }
      if (M && (N.delete("authorization"), N.set(
        "Authorization",
        "Basic " + btoa(T_((M.username || "") + ":" + (M.password || "")))
      )), ne && K && K.protocol === "data:" && P_(K.href) > X)
        throw new L(
          "maxContentLength size of " + X + " exceeded",
          L.ERR_BAD_RESPONSE,
          E,
          B
        );
      const U = m.isSpecCompliantForm(p) && we.from(R("headers")).getContentType();
      let J;
      if (m.isString(U) && /^multipart\/form-data(?:\s*;|$)/i.test(U.trim())) {
        const z = we.parseParameters(U);
        m.hasOwnProp(z, "boundary") && (J = z.boundary);
      }
      if (m.isSpecCompliantForm(p) && v !== "get" && v !== "head" && (j || T && h || J !== void 0) && (p = S_(
        p,
        a,
        j ? Z : 1 / 0,
        Q,
        J
      ), N.setContentType(J === void 0 ? p.type : U), V = p.size), j && v !== "get" && v !== "head") {
        const z = await C(p);
        if (typeof z == "number" && isFinite(z) && (V = z, z > Z))
          throw Q();
      }
      const x = j && (m.isReadableStream(p) || m.isStream(p)), se = (z, pe, Ne) => Fd(
        z,
        Ld,
        (Ce) => {
          if (j && Ce > Z)
            throw te = Q();
          pe && pe(Ce);
        },
        Ne
      );
      if (h && v !== "get" && v !== "head" && (T || x)) {
        if (V = V ?? await w(N, p), V !== 0 || x) {
          let z = new o(g, {
            method: "POST",
            body: p,
            duplex: "half"
          }), pe;
          if (m.isFormData(p) && (pe = z.headers.get("content-type")) && N.setContentType(pe), z.body) {
            const [Ne, Ce] = T && Cd(
              V,
              Lr(Ed(T))
            ) || [];
            p = se(z.body, Ne, Ce);
          }
        }
      } else if (x && !f && l && v !== "get" && v !== "head")
        p = se(p);
      else if (x && f && !h && v !== "get" && v !== "head")
        throw new L(
          "Stream request bodies are not supported by the current fetch implementation",
          L.ERR_NOT_SUPPORT,
          E,
          B
        );
      m.isString($) || ($ = $ ? "include" : "omit");
      const H = f && "credentials" in o.prototype;
      if (m.isFormData(p)) {
        const z = N.getContentType();
        z && /^multipart\/form-data/i.test(z) && !/boundary=/i.test(z) && N.delete("content-type");
      }
      N.set("User-Agent", "axios/" + nu, !1);
      const ie = G == null ? G : Object.assign(/* @__PURE__ */ Object.create(null), G);
      ie && (delete ie.body, delete ie.headers, delete ie.method, delete ie.signal, delete ie.duplex, delete ie.credentials);
      const he = Object.assign(/* @__PURE__ */ Object.create(null), ie, {
        signal: I,
        method: v.toUpperCase(),
        headers: vp(N.normalize()),
        body: p,
        duplex: "half",
        credentials: H ? $ : void 0
      });
      f && (m.forEach(O, (z, pe) => {
        he[pe] === void 0 && (he[pe] = z);
      }), he.signal === void 0 && (he.signal = null), he.body === void 0 && (he.body = null)), ce === 0 && (he.redirect = "manual", ie && (ie.redirect = "manual")), B = f && new o(g, he);
      let ge = await (f ? k(B, ie) : k(g, he));
      const be = we.from(ge.headers);
      if (ne) {
        const z = m.toFiniteNumber(be.getContentLength());
        if (z != null && z > X)
          throw new L(
            "maxContentLength size of " + X + " exceeded",
            L.ERR_BAD_RESPONSE,
            E,
            B
          );
      }
      const _e = y && (D === "stream" || D === "response");
      if (y && ge.body && (F || ne || _e && Y)) {
        const z = {};
        ["status", "statusText", "headers"].forEach((qe) => {
          z[qe] = ge[qe];
        });
        const pe = m.toFiniteNumber(be.getContentLength()), [Ne, Ce] = F && Cd(
          pe,
          Lr(Ed(F), !0)
        ) || [];
        let Fe = 0;
        const Le = (qe) => {
          if (ne && (Fe = qe, Fe > X))
            throw re = new L(
              "maxContentLength size of " + X + " exceeded",
              L.ERR_BAD_RESPONSE,
              E,
              B
            );
          Ne && Ne(qe);
        };
        ge = new s(
          Fd(ge.body, Ld, Le, () => {
            Ce && Ce(), Y && Y();
          }),
          z
        );
      }
      D = D || "text";
      let ae = await b[m.findKey(b, D) || "text"](
        ge,
        E
      );
      if (ne && !y && !_e) {
        let z;
        if (ae != null && (typeof ae.byteLength == "number" ? z = ae.byteLength : typeof ae.size == "number" ? z = ae.size : typeof ae == "string" && (z = typeof n == "function" ? new n().encode(ae).byteLength : ae.length)), typeof z == "number" && z > X)
          throw new L(
            "maxContentLength size of " + X + " exceeded",
            L.ERR_BAD_RESPONSE,
            E,
            B
          );
      }
      return !_e && Y && Y(), await new Promise((z, pe) => {
        Fp(z, pe, {
          data: ae,
          headers: we.from(ge.headers),
          status: ge.status,
          statusText: ge.statusText,
          config: E,
          request: B
        });
      });
    } catch (M) {
      if (Y && Y(), I && I.aborted && I.reason instanceof L) {
        const W = I.reason;
        throw W.config = E, B && (W.request = B), M !== W && Object.defineProperty(W, "cause", {
          __proto__: null,
          value: M,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), W;
      }
      if (te)
        throw B && !te.request && (te.request = B), te;
      if (re)
        throw re;
      if (M instanceof L)
        throw B && !M.request && (M.request = B), M;
      if (M && M.name === "TypeError" && /Load failed|fetch/i.test(M.message)) {
        const W = new L(
          "Network Error",
          L.ERR_NETWORK,
          E,
          B,
          M && M.response
        );
        throw Object.defineProperty(W, "cause", {
          __proto__: null,
          value: M.cause || M,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), W;
      }
      throw L.from(M, M && M.code, E, B, M && M.response);
    }
  };
}, j_ = /* @__PURE__ */ new Map(), Mp = (e) => {
  const t = /* @__PURE__ */ Object.create(null), r = e && m.hasOwnProp(e, "env") && e.env;
  ["fetch", "Request", "Response", "Blob"].forEach((h) => {
    r && m.hasOwnProp(r, h) && (t[h] = r[h]);
  });
  const { fetch: n, Request: i, Response: o, Blob: s } = t, a = [i, o, n, s];
  let u = a.length, f = u, c, l, d = j_;
  for (; f--; )
    c = a[f], l = d.get(c), l === void 0 && d.set(c, l = f ? /* @__PURE__ */ new Map() : I_(t)), d = l;
  return l;
};
Mp();
const iu = {
  http: Nb,
  xhr: g_,
  fetch: {
    get: Mp
  }
};
m.forEach(iu, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: t });
  }
});
const Bd = (e) => `- ${e}`, k_ = (e) => m.isFunction(e) || e === null || e === !1;
function N_(e, t) {
  e = m.isArray(e) ? e : [e];
  const { length: r } = e;
  let n, i;
  const o = {};
  for (let s = 0; s < r; s++) {
    n = e[s];
    let a;
    if (i = n, !k_(n) && (i = iu[(a = String(n)).toLowerCase()], i === void 0))
      throw new L(`Unknown adapter '${a}'`);
    if (i && (m.isFunction(i) || (i = i.get(t))))
      break;
    o[a || "#" + s] = i;
  }
  if (!i) {
    const s = Object.entries(o).map(
      ([u, f]) => `adapter ${u} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let a = r ? s.length > 1 ? `since :
` + s.map(Bd).join(`
`) : " " + Bd(s[0]) : "as no adapter specified";
    throw new L(
      "There is no suitable adapter to dispatch the request " + a,
      L.ERR_NOT_SUPPORT
    );
  }
  return i;
}
const Bp = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: N_,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: iu
};
function ta(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new nr(null, e);
}
function $d(e) {
  return Math.max(0, Date.now() - e);
}
function ra(e) {
  const t = m.toSafeFlatObject(e);
  ta(t), t.headers = we.from(m.getSafeProp(t, "headers")), t.data = Ys.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1);
  const r = Bp.getAdapter(t.adapter || rr.adapter, t), n = Date.now();
  return r(t).then(
    function(o) {
      ta(t), o.duration = $d(n), t.response = o;
      try {
        o.data = Ys.call(t, t.transformResponse, o);
      } finally {
        delete t.response;
      }
      return o.headers = we.from(o.headers), o;
    },
    function(o) {
      if (!Tp(o) && (ta(t), o && o.response)) {
        o.response.duration = $d(n), t.response = o.response;
        try {
          o.response.data = Ys.call(
            t,
            t.transformResponse,
            o.response
          );
        } finally {
          delete t.response;
        }
        o.response.headers = we.from(o.response.headers);
      }
      return Promise.reject(o);
    }
  );
}
const Vr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Vr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ud = {};
Vr.transitional = function(t, r, n) {
  function i(o, s) {
    return "[Axios v" + nu + "] Transitional option '" + o + "'" + s + (n ? ". " + n : "");
  }
  return (o, s, a) => {
    if (t === !1)
      throw new L(
        i(s, " has been removed" + (r ? " in " + r : "")),
        L.ERR_DEPRECATED
      );
    return r && !Ud[s] && (Ud[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, s, a) : !0;
  };
};
Vr.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function L_(e, t, r) {
  if (typeof e != "object" || e === null)
    throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let i = n.length;
  for (; i-- > 0; ) {
    const o = n[i], s = Object.prototype.hasOwnProperty.call(t, o) ? t[o] : void 0;
    if (s) {
      const a = e[o], u = a === void 0 || s(a, o, e);
      if (u !== !0)
        throw new L(
          "option " + o + " must be " + u,
          L.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new L("Unknown option " + o, L.ERR_BAD_OPTION);
  }
}
const Er = {
  assertOptions: L_,
  validators: Vr
}, Se = Er.validators, na = (e) => {
  if (e == null || m.isPlainObject(e) || e instanceof we)
    return !0;
  try {
    return m.isObject(e) && m.getSafeProp(e, Symbol.toStringTag) === "AxiosHeaders" && [
      "toJSON",
      "set",
      "get",
      "has",
      "delete",
      "clear",
      "normalize",
      "concat",
      "toString",
      Symbol.iterator
    ].every((t) => m.isFunction(m.getSafeProp(e, t)));
  } catch {
    return !1;
  }
};
let nt = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Sd(),
      response: new Sd()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error)
        try {
          let i = {};
          Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
          const o = i.stack;
          let s = "";
          if (typeof o == "string") {
            const a = o.indexOf(`
`);
            s = a === -1 ? "" : o.slice(a + 1);
          }
          if (!n.stack)
            n.stack = s;
          else if (s) {
            const a = s.indexOf(`
`), u = a === -1 ? -1 : s.indexOf(`
`, a + 1), f = u === -1 ? s : s.slice(u + 1), c = String(n.stack), l = jb(n, c), d = l === -1 ? c : c.slice(0, l), h = l === -1 ? "" : c.slice(l);
            d.endsWith(f) || (n.stack = d + `
` + s + h);
          }
        } catch {
        }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = st(this.defaults, r);
    const { transitional: n, paramsSerializer: i, headers: o } = r;
    n !== void 0 && Er.assertOptions(
      n,
      {
        silentJSONParsing: Se.transitional(Se.boolean),
        forcedJSONParsing: Se.transitional(Se.boolean),
        clarifyTimeoutError: Se.transitional(Se.boolean),
        legacyInterceptorReqResOrdering: Se.transitional(Se.boolean),
        advertiseZstdAcceptEncoding: Se.transitional(Se.boolean),
        validateStatusUndefinedResolves: Se.transitional(Se.boolean),
        encodeBasicAuthUsername: Se.transitional(Se.boolean)
      },
      !1
    ), i != null && (m.isFunction(i) ? r.paramsSerializer = {
      serialize: i
    } : Er.assertOptions(
      i,
      {
        encode: Se.function,
        serialize: Se.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (m.hasOwnProp(this.defaults, "allowAbsoluteUrls") && this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Er.assertOptions(
      r,
      {
        baseUrl: Se.spelling("baseURL"),
        withXsrfToken: Se.spelling("withXSRFToken")
      },
      !0
    ), r.method = (m.getSafeProp(r, "method") || m.getSafeProp(this.defaults, "method") || "get").toLowerCase();
    const s = m.getSafeProp(o, "common"), a = m.getSafeProp(o, r.method), u = o && m.merge(
      na(s) ? s : void 0,
      na(a) ? a : void 0
    );
    o && m.forEach(Pp.concat("common"), (b) => {
      na(m.getSafeProp(o, b)) && delete o[b];
    }), r.headers = we.concat(u, o);
    const f = [];
    let c = !0;
    this.interceptors.request.forEach(function(C) {
      if (typeof C.runWhen == "function" && C.runWhen(r) === !1)
        return;
      c = c && C.synchronous;
      const w = r.transitional || tu;
      w && w.legacyInterceptorReqResOrdering ? f.unshift(C.fulfilled, C.rejected) : f.push(C.fulfilled, C.rejected);
    });
    const l = [];
    this.interceptors.response.forEach(function(C) {
      l.push(C.fulfilled, C.rejected);
    });
    let d, h = 0, y;
    if (!c) {
      const b = [ra.bind(this), void 0];
      for (b.unshift(...f), b.push(...l), y = b.length, d = Promise.resolve(r); h < y; )
        d = d.then(b[h++], b[h++]);
      return d;
    }
    y = f.length;
    let O = r;
    for (; h < y; ) {
      const b = f[h++], C = f[h++];
      try {
        O = b ? b(O) : O;
      } catch (w) {
        if (!C) {
          d = Promise.reject(w);
          break;
        }
        try {
          const E = C.call(this, w);
          m.isThenable(E) && (d = Promise.resolve(E).then(
            () => ra.call(this, O)
          ));
        } catch (E) {
          d = Promise.reject(E);
        }
        break;
      }
    }
    if (!d)
      try {
        d = ra.call(this, O);
      } catch (b) {
        d = Promise.reject(b);
      }
    for (h = 0, y = l.length; h < y; )
      d = d.then(l[h++], l[h++]);
    return d;
  }
  getUri(t) {
    t = st(this.defaults, t);
    const r = kp(t.baseURL, t.url, t.allowAbsoluteUrls, t);
    return Op(r, t.params, t.paramsSerializer);
  }
};
m.forEach(["delete", "get", "head", "options"], function(t) {
  nt.prototype[t] = async function(r, n) {
    return this.request(
      st(n || {}, {
        method: t,
        url: r,
        data: n && m.hasOwnProp(n, "data") ? n.data : void 0
      })
    );
  };
});
m.forEach(["post", "put", "patch", "query"], function(t) {
  function r(n) {
    return async function(o, s, a) {
      return this.request(
        st(a || {}, {
          method: t,
          headers: n ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  nt.prototype[t] = r(), t !== "query" && (nt.prototype[t + "Form"] = r(!0));
});
let D_ = class $p {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((i) => {
      if (!n._listeners) return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](i);
      n._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const s = new Promise((a) => {
        n.subscribe(a), o = a;
      }).then(i);
      return s.cancel = function() {
        n.unsubscribe(o);
      }, s;
    }, t(function(o, s, a) {
      n.reason || (n.reason = new nr(o, s, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new $p(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
};
function M_(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function B_(e) {
  return m.isObject(e) && e.isAxiosError === !0;
}
const Rr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  /**
   * @deprecated Use `ContentTooLarge` instead.
   */
  PayloadTooLarge: 413,
  ContentTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  /**
   * @deprecated Use `UnprocessableContent` instead.
   */
  UnprocessableEntity: 422,
  UnprocessableContent: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerReturnsAnUnknownError: 520,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Rr).forEach(([e, t]) => {
  Rr[t] === void 0 && (Rr[t] = e);
});
function Up(e) {
  const t = new nt(e), r = fp(nt.prototype.request, t);
  return m.extend(r, nt.prototype, t, { allOwnKeys: !0 }), m.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(i) {
    return Up(st(e, i));
  }, r;
}
const ye = Up(rr);
ye.Axios = nt;
ye.CanceledError = nr;
ye.CancelToken = D_;
ye.isCancel = Tp;
ye.VERSION = nu;
ye.toFormData = Gr;
ye.AxiosError = L;
ye.Cancel = ye.CanceledError;
ye.all = function(t) {
  return Promise.all(t);
};
ye.spread = M_;
ye.isAxiosError = B_;
ye.mergeConfig = st;
ye.AxiosHeaders = we;
ye.formToJSON = (e) => qp(m.isHTMLForm(e) ? new FormData(e) : e);
ye.getAdapter = Bp.getAdapter;
ye.HttpStatusCode = Rr;
ye.default = ye;
const {
  Axios: k0,
  AxiosError: N0,
  CanceledError: L0,
  isCancel: D0,
  CancelToken: M0,
  VERSION: B0,
  all: $0,
  Cancel: U0,
  isAxiosError: x0,
  spread: H0,
  toFormData: K0,
  AxiosHeaders: W0,
  HttpStatusCode: G0,
  formToJSON: V0,
  getAdapter: z0,
  mergeConfig: J0,
  create: Q0
} = ye;
var ia, xd;
function $_() {
  return xd || (xd = 1, ia = (e) => {
    if (Object.prototype.toString.call(e) !== "[object Object]")
      return !1;
    const t = Object.getPrototypeOf(e);
    return t === null || t === Object.prototype;
  }), ia;
}
var yr, Hd;
function U_() {
  if (Hd) return yr;
  Hd = 1;
  const e = $_(), { hasOwnProperty: t } = Object.prototype, { propertyIsEnumerable: r } = Object, n = (h, y, O) => Object.defineProperty(h, y, {
    value: O,
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), i = yr, o = {
    concatArrays: !1,
    ignoreUndefined: !1
  }, s = (h) => {
    const y = [];
    for (const O in h)
      t.call(h, O) && y.push(O);
    if (Object.getOwnPropertySymbols) {
      const O = Object.getOwnPropertySymbols(h);
      for (const b of O)
        r.call(h, b) && y.push(b);
    }
    return y;
  };
  function a(h) {
    return Array.isArray(h) ? u(h) : e(h) ? f(h) : h;
  }
  function u(h) {
    const y = h.slice(0, 0);
    return s(h).forEach((O) => {
      n(y, O, a(h[O]));
    }), y;
  }
  function f(h) {
    const y = Object.getPrototypeOf(h) === null ? /* @__PURE__ */ Object.create(null) : {};
    return s(h).forEach((O) => {
      n(y, O, a(h[O]));
    }), y;
  }
  const c = (h, y, O, b) => (O.forEach((C) => {
    typeof y[C] > "u" && b.ignoreUndefined || (C in h && h[C] !== Object.getPrototypeOf(h) ? n(h, C, d(h[C], y[C], b)) : n(h, C, a(y[C])));
  }), h), l = (h, y, O) => {
    let b = h.slice(0, 0), C = 0;
    return [h, y].forEach((w) => {
      const E = [];
      for (let g = 0; g < w.length; g++)
        t.call(w, g) && (E.push(String(g)), w === h ? n(b, C++, w[g]) : n(b, C++, a(w[g])));
      b = c(b, w, s(w).filter((g) => !E.includes(g)), O);
    }), b;
  };
  function d(h, y, O) {
    return O.concatArrays && Array.isArray(h) && Array.isArray(y) ? l(h, y, O) : !e(y) || !e(h) ? a(y) : c(h, y, s(y), O);
  }
  return yr = function(...h) {
    const y = d(a(o), this !== i && this || {}, o);
    let O = { _: {} };
    for (const b of h)
      if (b !== void 0) {
        if (!e(b))
          throw new TypeError("`" + b + "` is not an Option Object");
        O = d(O, { _: b }, y);
      }
    return O._;
  }, yr;
}
var x_ = U_();
const H_ = /* @__PURE__ */ at(x_), K_ = H_.bind({
  concatArrays: !0,
  ignoreUndefined: !0
});
function W_(e, t) {
  const r = window.localStorage.getItem(e);
  if (r) {
    const n = JSON.parse(r), i = JSON.parse(t), o = JSON.stringify(K_(n, i));
    window.localStorage.setItem(e, o);
  } else
    window.localStorage.setItem(e, t);
}
function ht(e, t) {
  return new Promise((r, n) => {
    try {
      const i = e();
      t == null || t(null, i), r(i);
    } catch (i) {
      t == null || t(i), n(i);
    }
  });
}
function gr(e, t, r) {
  return Promise.all(e).then((n) => {
    const i = (r == null ? void 0 : r(n)) ?? null;
    return t == null || t(null, i), Promise.resolve(i);
  }, (n) => (t == null || t(n), Promise.reject(n)));
}
const bt = {
  /**
   * Fetches `key` value.
   */
  getItem: (e, t) => ht(() => window.localStorage.getItem(e), t),
  /**
   * Sets `value` for `key`.
   */
  setItem: (e, t, r) => ht(() => window.localStorage.setItem(e, t), r),
  /**
   * Removes a `key`
   */
  removeItem: (e, t) => ht(() => window.localStorage.removeItem(e), t),
  /**
   * Merges existing value with input value, assuming they are stringified JSON.
   */
  mergeItem: (e, t, r) => ht(() => W_(e, t), r),
  /**
   * Erases *all* AsyncStorage for the domain.
   */
  clear: (e) => ht(() => window.localStorage.clear(), e),
  /**
   * Gets *all* keys known to the app, for all callers, libraries, etc.
   */
  getAllKeys: (e) => ht(() => {
    const t = window.localStorage.length, r = [];
    for (let n = 0; n < t; n += 1) {
      const i = window.localStorage.key(n) || "";
      r.push(i);
    }
    return r;
  }, e),
  /**
   * (stub) Flushes any pending requests using a single batch call to get the data.
   */
  flushGetRequests: () => {
  },
  /**
   * multiGet resolves to an array of key-value pair arrays that matches the
   * input format of multiSet.
   *
   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
   */
  multiGet: (e, t) => {
    const r = e.map((i) => bt.getItem(i));
    return gr(r, t, (i) => i.map((o, s) => [e[s], o]));
  },
  /**
   * Takes an array of key-value array pairs.
   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
   */
  multiSet: (e, t) => {
    const r = e.map((n) => bt.setItem(n[0], n[1]));
    return gr(r, t);
  },
  /**
   * Delete all the keys in the `keys` array.
   */
  multiRemove: (e, t) => {
    const r = e.map((n) => bt.removeItem(n));
    return gr(r, t);
  },
  /**
   * Takes an array of key-value array pairs and merges them with existing
   * values, assuming they are stringified JSON.
   *
   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
   */
  multiMerge: (e, t) => {
    const r = e.map((n) => bt.mergeItem(n[0], n[1]));
    return gr(r, t);
  }
};
var Gt = { exports: {} }, Qe = {}, pt = {}, Kd;
function G_() {
  if (Kd) return pt;
  Kd = 1, Object.defineProperty(pt, "__esModule", { value: !0 }), pt.noopDebug = t, pt.setDebug = n, pt.createDebug = i;
  const e = {};
  function t() {
    return function() {
    };
  }
  let r = t;
  function n(o) {
    r = o, Object.keys(e).forEach((s) => {
      e[s] = o(s);
    });
  }
  function i(o) {
    return e[o] || (e[o] = r(o)), (...s) => e[o](...s);
  }
  return pt;
}
var Wd;
function Et() {
  return Wd || (Wd = 1, (function(e) {
    var t = Qe && Qe.__createBinding || (Object.create ? (function(s, a, u, f) {
      f === void 0 && (f = u);
      var c = Object.getOwnPropertyDescriptor(a, u);
      (!c || ("get" in c ? !a.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(s, f, c);
    }) : (function(s, a, u, f) {
      f === void 0 && (f = u), s[f] = a[u];
    })), r = Qe && Qe.__exportStar || function(s, a) {
      for (var u in s) u !== "default" && !Object.prototype.hasOwnProperty.call(a, u) && t(a, s, u);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e._ = void 0, e.stripSlashes = n, e.isPromise = i, e.createSymbol = o;
    function n(s) {
      return s.replace(/^(\/+)|(\/+)$/g, "");
    }
    e._ = {
      each(s, a) {
        s && typeof s.forEach == "function" ? s.forEach(a) : e._.isObject(s) && Object.keys(s).forEach((u) => a(s[u], u));
      },
      some(s, a) {
        return Object.keys(s).map((u) => [s[u], u]).some(([u, f]) => a(u, f));
      },
      every(s, a) {
        return Object.keys(s).map((u) => [s[u], u]).every(([u, f]) => a(u, f));
      },
      keys(s) {
        return Object.keys(s);
      },
      values(s) {
        return e._.keys(s).map((a) => s[a]);
      },
      isMatch(s, a) {
        return e._.keys(a).every((u) => s[u] === a[u]);
      },
      isEmpty(s) {
        return e._.keys(s).length === 0;
      },
      isObject(s) {
        return typeof s == "object" && !Array.isArray(s) && s !== null;
      },
      isObjectOrArray(s) {
        return typeof s == "object" && s !== null;
      },
      extend(s, ...a) {
        return Object.assign(s, ...a);
      },
      omit(s, ...a) {
        const u = e._.extend({}, s);
        return a.forEach((f) => delete u[f]), u;
      },
      pick(s, ...a) {
        return a.reduce((u, f) => (s[f] !== void 0 && (u[f] = s[f]), u), {});
      },
      // Recursively merge the source object into the target object
      merge(s, a) {
        return e._.isObject(s) && e._.isObject(a) && Object.keys(a).forEach((u) => {
          u === "__proto__" || u === "constructor" || u === "prototype" || (e._.isObject(a[u]) ? (s[u] || Object.assign(s, { [u]: {} }), e._.merge(s[u], a[u])) : Object.assign(s, { [u]: a[u] }));
        }), s;
      }
    };
    function i(s) {
      return e._.isObject(s) && typeof s.then == "function";
    }
    function o(s) {
      return typeof Symbol < "u" ? Symbol.for(s) : s;
    }
    r(G_(), e);
  })(Qe)), Qe;
}
var mr = {}, Gd;
function xp() {
  return Gd || (Gd = 1, Object.defineProperty(mr, "__esModule", { value: !0 }), mr.default = "5.0.50"), mr;
}
var Xe = {}, vr = { exports: {} }, Vd;
function ou() {
  if (Vd) return vr.exports;
  Vd = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(v, p, S) {
    return Function.prototype.apply.call(v, p, S);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(v) {
    return Object.getOwnPropertyNames(v).concat(Object.getOwnPropertySymbols(v));
  } : r = function(v) {
    return Object.getOwnPropertyNames(v);
  };
  function n(g) {
    console && console.warn && console.warn(g);
  }
  var i = Number.isNaN || function(v) {
    return v !== v;
  };
  function o() {
    o.init.call(this);
  }
  vr.exports = o, vr.exports.once = C, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function a(g) {
    if (typeof g != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof g);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(g) {
      if (typeof g != "number" || g < 0 || i(g))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + g + ".");
      s = g;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(v) {
    if (typeof v != "number" || v < 0 || i(v))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + v + ".");
    return this._maxListeners = v, this;
  };
  function u(g) {
    return g._maxListeners === void 0 ? o.defaultMaxListeners : g._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(v) {
    for (var p = [], S = 1; S < arguments.length; S++) p.push(arguments[S]);
    var _ = v === "error", A = this._events;
    if (A !== void 0)
      _ = _ && A.error === void 0;
    else if (!_)
      return !1;
    if (_) {
      var F;
      if (p.length > 0 && (F = p[0]), F instanceof Error)
        throw F;
      var T = new Error("Unhandled error." + (F ? " (" + F.message + ")" : ""));
      throw T.context = F, T;
    }
    var D = A[v];
    if (D === void 0)
      return !1;
    if (typeof D == "function")
      t(D, this, p);
    else
      for (var N = D.length, $ = y(D, N), S = 0; S < N; ++S)
        t($[S], this, p);
    return !0;
  };
  function f(g, v, p, S) {
    var _, A, F;
    if (a(p), A = g._events, A === void 0 ? (A = g._events = /* @__PURE__ */ Object.create(null), g._eventsCount = 0) : (A.newListener !== void 0 && (g.emit(
      "newListener",
      v,
      p.listener ? p.listener : p
    ), A = g._events), F = A[v]), F === void 0)
      F = A[v] = p, ++g._eventsCount;
    else if (typeof F == "function" ? F = A[v] = S ? [p, F] : [F, p] : S ? F.unshift(p) : F.push(p), _ = u(g), _ > 0 && F.length > _ && !F.warned) {
      F.warned = !0;
      var T = new Error("Possible EventEmitter memory leak detected. " + F.length + " " + String(v) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      T.name = "MaxListenersExceededWarning", T.emitter = g, T.type = v, T.count = F.length, n(T);
    }
    return g;
  }
  o.prototype.addListener = function(v, p) {
    return f(this, v, p, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(v, p) {
    return f(this, v, p, !0);
  };
  function c() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function l(g, v, p) {
    var S = { fired: !1, wrapFn: void 0, target: g, type: v, listener: p }, _ = c.bind(S);
    return _.listener = p, S.wrapFn = _, _;
  }
  o.prototype.once = function(v, p) {
    return a(p), this.on(v, l(this, v, p)), this;
  }, o.prototype.prependOnceListener = function(v, p) {
    return a(p), this.prependListener(v, l(this, v, p)), this;
  }, o.prototype.removeListener = function(v, p) {
    var S, _, A, F, T;
    if (a(p), _ = this._events, _ === void 0)
      return this;
    if (S = _[v], S === void 0)
      return this;
    if (S === p || S.listener === p)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete _[v], _.removeListener && this.emit("removeListener", v, S.listener || p));
    else if (typeof S != "function") {
      for (A = -1, F = S.length - 1; F >= 0; F--)
        if (S[F] === p || S[F].listener === p) {
          T = S[F].listener, A = F;
          break;
        }
      if (A < 0)
        return this;
      A === 0 ? S.shift() : O(S, A), S.length === 1 && (_[v] = S[0]), _.removeListener !== void 0 && this.emit("removeListener", v, T || p);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(v) {
    var p, S, _;
    if (S = this._events, S === void 0)
      return this;
    if (S.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : S[v] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete S[v]), this;
    if (arguments.length === 0) {
      var A = Object.keys(S), F;
      for (_ = 0; _ < A.length; ++_)
        F = A[_], F !== "removeListener" && this.removeAllListeners(F);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (p = S[v], typeof p == "function")
      this.removeListener(v, p);
    else if (p !== void 0)
      for (_ = p.length - 1; _ >= 0; _--)
        this.removeListener(v, p[_]);
    return this;
  };
  function d(g, v, p) {
    var S = g._events;
    if (S === void 0)
      return [];
    var _ = S[v];
    return _ === void 0 ? [] : typeof _ == "function" ? p ? [_.listener || _] : [_] : p ? b(_) : y(_, _.length);
  }
  o.prototype.listeners = function(v) {
    return d(this, v, !0);
  }, o.prototype.rawListeners = function(v) {
    return d(this, v, !1);
  }, o.listenerCount = function(g, v) {
    return typeof g.listenerCount == "function" ? g.listenerCount(v) : h.call(g, v);
  }, o.prototype.listenerCount = h;
  function h(g) {
    var v = this._events;
    if (v !== void 0) {
      var p = v[g];
      if (typeof p == "function")
        return 1;
      if (p !== void 0)
        return p.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function y(g, v) {
    for (var p = new Array(v), S = 0; S < v; ++S)
      p[S] = g[S];
    return p;
  }
  function O(g, v) {
    for (; v + 1 < g.length; v++)
      g[v] = g[v + 1];
    g.pop();
  }
  function b(g) {
    for (var v = new Array(g.length), p = 0; p < v.length; ++p)
      v[p] = g[p].listener || g[p];
    return v;
  }
  function C(g, v) {
    return new Promise(function(p, S) {
      function _(F) {
        g.removeListener(v, A), S(F);
      }
      function A() {
        typeof g.removeListener == "function" && g.removeListener("error", _), p([].slice.call(arguments));
      }
      E(g, v, A, { once: !0 }), v !== "error" && w(g, _, { once: !0 });
    });
  }
  function w(g, v, p) {
    typeof g.on == "function" && E(g, "error", v, p);
  }
  function E(g, v, p, S) {
    if (typeof g.on == "function")
      S.once ? g.once(v, p) : g.on(v, p);
    else if (typeof g.addEventListener == "function")
      g.addEventListener(v, function _(A) {
        S.once && g.removeEventListener(v, _), p(A);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof g);
  }
  return vr.exports;
}
var Ye = {}, oa = {}, Ze = {}, zd;
function Hp() {
  if (zd) return Ze;
  zd = 1, Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.copyFnProperties = Ze.copyProperties = void 0;
  function e(r, ...n) {
    for (const i of n) {
      const o = Object.keys(i).concat(Object.getOwnPropertySymbols(i));
      for (const s of o) {
        const a = Object.getOwnPropertyDescriptor(i, s);
        a && !Object.prototype.hasOwnProperty.call(r, s) && Object.defineProperty(r, s, a);
      }
    }
    return r;
  }
  Ze.copyProperties = e;
  function t(r, n) {
    const i = ["name", "length"];
    try {
      for (const o of i) {
        const s = n[o];
        Object.defineProperty(r, o, { value: s });
      }
    } catch {
    }
    return r;
  }
  return Ze.copyFnProperties = t, Ze;
}
var Jd;
function wa() {
  return Jd || (Jd = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.setMiddleware = e.getMiddleware = e.setManager = e.getManager = e.convertOptions = e.HookManager = e.BaseHookContext = e.HOOKS = void 0;
    const t = Hp();
    e.HOOKS = Symbol.for("@feathersjs/hooks");
    class r {
      constructor(c = {}) {
        Object.defineProperty(this, "self", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0
        }), Object.assign(this, c);
      }
      toJSON() {
        const c = Object.keys(this);
        let l = Object.getPrototypeOf(this);
        for (; l; )
          c.push(...Object.keys(l)), l = Object.getPrototypeOf(l);
        return c.reduce((d, h) => (d[h] = this[h], d), {});
      }
    }
    e.BaseHookContext = r;
    class n {
      constructor() {
        Object.defineProperty(this, "_parent", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(this, "_params", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(this, "_middleware", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(this, "_props", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null
        }), Object.defineProperty(this, "_defaults", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0
        });
      }
      parent(c) {
        return this._parent = c, this;
      }
      middleware(c) {
        return this._middleware = c != null && c.length ? c : null, this;
      }
      getMiddleware() {
        var l;
        const c = (l = this._parent) == null ? void 0 : l.getMiddleware();
        return c && this._middleware ? c.concat(this._middleware) : c || this._middleware;
      }
      collectMiddleware(c, l) {
        const d = a(c), h = this.getMiddleware();
        return d && h ? d.concat(h) : d || h || [];
      }
      props(c) {
        return this._props || (this._props = {}), (0, t.copyProperties)(this._props, c), this;
      }
      getProps() {
        var l;
        const c = (l = this._parent) == null ? void 0 : l.getProps();
        return c && this._props ? (0, t.copyProperties)({}, c, this._props) : c || this._props || null;
      }
      params(...c) {
        return this._params = c, this;
      }
      getParams() {
        var l;
        const c = (l = this._parent) == null ? void 0 : l.getParams();
        return c && this._params ? c.concat(this._params) : c || this._params;
      }
      defaults(c) {
        return this._defaults = c, this;
      }
      getDefaults(c, l, d) {
        var O;
        const h = typeof this._defaults == "function" ? this._defaults(c, l, d) : null, y = (O = this._parent) == null ? void 0 : O.getDefaults(c, l, d);
        return y && h ? Object.assign({}, y, h) : y || h;
      }
      getContextClass(c = r) {
        const l = class extends c {
          constructor(O) {
            super(O);
          }
        }, d = this.getParams(), h = this.getProps();
        return d && d.forEach((y, O) => {
          if ((h == null ? void 0 : h[y]) !== void 0)
            throw new Error(`Hooks can not have a property and param named '${y}'. Use .defaults instead.`);
          Object.defineProperty(l.prototype, y, {
            enumerable: !0,
            get() {
              return this == null ? void 0 : this.arguments[O];
            },
            set(b) {
              this.arguments[O] = b;
            }
          });
        }), h && (0, t.copyProperties)(l.prototype, h), l;
      }
      initializeContext(c, l, d) {
        const h = this._parent ? this._parent.initializeContext(c, l, d) : d, y = this.getDefaults(c, l, h);
        if (c && (h.self = c), h.arguments = l, y)
          for (const O of Object.keys(y))
            h[O] === void 0 && (h[O] = y[O]);
        return h;
      }
    }
    e.HookManager = n;
    function i(f = null) {
      return f ? Array.isArray(f) ? new n().middleware(f) : f : new n();
    }
    e.convertOptions = i;
    function o(f) {
      return f && f[e.HOOKS] || null;
    }
    e.getManager = o;
    function s(f, c) {
      const l = o(f);
      return f[e.HOOKS] = c.parent(l), f;
    }
    e.setManager = s;
    function a(f) {
      const c = o(f);
      return c ? c.getMiddleware() : null;
    }
    e.getMiddleware = a;
    function u(f, c) {
      const l = new n().middleware(c);
      return s(f, l);
    }
    e.setMiddleware = u;
  })(oa)), oa;
}
var Re = {}, jt = {}, Qd;
function su() {
  if (Qd) return jt;
  Qd = 1, Object.defineProperty(jt, "__esModule", { value: !0 }), jt.compose = void 0;
  function e(t) {
    if (!Array.isArray(t))
      throw new TypeError("Middleware stack must be an array!");
    for (const r of t)
      if (typeof r != "function")
        throw new TypeError("Middleware must be composed of functions!");
    return function(r, n) {
      let i = -1;
      return o.call(this, 0);
      function o(s) {
        if (s <= i)
          return Promise.reject(new Error("next() called multiple times"));
        i = s;
        let a = t[s];
        if (s === t.length && (a = n), !a)
          return Promise.resolve();
        try {
          return Promise.resolve(a.call(this, r, o.bind(this, s + 1)));
        } catch (u) {
          return Promise.reject(u);
        }
      }
    };
  }
  return jt.compose = e, jt;
}
var Xd;
function Yd() {
  if (Xd) return Re;
  Xd = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.legacyDecorator = Re.hookDecorator = Re.objectHooks = Re.functionHooks = Re.getOriginal = void 0;
  const e = su(), t = wa(), r = Hp();
  function n(u) {
    return typeof u.original == "function" ? n(u.original) : u;
  }
  Re.getOriginal = n;
  function i(u, f) {
    if (typeof u != "function")
      throw new Error("Can not apply hooks to non-function");
    const c = (0, t.convertOptions)(f), l = function(...d) {
      const { Context: h, original: y } = l, O = d[d.length - 1] instanceof h, b = O ? d.pop() : new h(), C = c.initializeContext(this, d, b), w = [
        // Return `ctx.result` or the context
        (g, v) => v().then(() => O ? g : g.result)
      ], E = c.collectMiddleware(this, d);
      return E && Array.prototype.push.apply(w, E), w.push((g, v) => Object.prototype.hasOwnProperty.call(C, "result") ? v() : Promise.resolve(y.apply(this, g.arguments)).then((p) => (g.result = p, v()))), (0, e.compose)(w).call(this, C);
    };
    return (0, r.copyFnProperties)(l, u), (0, r.copyProperties)(l, u), (0, t.setManager)(l, c), Object.assign(l, {
      original: n(u),
      Context: c.getContextClass(),
      createContext: (d = {}) => new l.Context(d)
    });
  }
  Re.functionHooks = i;
  function o(u, f) {
    if (Array.isArray(f))
      return (0, t.setMiddleware)(u, f);
    for (const c of Object.keys(f)) {
      const l = typeof u[c] == "function" ? u : u.prototype, d = l && l[c];
      if (typeof d != "function")
        throw new Error(`Can not apply hooks. '${c}' is not a function`);
      const h = (0, t.convertOptions)(f[c]);
      l[c] = i(d, h.props({ method: c }));
    }
    return u;
  }
  Re.objectHooks = o;
  const s = (u) => (f, c) => {
    const l = (0, t.convertOptions)(u);
    if (c.kind === "class")
      return (0, t.setManager)(f.prototype, l), f;
    if (c.kind === "method") {
      const d = String(c.name);
      return i(f, l.props({ method: d }));
    }
    throw new Error("Can not apply hooks.");
  };
  Re.hookDecorator = s;
  const a = (u) => (c, l, d) => {
    const h = (0, t.convertOptions)(u);
    if (!d)
      return (0, t.setManager)(c.prototype, h), c;
    const y = d.value;
    if (typeof y != "function")
      throw new Error(`Can not apply hooks. '${l}' is not a function`);
    return d.value = i(y, h.props({ method: l })), d;
  };
  return Re.legacyDecorator = a, Re;
}
var sa = {}, Zd;
function V_() {
  return Zd || (Zd = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.collect = e.fromErrorHook = e.fromAfterHook = e.fromBeforeHook = e.runHooks = e.runHook = void 0;
    const t = su(), r = (u, f, c) => {
      const l = f.type;
      return c && (f.type = c), Promise.resolve(u.call(f.self, f)).then((d) => {
        c && (f.type = l), d && d !== f && Object.assign(f, d);
      });
    };
    e.runHook = r;
    const n = (u) => (f) => u.reduce((c, l) => c.then(() => (0, e.runHook)(l, f)), Promise.resolve(f));
    e.runHooks = n;
    function i(u) {
      return (f, c) => (0, e.runHook)(u, f, "before").then(c);
    }
    e.fromBeforeHook = i;
    function o(u) {
      return (f, c) => c().then(() => (0, e.runHook)(u, f, "after"));
    }
    e.fromAfterHook = o;
    function s(u) {
      return (f, c) => c().catch((l) => ((f.error !== l || f.result !== void 0) && (f.original = { ...f }, f.error = l, delete f.result), (0, e.runHook)(u, f, "error").then(() => {
        if (f.result === void 0 && f.error !== void 0)
          throw f.error;
      }).catch((d) => {
        throw f.error = d, f.error;
      })));
    }
    e.fromErrorHook = s;
    function a({ before: u = [], after: f = [], error: c = [] }) {
      const l = u.map(i), d = [...f].reverse().map(o), h = c.length ? [s((0, e.runHooks)(c))] : [];
      return (0, t.compose)([...h, ...l, ...d]);
    }
    e.collect = a;
  })(sa)), sa;
}
var eh;
function Kp() {
  return eh || (eh = 1, (function(e) {
    var t = Ye && Ye.__createBinding || (Object.create ? (function(a, u, f, c) {
      c === void 0 && (c = f);
      var l = Object.getOwnPropertyDescriptor(u, f);
      (!l || ("get" in l ? !u.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
        return u[f];
      } }), Object.defineProperty(a, c, l);
    }) : (function(a, u, f, c) {
      c === void 0 && (c = f), a[c] = u[f];
    })), r = Ye && Ye.__exportStar || function(a, u) {
      for (var f in a) f !== "default" && !Object.prototype.hasOwnProperty.call(u, f) && t(u, a, f);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hooks = e.middleware = void 0;
    const n = wa(), i = Yd();
    r(Yd(), e), r(su(), e), r(wa(), e), r(V_(), e);
    function o(a, u) {
      const f = new n.HookManager().middleware(a);
      return u && (u.params && f.params(...u.params), u.defaults && f.defaults(u.defaults), u.props && f.props(u.props)), f;
    }
    e.middleware = o;
    function s(...a) {
      const [u, f] = a;
      return typeof u == "function" && (f instanceof n.HookManager || Array.isArray(f) || a.length === 1) ? (0, i.functionHooks)(u, f) : a.length === 2 ? (0, i.objectHooks)(u, f) : (0, i.hookDecorator)(u);
    }
    e.hooks = s;
  })(Ye)), Ye;
}
var kt = {}, aa = {}, th;
function zr() {
  return th || (th = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.normalizeServiceOptions = e.protectedMethods = e.defaultServiceEvents = e.defaultEventMap = e.defaultServiceMethods = e.defaultServiceArguments = e.SERVICE = void 0, e.getHookMethods = n, e.getServiceOptions = i, e.wrapService = s;
    const t = ou(), r = Et();
    e.SERVICE = (0, r.createSymbol)("@feathersjs/service"), e.defaultServiceArguments = {
      find: ["params"],
      get: ["id", "params"],
      create: ["data", "params"],
      update: ["id", "data", "params"],
      patch: ["id", "data", "params"],
      remove: ["id", "params"]
    }, e.defaultServiceMethods = ["find", "get", "create", "update", "patch", "remove"], e.defaultEventMap = {
      create: "created",
      update: "updated",
      patch: "patched",
      remove: "removed"
    }, e.defaultServiceEvents = Object.values(e.defaultEventMap), e.protectedMethods = Object.keys(Object.prototype).concat(Object.keys(t.EventEmitter.prototype)).concat(["all", "around", "before", "after", "error", "hooks", "setup", "teardown", "publish"]);
    function n(a, u) {
      const { methods: f } = u;
      return e.defaultServiceMethods.filter((c) => typeof a[c] == "function" && !f.includes(c)).concat(f);
    }
    function i(a) {
      return a[e.SERVICE];
    }
    const o = (a, u = {}) => {
      const { methods: f = e.defaultServiceMethods.filter((d) => typeof a[d] == "function"), events: c = a.events || [] } = u, l = u.serviceEvents || e.defaultServiceEvents.concat(c);
      return {
        ...u,
        events: c,
        methods: f,
        serviceEvents: l
      };
    };
    e.normalizeServiceOptions = o;
    function s(a, u, f) {
      if (u[e.SERVICE])
        return u;
      const c = Object.create(u), l = (0, e.normalizeServiceOptions)(u, f);
      if (Object.keys(l.methods).length === 0 && ![...e.defaultServiceMethods, "setup", "teardown"].some((d) => typeof u[d] == "function"))
        throw new Error(`Invalid service object passed for path \`${a}\``);
      return Object.defineProperty(c, e.SERVICE, {
        value: l
      }), c;
    }
  })(aa)), aa;
}
var rh;
function z_() {
  if (rh) return kt;
  rh = 1, Object.defineProperty(kt, "__esModule", { value: !0 }), kt.eventHook = r, kt.eventMixin = n;
  const e = ou(), t = zr();
  function r(i, o) {
    const { events: s } = (0, t.getServiceOptions)(i.self), a = t.defaultEventMap[i.method] || null;
    return i.event = a, o().then(() => {
      typeof i.event == "string" && !s.includes(i.event) && (Array.isArray(i.result) ? i.result : [i.result]).forEach((f) => i.self.emit(i.event, f, i));
    });
  }
  function n(i) {
    return typeof i.on == "function" && typeof i.emit == "function" || Object.assign(i, e.EventEmitter.prototype), i;
  }
  return kt;
}
var Me = {}, nh;
function Sa() {
  if (nh) return Me;
  nh = 1, Object.defineProperty(Me, "__esModule", { value: !0 }), Me.FeathersHookManager = void 0, Me.convertHookData = i, Me.collectHooks = o, Me.enableHooks = s, Me.createContext = a, Me.hookMixin = f;
  const e = Kp(), t = zr(), r = ["before", "after", "error", "around"], n = (c) => r.includes(c);
  function i(c) {
    const l = {};
    if (Array.isArray(c))
      l.all = c;
    else if (typeof c != "object")
      l.all = [c];
    else
      for (const d of Object.keys(c)) {
        const h = c[d];
        l[d] = Array.isArray(h) ? h : [h];
      }
    return l;
  }
  function o(c, l) {
    const { collected: d, collectedAll: h, around: y } = c.__hooks;
    return [
      ...y.all || [],
      ...y[l] || [],
      ...h.before || [],
      ...d[l] || [],
      ...h.after || []
    ];
  }
  function s(c) {
    return Object.defineProperty(c, "__hooks", {
      configurable: !0,
      value: {
        around: {},
        before: {},
        after: {},
        error: {},
        collected: {},
        collectedAll: {}
      },
      writable: !0
    }), function(h) {
      const y = this.__hooks, O = Object.keys(h).reduce((C, w) => {
        if (!n(w))
          throw new Error(`'${w}' is not a valid hook type`);
        return C[w] = i(h[w]), C;
      }, {});
      return Object.keys(O).forEach((C) => Object.keys(O[C]).forEach((w) => {
        var E;
        const g = O[C][w];
        if (((E = y[C])[w] || (E[w] = [])).push(...g), w === "all") {
          if (y.before[w] || y.error[w]) {
            const p = (0, e.collect)({
              before: y.before[w] || [],
              error: y.error[w] || []
            });
            y.collectedAll.before = [p];
          }
          if (y.after[w]) {
            const p = (0, e.collect)({
              after: y.after[w] || []
            });
            y.collectedAll.after = [p];
          }
        } else if (y.before[w] || y.after[w] || y.error[w]) {
          const p = (0, e.collect)({
            before: y.before[w] || [],
            after: y.after[w] || [],
            error: y.error[w] || []
          });
          y.collected[w] = [p];
        }
      })), this;
    };
  }
  function a(c, l, d = {}) {
    const h = c[l].createContext;
    if (typeof h != "function")
      throw new Error(`Can not create context for method ${l}`);
    return h(d);
  }
  class u extends e.HookManager {
    constructor(l, d) {
      super(), this.app = l, this.method = d, this._middleware = [];
    }
    collectMiddleware(l, d) {
      const h = o(this.app, this.method), y = super.collectMiddleware(l, d), O = o(l, this.method);
      return [...h, ...y, ...O];
    }
    initializeContext(l, d, h) {
      const y = super.initializeContext(l, d, h);
      return y.params = y.params || {}, y;
    }
    middleware(l) {
      return this._middleware.push(...l), this;
    }
  }
  Me.FeathersHookManager = u;
  function f(c, l, d) {
    if (typeof c.hooks == "function")
      return c;
    const y = (0, t.getHookMethods)(c, d).reduce((b, C) => {
      const w = t.defaultServiceArguments[C] || ["data", "params"];
      return b[C] = new u(this, C).params(...w).props({
        app: this,
        path: l,
        method: C,
        service: c,
        event: null,
        type: "around",
        get statusCode() {
          var E;
          return (E = this.http) === null || E === void 0 ? void 0 : E.status;
        },
        set statusCode(E) {
          this.http = this.http || {}, this.http.status = E;
        }
      }), b;
    }, {}), O = s(c);
    return (0, e.hooks)(c, y), c.hooks = function(b) {
      return b.before || b.after || b.error || b.around ? O.call(this, b) : Array.isArray(b) ? (0, e.hooks)(this, b) : (Object.keys(b).forEach((C) => {
        const w = (0, e.getManager)(this[C]);
        if (!(w instanceof u))
          throw new Error(`Method ${C} is not a Feathers hooks enabled service method`);
        w.middleware(b[C]);
      }), this);
    }, c;
  }
  return Me;
}
var ih;
function J_() {
  if (ih) return Xe;
  ih = 1;
  var e = Xe && Xe.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.Feathers = void 0;
  const t = e(xp()), r = ou(), n = Et(), i = Kp(), o = z_(), s = Sa(), a = zr(), u = Sa(), f = (0, n.createDebug)("@feathersjs/feathers");
  class c extends r.EventEmitter {
    constructor() {
      super(), this.services = {}, this.settings = {}, this.mixins = [s.hookMixin, o.eventMixin], this.version = t.default, this._isSetup = !1, this.registerHooks = (0, u.enableHooks)(this), this.registerHooks({
        around: [o.eventHook]
      });
    }
    get(d) {
      return this.settings[d];
    }
    set(d, h) {
      return this.settings[d] = h, this;
    }
    configure(d) {
      return d.call(this, this), this;
    }
    defaultService(d) {
      throw new Error(`Can not find service '${d}'`);
    }
    service(d) {
      const h = (0, n.stripSlashes)(d) || "/", y = this.services.hasOwnProperty(h) ? this.services[h] : void 0;
      return typeof y > "u" ? (this.use(h, this.defaultService(h)), this.service(h)) : y;
    }
    _setup() {
      return this._isSetup = !0, Object.keys(this.services).reduce((d, h) => d.then(() => {
        const y = this.service(h);
        if (typeof y.setup == "function")
          return f(`Setting up service for \`${h}\``), y.setup(this, h);
      }), Promise.resolve()).then(() => this);
    }
    get setup() {
      return this._setup;
    }
    set setup(d) {
      this._setup = d[i.HOOKS] ? d : (0, i.hooks)(d, (0, i.middleware)().params("server").props({
        app: this
      }));
    }
    _teardown() {
      return this._isSetup = !1, Object.keys(this.services).reduce((d, h) => d.then(() => {
        const y = this.service(h);
        if (typeof y.teardown == "function")
          return f(`Tearing down service for \`${h}\``), y.teardown(this, h);
      }), Promise.resolve()).then(() => this);
    }
    get teardown() {
      return this._teardown;
    }
    set teardown(d) {
      this._teardown = d[i.HOOKS] ? d : (0, i.hooks)(d, (0, i.middleware)().params("server").props({
        app: this
      }));
    }
    use(d, h, y) {
      if (typeof d != "string")
        throw new Error(`'${d}' is not a valid service path.`);
      const O = (0, n.stripSlashes)(d) || "/", b = h;
      if (typeof b.service == "function" && b.services)
        return Object.keys(b.services).forEach((g) => this.use(`${O}/${g}`, b.service(g))), this;
      const w = (0, a.wrapService)(O, h, y), E = (0, a.getServiceOptions)(w);
      for (const g of a.protectedMethods)
        if (E.methods.includes(g))
          throw new Error(`'${g}' on service '${O}' is not allowed as a custom method name`);
      return f(`Registering new service at \`${O}\``), this.mixins.forEach((g) => g.call(this, w, O, E)), this.services[O] = w, this._isSetup && typeof w.setup == "function" && (f(`Setting up service for \`${O}\``), w.setup(this, O)), this;
    }
    async unuse(d) {
      const h = (0, n.stripSlashes)(d) || "/", y = this.services[h];
      return y && typeof y.teardown == "function" && await y.teardown(this, h), delete this.services[h], y;
    }
    hooks(d) {
      const h = d;
      return h.before || h.after || h.error || h.around ? this.registerHooks(h) : h.setup || h.teardown ? (0, i.hooks)(this, h) : this.registerHooks({
        around: h
      }), this;
    }
  }
  return Xe.Feathers = c, Xe;
}
var ua = {}, oh;
function Q_() {
  return oh || (oh = 1, Object.defineProperty(ua, "__esModule", { value: !0 })), ua;
}
var yt = Gt.exports, sh;
function au() {
  return sh || (sh = 1, (function(e, t) {
    var r = yt && yt.__createBinding || (Object.create ? (function(f, c, l, d) {
      d === void 0 && (d = l);
      var h = Object.getOwnPropertyDescriptor(c, l);
      (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return c[l];
      } }), Object.defineProperty(f, d, h);
    }) : (function(f, c, l, d) {
      d === void 0 && (d = l), f[d] = c[l];
    })), n = yt && yt.__exportStar || function(f, c) {
      for (var l in f) l !== "default" && !Object.prototype.hasOwnProperty.call(c, l) && r(c, f, l);
    }, i = yt && yt.__importDefault || function(f) {
      return f && f.__esModule ? f : { default: f };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Feathers = t.version = void 0, t.feathers = u;
    const o = Et(), s = i(xp());
    t.version = s.default;
    const a = J_();
    Object.defineProperty(t, "Feathers", { enumerable: !0, get: function() {
      return a.Feathers;
    } });
    function u() {
      return new a.Feathers();
    }
    u.setDebug = o.setDebug, n(Sa(), t), n(Q_(), t), n(zr(), t), e.exports = Object.assign(u, e.exports);
  })(Gt, Gt.exports)), Gt.exports;
}
var Jr = au(), Vt = { exports: {} }, Nt = {}, et = {}, ah;
function Wp() {
  if (ah) return et;
  ah = 1, Object.defineProperty(et, "__esModule", { value: !0 }), et.StorageWrapper = et.MemoryStorage = void 0;
  class e {
    constructor() {
      this.store = {};
    }
    getItem(n) {
      return Promise.resolve(this.store[n]);
    }
    setItem(n, i) {
      return Promise.resolve(this.store[n] = i);
    }
    removeItem(n) {
      const i = this.store[n];
      return delete this.store[n], Promise.resolve(i);
    }
  }
  et.MemoryStorage = e;
  class t {
    constructor(n) {
      this.storage = n;
    }
    getItem(n) {
      var i;
      return Promise.resolve((i = this.storage) === null || i === void 0 ? void 0 : i.getItem(n));
    }
    setItem(n, i) {
      var o;
      return Promise.resolve((o = this.storage) === null || o === void 0 ? void 0 : o.setItem(n, i));
    }
    removeItem(n) {
      var i;
      return Promise.resolve((i = this.storage) === null || i === void 0 ? void 0 : i.removeItem(n));
    }
  }
  return et.StorageWrapper = t, et;
}
var uh;
function X_() {
  if (uh) return Nt;
  uh = 1, Object.defineProperty(Nt, "__esModule", { value: !0 }), Nt.AuthenticationClient = void 0;
  const e = Xt(), t = Wp();
  class r extends e.FeathersError {
    constructor(s, a) {
      super(s, "OauthError", 401, "oauth-error", a);
    }
  }
  const n = (o, s) => {
    const a = new RegExp(`(?:&?)${s}=([^&]*)`), u = o.hash ? o.hash.match(a) : null;
    if (u !== null) {
      const [, f] = u;
      return [f, a];
    }
    return [null, a];
  };
  class i {
    constructor(s, a) {
      const u = s.io, f = new t.StorageWrapper(s.get("storage") || a.storage);
      this.app = s, this.options = a, this.authenticated = !1, this.app.set("storage", f), u && this.handleSocket(u);
    }
    get service() {
      return this.app.service(this.options.path);
    }
    get storage() {
      return this.app.get("storage");
    }
    handleSocket(s) {
      s.on("disconnect", () => {
        this.authenticated && this.reAuthenticate(!0);
      });
    }
    /**
     * Parse the access token or authentication error from the window location hash. Will remove it from the hash
     * if found.
     *
     * @param location The window location
     * @returns The access token if available, will throw an error if found, otherwise null
     */
    getFromLocation(s) {
      const [a, u] = n(s, this.options.locationKey);
      if (a !== null)
        return s.hash = s.hash.replace(u, ""), Promise.resolve(a);
      const [f, c] = n(s, this.options.locationErrorKey);
      return f !== null ? (s.hash = s.hash.replace(c, ""), Promise.reject(new r(decodeURIComponent(f)))) : Promise.resolve(null);
    }
    /**
     * Set the access token in storage.
     *
     * @param accessToken The access token to set
     * @returns
     */
    setAccessToken(s) {
      return this.storage.setItem(this.options.storageKey, s);
    }
    /**
     * Returns the access token from storage or the window location hash.
     *
     * @returns The access token from storage or location hash
     */
    getAccessToken() {
      return this.storage.getItem(this.options.storageKey).then((s) => !s && typeof window < "u" && window.location ? this.getFromLocation(window.location) : s || null);
    }
    /**
     * Remove the access token from storage
     * @returns The removed access token
     */
    removeAccessToken() {
      return this.storage.removeItem(this.options.storageKey);
    }
    /**
     * Reset the internal authentication state. Usually not necessary to call directly.
     *
     * @returns null
     */
    reset() {
      return this.app.set("authentication", null), this.authenticated = !1, Promise.resolve(null);
    }
    handleError(s, a) {
      if (s.code > 400 && s.code < 408) {
        const u = this.removeAccessToken().then(() => this.reset());
        return a === "logout" ? u : u.then(() => Promise.reject(s));
      }
      return this.reset().then(() => Promise.reject(s));
    }
    /**
     * Try to reauthenticate using the token from storage. Will do nothing if already authenticated unless
     * `force` is true.
     *
     * @param force force reauthentication with the server
     * @param strategy The name of the strategy to use. Defaults to `options.jwtStrategy`
     * @param authParams Additional authentication parameters
     * @returns The reauthentication result
     */
    reAuthenticate(s = !1, a, u) {
      let f = this.app.get("authentication");
      return (!f || s === !0) && (f = this.getAccessToken().then((c) => c ? this.authenticate({
        strategy: a || this.options.jwtStrategy,
        accessToken: c
      }, u) : this.handleError(new e.NotAuthenticated("No accessToken found in storage"), "authenticate")), this.app.set("authentication", f)), f;
    }
    /**
     * Authenticate using a specific strategy and data.
     *
     * @param authentication The authentication data
     * @param params Additional parameters
     * @returns The authentication result
     */
    authenticate(s, a) {
      if (!s)
        return this.reAuthenticate();
      const u = this.service.create(s, a).then((f) => {
        const { accessToken: c } = f;
        return this.authenticated = !0, this.app.emit("login", f), this.app.emit("authenticated", f), this.setAccessToken(c).then(() => f);
      }).catch((f) => this.handleError(f, "authenticate"));
      return this.app.set("authentication", u), u;
    }
    /**
     * Log out the current user and remove their token. Will do nothing
     * if not authenticated.
     *
     * @returns The log out result.
     */
    logout() {
      return Promise.resolve(this.app.get("authentication")).then(() => this.service.remove(null).then((s) => this.removeAccessToken().then(() => this.reset()).then(() => (this.app.emit("logout", s), s)))).catch((s) => this.handleError(s, "logout"));
    }
  }
  return Nt.AuthenticationClient = i, Nt;
}
var ca = {}, Lt = {}, ch;
function Y_() {
  if (ch) return Lt;
  ch = 1, Object.defineProperty(Lt, "__esModule", { value: !0 }), Lt.authentication = void 0;
  const e = Et(), t = () => (r, n) => {
    const { app: i, params: o, path: s, method: a, app: { authentication: u } } = r;
    return (0, e.stripSlashes)(u.options.path) === s && a === "create" ? n() : Promise.resolve(i.get("authentication")).then((f) => {
      f && (r.params = Object.assign({}, f, o));
    }).then(n);
  };
  return Lt.authentication = t, Lt;
}
var Dt = {}, fh;
function Z_() {
  if (fh) return Dt;
  fh = 1, Object.defineProperty(Dt, "__esModule", { value: !0 }), Dt.populateHeader = void 0;
  const e = () => (t, r) => {
    const { app: n, params: { accessToken: i } } = t, o = n.authentication;
    if (n.rest && i) {
      const { scheme: s, header: a } = o.options, u = `${s} ${i}`;
      t.params.headers = Object.assign({}, {
        [a]: u
      }, t.params.headers);
    }
    return r();
  };
  return Dt.populateHeader = e, Dt;
}
var lh;
function ew() {
  return lh || (lh = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.populateHeader = e.authentication = void 0;
    var t = Y_();
    Object.defineProperty(e, "authentication", { enumerable: !0, get: function() {
      return t.authentication;
    } });
    var r = Z_();
    Object.defineProperty(e, "populateHeader", { enumerable: !0, get: function() {
      return r.populateHeader;
    } });
  })(ca)), ca;
}
var gt = Vt.exports, dh;
function tw() {
  return dh || (dh = 1, (function(e, t) {
    var r = gt && gt.__createBinding || (Object.create ? (function(c, l, d, h) {
      h === void 0 && (h = d);
      var y = Object.getOwnPropertyDescriptor(l, d);
      (!y || ("get" in y ? !l.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
        return l[d];
      } }), Object.defineProperty(c, h, y);
    }) : (function(c, l, d, h) {
      h === void 0 && (h = d), c[h] = l[d];
    })), n = gt && gt.__setModuleDefault || (Object.create ? (function(c, l) {
      Object.defineProperty(c, "default", { enumerable: !0, value: l });
    }) : function(c, l) {
      c.default = l;
    }), i = gt && gt.__importStar || /* @__PURE__ */ (function() {
      var c = function(l) {
        return c = Object.getOwnPropertyNames || function(d) {
          var h = [];
          for (var y in d) Object.prototype.hasOwnProperty.call(d, y) && (h[h.length] = y);
          return h;
        }, c(l);
      };
      return function(l) {
        if (l && l.__esModule) return l;
        var d = {};
        if (l != null) for (var h = c(l), y = 0; y < h.length; y++) h[y] !== "default" && r(d, l, h[y]);
        return n(d, l), d;
      };
    })();
    Object.defineProperty(t, "__esModule", { value: !0 }), t.defaults = t.defaultStorage = t.hooks = t.MemoryStorage = t.AuthenticationClient = t.getDefaultStorage = void 0;
    const o = X_();
    Object.defineProperty(t, "AuthenticationClient", { enumerable: !0, get: function() {
      return o.AuthenticationClient;
    } });
    const s = i(ew());
    t.hooks = s;
    const a = Wp();
    Object.defineProperty(t, "MemoryStorage", { enumerable: !0, get: function() {
      return a.MemoryStorage;
    } });
    const u = () => {
      try {
        return new a.StorageWrapper(window.localStorage);
      } catch {
      }
      return new a.MemoryStorage();
    };
    t.getDefaultStorage = u, t.defaultStorage = (0, t.getDefaultStorage)(), t.defaults = {
      header: "Authorization",
      scheme: "Bearer",
      storageKey: "feathers-jwt",
      locationKey: "access_token",
      locationErrorKey: "error",
      jwtStrategy: "jwt",
      path: "/authentication",
      Authentication: o.AuthenticationClient,
      storage: t.defaultStorage
    };
    const f = (c = {}) => {
      const l = Object.assign({}, t.defaults, c), { Authentication: d } = l;
      return (h) => {
        const y = new d(h, l);
        h.authentication = y, h.authenticate = y.authenticate.bind(y), h.reAuthenticate = y.reAuthenticate.bind(y), h.logout = y.logout.bind(y), h.hooks([s.authentication(), s.populateHeader()]);
      };
    };
    t.default = f, e.exports = Object.assign(f, e.exports);
  })(Vt, Vt.exports)), Vt.exports;
}
var rw = tw();
const Qr = /* @__PURE__ */ at(rw);
var br = { exports: {} }, tt = {}, hh;
function Xr() {
  if (hh) return tt;
  hh = 1;
  var e = tt && tt.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(tt, "__esModule", { value: !0 }), tt.Base = void 0;
  const t = e(/* @__PURE__ */ Qm()), r = Xt(), n = Et();
  function i(s) {
    throw s.code === "ECONNREFUSED" ? new r.Unavailable(s.message, n._.pick(s, "address", "port", "config")) : (0, r.convert)(s);
  }
  class o {
    constructor(a) {
      this.name = (0, n.stripSlashes)(a.name), this.options = a.options, this.connection = a.connection, this.base = `${a.base}/${this.name}`;
    }
    makeUrl(a, u, f) {
      let c = this.base;
      return f && Object.keys(f).forEach((l) => {
        c = c.replace(`:${l}`, f[l]);
      }), a = a || {}, typeof u < "u" && u !== null && (c += `/${encodeURIComponent(u)}`), c + this.getQuery(a);
    }
    getQuery(a) {
      return Object.keys(a).length !== 0 ? `?${t.default.stringify(a)}` : "";
    }
    methods(...a) {
      return a.forEach((u) => {
        const f = `_${u}`;
        this[f] = function(c, l = {}) {
          return this.request({
            body: c,
            url: this.makeUrl(l.query, null, l.route),
            method: "POST",
            headers: Object.assign({
              "Content-Type": "application/json",
              "X-Service-Method": u
            }, l.headers)
          }, l).catch(i);
        }, this[u] = function(c, l = {}) {
          return this[f](c, l);
        };
      }), this;
    }
    _find(a) {
      return this.request({
        url: this.makeUrl(a.query, null, a.route),
        method: "GET",
        headers: Object.assign({}, a.headers)
      }, a).catch(i);
    }
    find(a) {
      return this._find(a);
    }
    _get(a, u) {
      return a === void 0 || a === "" ? Promise.reject(new r.BadRequest("id for .get is required")) : this.request({
        url: this.makeUrl(u.query, a, u.route),
        method: "GET",
        headers: Object.assign({}, u.headers)
      }, u).catch(i);
    }
    get(a, u) {
      return this._get(a, u);
    }
    _create(a, u) {
      return this.request({
        url: this.makeUrl(u.query, null, u.route),
        body: a,
        method: "POST",
        headers: Object.assign({ "Content-Type": "application/json" }, u.headers)
      }, u).catch(i);
    }
    create(a, u) {
      return this._create(a, u);
    }
    _update(a, u, f) {
      return a === void 0 || a === "" ? Promise.reject(new r.BadRequest("id for .update is required")) : this.request({
        url: this.makeUrl(f.query, a, f.route),
        body: u,
        method: "PUT",
        headers: Object.assign({ "Content-Type": "application/json" }, f.headers)
      }, f).catch(i);
    }
    update(a, u, f) {
      return this._update(a, u, f);
    }
    _patch(a, u, f) {
      return a === void 0 || a === "" ? Promise.reject(new r.BadRequest("id for .patch is required")) : this.request({
        url: this.makeUrl(f.query, a, f.route),
        body: u,
        method: "PATCH",
        headers: Object.assign({ "Content-Type": "application/json" }, f.headers)
      }, f).catch(i);
    }
    patch(a, u, f) {
      return this._patch(a, u, f);
    }
    _remove(a, u) {
      return a === void 0 || a === "" ? Promise.reject(new r.BadRequest("id for .remove is required")) : this.request({
        url: this.makeUrl(u.query, a, u.route),
        method: "DELETE",
        headers: Object.assign({}, u.headers)
      }, u).catch(i);
    }
    remove(a, u) {
      return this._remove(a, u);
    }
  }
  return tt.Base = o, tt;
}
var Mt = {}, ph;
function nw() {
  if (ph) return Mt;
  ph = 1, Object.defineProperty(Mt, "__esModule", { value: !0 }), Mt.AxiosClient = void 0;
  const e = Xr();
  class t extends e.Base {
    request(n, i) {
      const o = Object.assign({
        url: n.url,
        method: n.method,
        data: n.body,
        headers: Object.assign({
          Accept: "application/json"
        }, this.options.headers, n.headers)
      }, i.connection);
      return this.connection.request(o).then((s) => s.data).catch((s) => {
        const a = s.response || s;
        throw a instanceof Error ? a : a.data || a;
      });
    }
  }
  return Mt.AxiosClient = t, Mt;
}
var Bt = {}, yh;
function iw() {
  if (yh) return Bt;
  yh = 1, Object.defineProperty(Bt, "__esModule", { value: !0 }), Bt.FetchClient = void 0;
  const e = Xt(), t = Xr();
  class r extends t.Base {
    request(i, o) {
      const s = Object.assign({}, i, o.connection);
      return s.headers = Object.assign({
        Accept: "application/json"
      }, this.options.headers, s.headers), i.body && (s.body = JSON.stringify(i.body)), this.connection(i.url, s).then(this.checkStatus).then((a) => a.status === 204 ? null : a.json());
    }
    checkStatus(i) {
      return i.ok ? i : i.json().catch(() => {
        const o = e.errors[i.status] || Error;
        return new o("JSON parsing error");
      }).then((o) => {
        throw o.response = i, o;
      });
    }
  }
  return Bt.FetchClient = r, Bt;
}
var $t = {}, gh;
function ow() {
  if (gh) return $t;
  gh = 1, Object.defineProperty($t, "__esModule", { value: !0 }), $t.SuperagentClient = void 0;
  const e = Xr();
  class t extends e.Base {
    request(n, i) {
      const o = this.connection(n.method, n.url).set(this.options.headers || {}).set("Accept", "application/json").set(i.connection || {}).set(n.headers || {}).type(n.type || "json");
      return new Promise((s, a) => {
        o.set(n.headers), n.body && o.send(n.body), o.end(function(u, f) {
          if (u) {
            try {
              const c = u.response;
              u = JSON.parse(u.response.text), u.response = c;
            } catch {
            }
            return a(u);
          }
          s(f && f.body);
        });
      });
    }
  }
  return $t.SuperagentClient = t, $t;
}
var mh;
function sw() {
  return mh || (mh = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SuperagentClient = t.FetchClient = t.AxiosClient = void 0, t.default = u;
    const r = au(), n = Xr(), i = nw();
    Object.defineProperty(t, "AxiosClient", { enumerable: !0, get: function() {
      return i.AxiosClient;
    } });
    const o = iw();
    Object.defineProperty(t, "FetchClient", { enumerable: !0, get: function() {
      return o.FetchClient;
    } });
    const s = ow();
    Object.defineProperty(t, "SuperagentClient", { enumerable: !0, get: function() {
      return s.SuperagentClient;
    } });
    const a = {
      superagent: s.SuperagentClient,
      fetch: o.FetchClient,
      axios: i.AxiosClient
    };
    function u(f = "") {
      const c = { Base: n.Base };
      return Object.keys(a).forEach((l) => {
        c[l] = function(d, h = {}, y = a[l]) {
          if (!d)
            throw new Error(`${l} has to be provided to feathers-rest`);
          typeof h == "function" && (y = h, h = {});
          const O = function(C) {
            return new y({ base: f, name: C, connection: d, options: h });
          }, b = (C) => {
            if (C.rest !== void 0)
              throw new Error("Only one default client provider can be configured");
            C.rest = d, C.defaultService = O, C.mixins.unshift((w, E, g) => {
              if (g && g.methods && w instanceof n.Base) {
                const v = g.methods.filter((p) => !r.defaultServiceMethods.includes(p));
                w.methods(...v);
              }
            });
          };
          return b.Service = y, b.service = O, b;
        };
      }), c;
    }
    e.exports = Object.assign(u, e.exports);
  })(br, br.exports)), br.exports;
}
var aw = sw();
const Gp = /* @__PURE__ */ at(aw), Y0 = ({ url: e }) => {
  const t = Jr.feathers(), r = Gp(e);
  return t.configure(
    r.axios(
      ye.create({
        headers: { "X-Requested-With": "My-Feathers-Mobile" }
      })
    )
  ), t.configure(
    Qr({
      storage: bt
    })
  ), t;
}, Z0 = ({ url: e, authenticationPath: t }) => {
  const r = Jr.feathers(), n = Gp(e);
  return r.configure(
    n.axios(
      ye.create({
        headers: { "X-Requested-With": "My-Feathers-Frontend" }
      })
    )
  ), r.configure(
    Qr({
      storage: window.localStorage,
      path: t
    })
  ), r;
}, $e = /* @__PURE__ */ Object.create(null);
$e.open = "0";
$e.close = "1";
$e.ping = "2";
$e.pong = "3";
$e.message = "4";
$e.upgrade = "5";
$e.noop = "6";
const qr = /* @__PURE__ */ Object.create(null);
Object.keys($e).forEach((e) => {
  qr[$e[e]] = e;
});
const Oa = { type: "error", data: "parser error" }, Vp = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", zp = typeof ArrayBuffer == "function", Jp = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, uu = ({ type: e, data: t }, r, n) => Vp && t instanceof Blob ? r ? n(t) : vh(t, n) : zp && (t instanceof ArrayBuffer || Jp(t)) ? r ? n(t) : vh(new Blob([t]), n) : n($e[e] + (t || "")), vh = (e, t) => {
  const r = new FileReader();
  return r.onload = function() {
    const n = r.result.split(",")[1];
    t("b" + (n || ""));
  }, r.readAsDataURL(e);
};
function bh(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let fa;
function uw(e, t) {
  if (Vp && e.data instanceof Blob)
    return e.data.arrayBuffer().then(bh).then(t);
  if (zp && (e.data instanceof ArrayBuffer || Jp(e.data)))
    return t(bh(e.data));
  uu(e, !1, (r) => {
    fa || (fa = new TextEncoder()), t(fa.encode(r));
  });
}
const _h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", zt = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < _h.length; e++)
  zt[_h.charCodeAt(e)] = e;
const cw = (e) => {
  let t = e.length * 0.75, r = e.length, n, i = 0, o, s, a, u;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const f = new ArrayBuffer(t), c = new Uint8Array(f);
  for (n = 0; n < r; n += 4)
    o = zt[e.charCodeAt(n)], s = zt[e.charCodeAt(n + 1)], a = zt[e.charCodeAt(n + 2)], u = zt[e.charCodeAt(n + 3)], c[i++] = o << 2 | s >> 4, c[i++] = (s & 15) << 4 | a >> 2, c[i++] = (a & 3) << 6 | u & 63;
  return f;
}, fw = typeof ArrayBuffer == "function", cu = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: Qp(e, t)
    };
  const r = e.charAt(0);
  return r === "b" ? {
    type: "message",
    data: lw(e.substring(1), t)
  } : qr[r] ? e.length > 1 ? {
    type: qr[r],
    data: e.substring(1)
  } : {
    type: qr[r]
  } : Oa;
}, lw = (e, t) => {
  if (fw) {
    const r = cw(e);
    return Qp(r, t);
  } else
    return { base64: !0, data: e };
}, Qp = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, Xp = "", dw = (e, t) => {
  const r = e.length, n = new Array(r);
  let i = 0;
  e.forEach((o, s) => {
    uu(o, !1, (a) => {
      n[s] = a, ++i === r && t(n.join(Xp));
    });
  });
}, hw = (e, t) => {
  const r = e.split(Xp), n = [];
  for (let i = 0; i < r.length; i++) {
    const o = cu(r[i], t);
    if (n.push(o), o.type === "error")
      break;
  }
  return n;
};
function pw() {
  return new TransformStream({
    transform(e, t) {
      uw(e, (r) => {
        const n = r.length;
        let i;
        if (n < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, n);
        else if (n < 65536) {
          i = new Uint8Array(3);
          const o = new DataView(i.buffer);
          o.setUint8(0, 126), o.setUint16(1, n);
        } else {
          i = new Uint8Array(9);
          const o = new DataView(i.buffer);
          o.setUint8(0, 127), o.setBigUint64(1, BigInt(n));
        }
        e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(r);
      });
    }
  });
}
let la;
function _r(e) {
  return e.reduce((t, r) => t + r.length, 0);
}
function wr(e, t) {
  if (e[0].length === t)
    return e.shift();
  const r = new Uint8Array(t);
  let n = 0;
  for (let i = 0; i < t; i++)
    r[i] = e[0][n++], n === e[0].length && (e.shift(), n = 0);
  return e.length && n < e[0].length && (e[0] = e[0].slice(n)), r;
}
function yw(e, t) {
  la || (la = new TextDecoder());
  const r = [];
  let n = 0, i = -1, o = !1;
  return new TransformStream({
    transform(s, a) {
      for (r.push(s); ; ) {
        if (n === 0) {
          if (_r(r) < 1)
            break;
          const u = wr(r, 1);
          o = (u[0] & 128) === 128, i = u[0] & 127, i < 126 ? n = 3 : i === 126 ? n = 1 : n = 2;
        } else if (n === 1) {
          if (_r(r) < 2)
            break;
          const u = wr(r, 2);
          i = new DataView(u.buffer, u.byteOffset, u.length).getUint16(0), n = 3;
        } else if (n === 2) {
          if (_r(r) < 8)
            break;
          const u = wr(r, 8), f = new DataView(u.buffer, u.byteOffset, u.length), c = f.getUint32(0);
          if (c > Math.pow(2, 21) - 1) {
            a.enqueue(Oa);
            break;
          }
          i = c * Math.pow(2, 32) + f.getUint32(4), n = 3;
        } else {
          if (_r(r) < i)
            break;
          const u = wr(r, i);
          a.enqueue(cu(o ? u : la.decode(u), t)), n = 0;
        }
        if (i === 0 || i > e) {
          a.enqueue(Oa);
          break;
        }
      }
    }
  });
}
const Yp = 4;
function ve(e) {
  if (e) return gw(e);
}
function gw(e) {
  for (var t in ve.prototype)
    e[t] = ve.prototype[t];
  return e;
}
ve.prototype.on = ve.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
ve.prototype.once = function(e, t) {
  function r() {
    this.off(e, r), t.apply(this, arguments);
  }
  return r.fn = t, this.on(e, r), this;
};
ve.prototype.off = ve.prototype.removeListener = ve.prototype.removeAllListeners = ve.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var r = this._callbacks["$" + e];
  if (!r) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var n, i = 0; i < r.length; i++)
    if (n = r[i], n === t || n.fn === t) {
      r.splice(i, 1);
      break;
    }
  return r.length === 0 && delete this._callbacks["$" + e], this;
};
ve.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), r = this._callbacks["$" + e], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (r) {
    r = r.slice(0);
    for (var n = 0, i = r.length; n < i; ++n)
      r[n].apply(this, t);
  }
  return this;
};
ve.prototype.emitReserved = ve.prototype.emit;
ve.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
ve.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const Yr = typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, r) => r(t, 0), Pe = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), mw = "arraybuffer";
function Zp(e, ...t) {
  return t.reduce((r, n) => (e.hasOwnProperty(n) && (r[n] = e[n]), r), {});
}
const vw = Pe.setTimeout, bw = Pe.clearTimeout;
function Zr(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = vw.bind(Pe), e.clearTimeoutFn = bw.bind(Pe)) : (e.setTimeoutFn = Pe.setTimeout.bind(Pe), e.clearTimeoutFn = Pe.clearTimeout.bind(Pe));
}
const _w = 1.33;
function ww(e) {
  return typeof e == "string" ? Sw(e) : Math.ceil((e.byteLength || e.size) * _w);
}
function Sw(e) {
  let t = 0, r = 0;
  for (let n = 0, i = e.length; n < i; n++)
    t = e.charCodeAt(n), t < 128 ? r += 1 : t < 2048 ? r += 2 : t < 55296 || t >= 57344 ? r += 3 : (n++, r += 4);
  return r;
}
function ey() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function Ow(e) {
  let t = "";
  for (let r in e)
    e.hasOwnProperty(r) && (t.length && (t += "&"), t += encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
  return t;
}
function Aw(e) {
  let t = {}, r = e.split("&");
  for (let n = 0, i = r.length; n < i; n++) {
    let o = r[n].split("=");
    t[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
  }
  return t;
}
class Cw extends Error {
  constructor(t, r, n) {
    super(t), this.description = r, this.context = n, this.type = "TransportError";
  }
}
class fu extends ve {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, Zr(this, t), this.opts = t, this.query = t.query, this.socket = t.socket, this.supportsBinary = !t.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, r, n) {
    return super.emitReserved("error", new Cw(t, r, n)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const r = cu(t, this.socket.binaryType);
    this.onPacket(r);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, r = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(r);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const r = Ow(t);
    return r.length ? "?" + r : "";
  }
}
class Ew extends fu {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const r = () => {
      this.readyState = "paused", t();
    };
    if (this._polling || !this.writable) {
      let n = 0;
      this._polling && (n++, this.once("pollComplete", function() {
        --n || r();
      })), this.writable || (n++, this.once("drain", function() {
        --n || r();
      }));
    } else
      r();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const r = (n) => {
      if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(n);
    };
    hw(t, this.socket.binaryType).forEach(r), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, dw(t, (r) => {
      this.doWrite(r, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", r = this.query || {};
    return this.opts.timestampRequests !== !1 && (r[this.opts.timestampParam] = ey()), !this.supportsBinary && !r.sid && (r.b64 = 1), this.createUri(t, r);
  }
}
let ty = !1;
try {
  ty = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const Rw = ty;
function qw() {
}
class Pw extends Ew {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), typeof location < "u") {
      const r = location.protocol === "https:";
      let n = location.port;
      n || (n = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || n !== t.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data - data to send.
   * @param {Function} fn - called upon flush.
   * @private
   */
  doWrite(t, r) {
    const n = this.request({
      method: "POST",
      data: t
    });
    n.on("success", r), n.on("error", (i, o) => {
      this.onError("xhr post error", i, o);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (r, n) => {
      this.onError("xhr poll error", r, n);
    }), this.pollXhr = t;
  }
}
class Be extends ve {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, r, n) {
    super(), this.createRequest = t, Zr(this, n), this._opts = n, this._method = n.method || "GET", this._uri = r, this._data = n.data !== void 0 ? n.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var t;
    const r = Zp(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    r.xdomain = !!this._opts.xd;
    const n = this._xhr = this.createRequest(r);
    try {
      n.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let i in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(i) && n.setRequestHeader(i, this._opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this._opts.cookieJar) === null || t === void 0 || t.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = () => {
        var i;
        n.readyState === 3 && ((i = this._opts.cookieJar) === null || i === void 0 || i.parseCookies(
          // @ts-ignore
          n.getResponseHeader("set-cookie")
        )), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this._data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this._onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Be.requestsCount++, Be.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(t) {
    this.emitReserved("error", t, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(t) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = qw, t)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Be.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const t = this._xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Be.requestsCount = 0;
Be.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", wh);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in Pe ? "pagehide" : "unload";
    addEventListener(e, wh, !1);
  }
}
function wh() {
  for (let e in Be.requests)
    Be.requests.hasOwnProperty(e) && Be.requests[e].abort();
}
const Tw = (function() {
  const e = ry({
    xdomain: !1
  });
  return e && e.responseType !== null;
})();
class Fw extends Pw {
  constructor(t) {
    super(t);
    const r = t && t.forceBase64;
    this.supportsBinary = Tw && !r;
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd }, this.opts), new Be(ry, this.uri(), t);
  }
}
function ry(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || Rw))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new Pe[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const ny = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class Iw extends fu {
  get name() {
    return "websocket";
  }
  doOpen() {
    const t = this.uri(), r = this.opts.protocols, n = ny ? {} : Zp(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(t, r, n);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], i = r === t.length - 1;
      uu(n, this.supportsBinary, (o) => {
        try {
          this.doWrite(n, o);
        } catch {
        }
        i && Yr(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", r = this.query || {};
    return this.opts.timestampRequests && (r[this.opts.timestampParam] = ey()), this.supportsBinary || (r.b64 = 1), this.createUri(t, r);
  }
}
const da = Pe.WebSocket || Pe.MozWebSocket;
class jw extends Iw {
  createSocket(t, r, n) {
    return ny ? new da(t, r, n) : r ? new da(t, r) : new da(t);
  }
  doWrite(t, r) {
    this.ws.send(r);
  }
}
class kw extends fu {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (t) {
      return this.emitReserved("error", t);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((t) => {
        const r = yw(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = t.readable.pipeThrough(r).getReader(), i = pw();
        i.readable.pipeTo(t.writable), this._writer = i.writable.getWriter();
        const o = () => {
          n.read().then(({ done: a, value: u }) => {
            a || (this.onPacket(u), o());
          }).catch((a) => {
          });
        };
        o();
        const s = { type: "open" };
        this.query.sid && (s.data = `{"sid":"${this.query.sid}"}`), this._writer.write(s).then(() => this.onOpen());
      });
    });
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], i = r === t.length - 1;
      this._writer.write(n).then(() => {
        i && Yr(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this._transport) === null || t === void 0 || t.close();
  }
}
const Nw = {
  websocket: jw,
  webtransport: kw,
  polling: Fw
}, Lw = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Dw = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function Aa(e) {
  if (e.length > 8e3)
    throw "URI too long";
  const t = e, r = e.indexOf("["), n = e.indexOf("]");
  r != -1 && n != -1 && (e = e.substring(0, r) + e.substring(r, n).replace(/:/g, ";") + e.substring(n, e.length));
  let i = Lw.exec(e || ""), o = {}, s = 14;
  for (; s--; )
    o[Dw[s]] = i[s] || "";
  return r != -1 && n != -1 && (o.source = t, o.host = o.host.substring(1, o.host.length - 1).replace(/;/g, ":"), o.authority = o.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), o.ipv6uri = !0), o.pathNames = Mw(o, o.path), o.queryKey = Bw(o, o.query), o;
}
function Mw(e, t) {
  const r = /\/{2,9}/g, n = t.replace(r, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function Bw(e, t) {
  const r = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, i, o) {
    i && (r[i] = o);
  }), r;
}
const Ca = typeof addEventListener == "function" && typeof removeEventListener == "function", Pr = [];
Ca && addEventListener("offline", () => {
  Pr.forEach((e) => e());
}, !1);
let iy = class mt extends ve {
  constructor(t, r = {}) {
    var n, i;
    if (super(), this.binaryType = mw, this.writeBuffer = [], this._prevBufferLen = 0, this._upgrades = [], this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, t && typeof t == "object" && (r = t, t = null), t) {
      const o = Aa(t);
      r.hostname = o.host, r.secure = o.protocol === "https" || o.protocol === "wss", r.port = o.port, o.query && (r.query = o.query);
    } else r.host && (r.hostname = Aa(r.host).host);
    if (Zr(this, r), this.secure = r.secure != null ? r.secure : typeof location < "u" && location.protocol === "https:", r.hostname && !r.port && (r.port = this.secure ? "443" : "80"), this.hostname = r.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = r.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), r.transportImplementations && r.transports)
      throw new Error("specifying both 'transportImplementations' and 'transports' options is not supported");
    r.transportImplementations || !((n = r.transports) === null || n === void 0) && n.length && typeof r.transports[0] == "function" ? (this.transports = [], this._transportsByName = /* @__PURE__ */ Object.create(null), ((i = r.transportImplementations) !== null && i !== void 0 ? i : r.transports).forEach((o) => {
      const s = o.prototype.name;
      this.transports.push(s), this._transportsByName[s] = o;
    })) : (this.transports = r.transports ? [...r.transports] : ["polling", "websocket", "webtransport"], this._transportsByName = Nw), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, r), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = Aw(this.opts.query)), Ca && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, Pr.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const r = Object.assign({}, this.opts.query);
    r.EIO = Yp, r.transport = t, this.id && (r.sid = this.id);
    const n = Object.assign({}, this.opts, {
      query: r,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new this._transportsByName[t](n);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const t = this.opts.rememberUpgrade && mt.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const r = this.createTransport(t);
    r.open(), this.setTransport(r);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (r) => this._onClose("transport close", r));
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(t) {
    let r = this.createTransport(t), n = !1;
    mt.priorWebsocketSuccess = !1;
    const i = () => {
      n || (r.send([{ type: "ping", data: "probe" }]), r.once("packet", (l) => {
        if (!n)
          if (l.type === "pong" && l.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", r), !r)
              return;
            mt.priorWebsocketSuccess = r.name === "websocket", this.transport.pause(() => {
              n || this.readyState !== "closed" && (c(), this.setTransport(r), r.send([{ type: "upgrade" }]), this.emitReserved("upgrade", r), r = null, this.upgrading = !1, this.flush());
            });
          } else {
            const d = new Error("probe error");
            d.transport = r.name, this.emitReserved("upgradeError", d);
          }
      }));
    };
    function o() {
      n || (n = !0, c(), r.close(), r = null);
    }
    const s = (l) => {
      const d = new Error("probe error: " + l);
      d.transport = r.name, o(), this.emitReserved("upgradeError", d);
    };
    function a() {
      s("transport closed");
    }
    function u() {
      s("socket closed");
    }
    function f(l) {
      r && l.name !== r.name && o();
    }
    const c = () => {
      r.removeListener("open", i), r.removeListener("error", s), r.removeListener("close", a), this.off("close", u), this.off("upgrading", f);
    };
    r.once("open", i), r.once("error", s), r.once("close", a), this.once("close", u), this.once("upgrading", f), this._upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      n || r.open();
    }, 200) : r.open();
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    if (this.readyState = "open", mt.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade)
      for (let t = 0; t < this._upgrades.length; t++)
        this._probe(this._upgrades[t]);
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const r = new Error("server error");
          r.code = t.data, this._onError(r);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this._upgrades = this._filterUpgrades(t.upgrades), this._pingInterval = t.pingInterval, this._pingTimeout = t.pingTimeout, this._maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const t = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + t, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, t), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this._getWritablePackets();
      this.transport.send(t), this._prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let r = 1;
    for (let n = 0; n < this.writeBuffer.length; n++) {
      const i = this.writeBuffer[n].data;
      if (i && (r += ww(i)), n > 0 && r > this._maxPayload)
        return this.writeBuffer.slice(0, n);
      r += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const t = Date.now() > this._pingTimeoutTime;
    return t && (this._pingTimeoutTime = 0, Yr(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), t;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type - packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(t, r, n, i) {
    if (typeof r == "function" && (i = r, r = void 0), typeof n == "function" && (i = n, n = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    n = n || {}, n.compress = n.compress !== !1;
    const o = {
      type: t,
      data: r,
      options: n
    };
    this.emitReserved("packetCreate", o), this.writeBuffer.push(o), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this._onClose("forced close"), this.transport.close();
    }, r = () => {
      this.off("upgrade", r), this.off("upgradeError", r), t();
    }, n = () => {
      this.once("upgrade", r), this.once("upgradeError", r);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? n() : t();
    }) : this.upgrading ? n() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(t) {
    if (mt.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", t), this._onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(t, r) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), Ca && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const n = Pr.indexOf(this._offlineEventListener);
        n !== -1 && Pr.splice(n, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", t, r), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(t) {
    const r = [];
    for (let n = 0; n < t.length; n++)
      ~this.transports.indexOf(t[n]) && r.push(t[n]);
    return r;
  }
};
iy.protocol = Yp;
function $w(e, t = "", r) {
  let n = e;
  r = r || typeof location < "u" && location, e == null && (e = r.protocol + "//" + r.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = r.protocol + e : e = r.host + e), /^(https?|wss?):\/\//.test(e) || (typeof r < "u" ? e = r.protocol + "//" + e : e = "https://" + e), n = Aa(e)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  const o = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + o + ":" + n.port + t, n.href = n.protocol + "://" + o + (r && r.port === n.port ? "" : ":" + n.port), n;
}
const Uw = typeof ArrayBuffer == "function", xw = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, oy = Object.prototype.toString, Hw = typeof Blob == "function" || typeof Blob < "u" && oy.call(Blob) === "[object BlobConstructor]", Kw = typeof File == "function" || typeof File < "u" && oy.call(File) === "[object FileConstructor]";
function lu(e) {
  return Uw && (e instanceof ArrayBuffer || xw(e)) || Hw && e instanceof Blob || Kw && e instanceof File;
}
function Tr(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let r = 0, n = e.length; r < n; r++)
      if (Tr(e[r]))
        return !0;
    return !1;
  }
  if (lu(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return Tr(e.toJSON(), !0);
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && Tr(e[r]))
      return !0;
  return !1;
}
function Ww(e) {
  const t = [], r = e.data, n = e;
  return n.data = Fr(r, t), n.attachments = t.length, { packet: n, buffers: t };
}
function Fr(e, t, r) {
  if (!e)
    return e;
  if (lu(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let i = 0; i < e.length; i++)
      n[i] = Fr(e[i], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    if (e.toJSON && typeof e.toJSON == "function" && !r)
      return Fr(e.toJSON(), t, !0);
    const n = {};
    for (const i in e)
      Object.prototype.hasOwnProperty.call(e, i) && (n[i] = Fr(e[i], t));
    return n;
  }
  return e;
}
function Gw(e, t) {
  return e.data = Ea(e.data, t), delete e.attachments, e;
}
function Ea(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let r = 0; r < e.length; r++)
      e[r] = Ea(e[r], t);
  else if (typeof e == "object")
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (e[r] = Ea(e[r], t));
  return e;
}
const Vw = [
  "connect",
  // used on the client side
  "connect_error",
  // used on the client side
  "disconnect",
  // used on both sides
  "disconnecting",
  // used on the server side
  "newListener",
  // used by the Node.js EventEmitter
  "removeListener"
  // used by the Node.js EventEmitter
];
var oe;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(oe || (oe = {}));
class zw {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === oe.EVENT || t.type === oe.ACK) && Tr(t) ? this.encodeAsBinary({
      type: t.type === oe.EVENT ? oe.BINARY_EVENT : oe.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let r = "" + t.type;
    return (t.type === oe.BINARY_EVENT || t.type === oe.BINARY_ACK) && (r += t.attachments + "-"), t.nsp && t.nsp !== "/" && (r += t.nsp + ","), t.id != null && (r += t.id), t.data != null && (r += JSON.stringify(t.data, this.replacer)), r;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const r = Ww(t), n = this.encodeAsString(r.packet), i = r.buffers;
    return i.unshift(n), i;
  }
}
class du extends ve {
  /**
   * Decoder constructor
   */
  constructor(t) {
    super(), this.opts = Object.assign({
      reviver: void 0,
      maxAttachments: 10
    }, typeof t == "function" ? { reviver: t } : t);
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let r;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      r = this.decodeString(t);
      const n = r.type === oe.BINARY_EVENT;
      n || r.type === oe.BINARY_ACK ? (r.type = n ? oe.EVENT : oe.ACK, this.reconstructor = new Jw(r)) : super.emitReserved("decoded", r);
    } else if (lu(t) || t.base64)
      if (this.reconstructor)
        r = this.reconstructor.takeBinaryData(t), r && (this.reconstructor = null, super.emitReserved("decoded", r));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let r = 0;
    const n = {
      type: Number(t.charAt(0))
    };
    if (oe[n.type] === void 0)
      throw new Error("unknown packet type " + n.type);
    if (n.type === oe.BINARY_EVENT || n.type === oe.BINARY_ACK) {
      const o = r + 1;
      for (; t.charAt(++r) !== "-" && r != t.length; )
        ;
      const s = t.substring(o, r);
      if (s != Number(s) || t.charAt(r) !== "-")
        throw new Error("Illegal attachments");
      const a = Number(s);
      if (!Qw(a) || a < 1)
        throw new Error("Illegal attachments");
      if (a > this.opts.maxAttachments)
        throw new Error("too many attachments");
      n.attachments = a;
    }
    if (t.charAt(r + 1) === "/") {
      const o = r + 1;
      for (; ++r && !(t.charAt(r) === "," || r === t.length); )
        ;
      n.nsp = t.substring(o, r);
    } else
      n.nsp = "/";
    const i = t.charAt(r + 1);
    if (i !== "" && Number(i) == i) {
      const o = r + 1;
      for (; ++r; ) {
        const s = t.charAt(r);
        if (s == null || Number(s) != s) {
          --r;
          break;
        }
        if (r === t.length)
          break;
      }
      n.id = Number(t.substring(o, r + 1));
    }
    if (t.charAt(++r)) {
      const o = this.tryParse(t.substr(r));
      if (du.isPayloadValid(n.type, o))
        n.data = o;
      else
        throw new Error("invalid payload");
    }
    return n;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.opts.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, r) {
    switch (t) {
      case oe.CONNECT:
        return Sh(r);
      case oe.DISCONNECT:
        return r === void 0;
      case oe.CONNECT_ERROR:
        return typeof r == "string" || Sh(r);
      case oe.EVENT:
      case oe.BINARY_EVENT:
        return Array.isArray(r) && (typeof r[0] == "number" || typeof r[0] == "string" && Vw.indexOf(r[0]) === -1);
      case oe.ACK:
      case oe.BINARY_ACK:
        return Array.isArray(r);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class Jw {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const r = Gw(this.reconPack, this.buffers);
      return this.finishedReconstruction(), r;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const Qw = Number.isInteger || function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
};
function Sh(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
const Xw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: du,
  Encoder: zw,
  get PacketType() {
    return oe;
  }
}, Symbol.toStringTag, { value: "Module" }));
function ke(e, t, r) {
  return e.on(t, r), function() {
    e.off(t, r);
  };
}
const Yw = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class sy extends ve {
  /**
   * `Socket` constructor.
   */
  constructor(t, r, n) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = r, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      ke(t, "open", this.onopen.bind(this)),
      ke(t, "packet", this.onpacket.bind(this)),
      ke(t, "error", this.onerror.bind(this)),
      ke(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...r) {
    var n, i, o;
    if (Yw.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (r.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(r), this;
    const s = {
      type: oe.EVENT,
      data: r
    };
    if (s.options = {}, s.options.compress = this.flags.compress !== !1, typeof r[r.length - 1] == "function") {
      const c = this.ids++, l = r.pop();
      this._registerAckCallback(c, l), s.id = c;
    }
    const a = (i = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || i === void 0 ? void 0 : i.writable, u = this.connected && !(!((o = this.io.engine) === null || o === void 0) && o._hasPingExpired());
    return this.flags.volatile && !a || (u ? (this.notifyOutgoingListeners(s), this.packet(s)) : this.sendBuffer.push(s)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, r) {
    var n;
    const i = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[t] = r;
      return;
    }
    const o = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === t && this.sendBuffer.splice(a, 1);
      r.call(this, new Error("operation has timed out"));
    }, i), s = (...a) => {
      this.io.clearTimeoutFn(o), r.apply(this, a);
    };
    s.withError = !0, this.acks[t] = s;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...r) {
    return new Promise((n, i) => {
      const o = (s, a) => s ? i(s) : n(a);
      o.withError = !0, r.push(o), this.emit(t, ...r);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let r;
    typeof t[t.length - 1] == "function" && (r = t.pop());
    const n = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((i, ...o) => (this._queue[0], i !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), r && r(i)) : (this._queue.shift(), r && r(null, ...o)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const r = this._queue[0];
    r.pending && !t || (r.pending = !0, r.tryCount++, this.flags = r.flags, this.emit.apply(this, r.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: oe.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, r) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, r), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((t) => {
      if (!this.sendBuffer.some((n) => String(n.id) === t)) {
        const n = this.acks[t];
        delete this.acks[t], n.withError && n.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case oe.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case oe.EVENT:
        case oe.BINARY_EVENT:
          this.onevent(t);
          break;
        case oe.ACK:
        case oe.BINARY_ACK:
          this.onack(t);
          break;
        case oe.DISCONNECT:
          this.ondisconnect();
          break;
        case oe.CONNECT_ERROR:
          this.destroy();
          const n = new Error(t.data.message);
          n.data = t.data.data, this.emitReserved("connect_error", n);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const r = t.data || [];
    t.id != null && r.push(this.ack(t.id)), this.connected ? this.emitEvent(r) : this.receiveBuffer.push(Object.freeze(r));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const r = this._anyListeners.slice();
      for (const n of r)
        n.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const r = this;
    let n = !1;
    return function(...i) {
      n || (n = !0, r.packet({
        type: oe.ACK,
        id: t,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const r = this.acks[t.id];
    typeof r == "function" && (delete this.acks[t.id], r.withError && t.data.unshift(null), r.apply(this, t.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, r) {
    this.id = t, this.recovered = r && this._pid === r, this._pid = r, this.connected = !0, this.emitBuffered(), this._drainQueue(!0), this.emitReserved("connect");
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: oe.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const r = this._anyListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const r = this._anyOutgoingListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const r = this._anyOutgoingListeners.slice();
      for (const n of r)
        n.apply(this, t.data);
    }
  }
}
function Rt(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Rt.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), r = Math.floor(t * this.jitter * e);
    e = (Math.floor(t * 10) & 1) == 0 ? e - r : e + r;
  }
  return Math.min(e, this.max) | 0;
};
Rt.prototype.reset = function() {
  this.attempts = 0;
};
Rt.prototype.setMin = function(e) {
  this.ms = e;
};
Rt.prototype.setMax = function(e) {
  this.max = e;
};
Rt.prototype.setJitter = function(e) {
  this.jitter = e;
};
class Ra extends ve {
  constructor(t, r) {
    var n;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (r = t, t = void 0), r = r || {}, r.path = r.path || "/socket.io", this.opts = r, Zr(this, r), this.reconnection(r.reconnection !== !1), this.reconnectionAttempts(r.reconnectionAttempts || 1 / 0), this.reconnectionDelay(r.reconnectionDelay || 1e3), this.reconnectionDelayMax(r.reconnectionDelayMax || 5e3), this.randomizationFactor((n = r.randomizationFactor) !== null && n !== void 0 ? n : 0.5), this.backoff = new Rt({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(r.timeout == null ? 2e4 : r.timeout), this._readyState = "closed", this.uri = t;
    const i = r.parser || Xw;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = r.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, t || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var r;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (r = this.backoff) === null || r === void 0 || r.setMin(t), this);
  }
  randomizationFactor(t) {
    var r;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (r = this.backoff) === null || r === void 0 || r.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var r;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (r = this.backoff) === null || r === void 0 || r.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new iy(this.uri, this.opts);
    const r = this.engine, n = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = ke(r, "open", function() {
      n.onopen(), t && t();
    }), o = (a) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), t ? t(a) : this.maybeReconnectOnOpen();
    }, s = ke(r, "error", o);
    if (this._timeout !== !1) {
      const a = this._timeout, u = this.setTimeoutFn(() => {
        i(), o(new Error("timeout")), r.close();
      }, a);
      this.opts.autoUnref && u.unref(), this.subs.push(() => {
        this.clearTimeoutFn(u);
      });
    }
    return this.subs.push(i), this.subs.push(s), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(
      ke(t, "ping", this.onping.bind(this)),
      ke(t, "data", this.ondata.bind(this)),
      ke(t, "error", this.onerror.bind(this)),
      ke(t, "close", this.onclose.bind(this)),
      // @ts-ignore
      ke(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (r) {
      this.onclose("parse error", r);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    Yr(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, r) {
    let n = this.nsps[t];
    return n ? this._autoConnect && !n.active && n.connect() : (n = new sy(this, t, r), this.nsps[t] = n), n;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const r = Object.keys(this.nsps);
    for (const n of r)
      if (this.nsps[n].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const r = this.encoder.encode(t);
    for (let n = 0; n < r.length; n++)
      this.engine.write(r[n], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(t, r) {
    var n;
    this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, r), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const r = this.backoff.duration();
      this._reconnecting = !0;
      const n = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((i) => {
          i ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", i)) : t.onreconnect();
        }));
      }, r);
      this.opts.autoUnref && n.unref(), this.subs.push(() => {
        this.clearTimeoutFn(n);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Ut = {};
function Jt(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const r = $w(e, t.path || "/socket.io"), n = r.source, i = r.id, o = r.path, s = Ut[i] && o in Ut[i].nsps, a = t.forceNew || t["force new connection"] || t.multiplex === !1 || s;
  let u;
  return a ? u = new Ra(n, t) : (Ut[i] || (Ut[i] = new Ra(n, t)), u = Ut[i]), r.query && !t.query && (t.query = r.queryKey), u.socket(r.path, t);
}
Object.assign(Jt, {
  Manager: Ra,
  Socket: sy,
  io: Jt,
  connect: Jt
});
var Sr = { exports: {} }, xt = {}, Oh;
function Zw() {
  if (Oh) return xt;
  Oh = 1, Object.defineProperty(xt, "__esModule", { value: !0 }), xt.Service = void 0;
  const e = Xt(), r = (0, Et().createDebug)("@feathersjs/transport-commons/client"), n = [
    "addListener",
    "addEventListener",
    "emit",
    "listenerCount",
    "listeners",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "removeAllListeners",
    "removeEventListener",
    "removeListener"
  ], i = ["eventNames", "getMaxListeners", "setMaxListeners"], o = (a) => {
    i.forEach((u) => {
      a[u] = function(...f) {
        if (typeof this.connection[u] != "function")
          throw new Error(`Can not call '${u}' on the client service connection`);
        return this.connection[u](...f);
      };
    }), n.forEach((u) => {
      a[u] = function(f, ...c) {
        if (typeof this.connection[u] != "function")
          throw new Error(`Can not call '${u}' on the client service connection`);
        const l = `${this.path} ${f}`;
        r(`Calling emitter method ${u} with namespaced event '${l}'`);
        const d = this.connection[u](l, ...c);
        return d === this.connection ? this : d;
      };
    });
  };
  class s {
    constructor(u) {
      this.events = u.events, this.path = u.name, this.connection = u.connection, this.method = u.method, o(this);
    }
    send(u, ...f) {
      return new Promise((c, l) => {
        var d, h;
        const y = f.pop();
        let O = this.path;
        y && Object.keys(y).forEach((C) => {
          O = O.replace(`:${C}`, y[C]);
        }), f.unshift(u, O), (((d = this.connection.flags) === null || d === void 0 ? void 0 : d.timeout) || ((h = this.connection._opts) === null || h === void 0 ? void 0 : h.ackTimeout)) !== void 0 ? f.push(function(C, w, E) {
          return C || w ? l((0, e.convert)(C || w)) : c(E);
        }) : f.push(function(C, w) {
          return C ? l((0, e.convert)(C)) : c(w);
        }), r(`Sending socket.${this.method}`, f), this.connection[this.method](...f);
      });
    }
    methods(...u) {
      return u.forEach((f) => {
        const c = `_${f}`;
        this[c] = function(l, d = {}) {
          return this.send(f, l, d.query || {}, d.route || {});
        }, this[f] = function(l, d = {}) {
          return this[c](l, d, d.route || {});
        };
      }), this;
    }
    _find(u = {}) {
      return this.send("find", u.query || {}, u.route || {});
    }
    find(u = {}) {
      return this._find(u);
    }
    _get(u, f = {}) {
      return u === void 0 || u === "" ? Promise.reject(new e.BadRequest("id for .get is required")) : this.send("get", u, f.query || {}, f.route || {});
    }
    get(u, f = {}) {
      return this._get(u, f);
    }
    _create(u, f = {}) {
      return this.send("create", u, f.query || {}, f.route || {});
    }
    create(u, f = {}) {
      return this._create(u, f);
    }
    _update(u, f, c = {}) {
      return u === void 0 || u === "" ? Promise.reject(new e.BadRequest("id for .update is required")) : this.send("update", u, f, c.query || {}, c.route || {});
    }
    update(u, f, c = {}) {
      return u === void 0 || u === "" ? Promise.reject(new e.BadRequest("id for .update is required")) : this._update(u, f, c);
    }
    _patch(u, f, c = {}) {
      return u === void 0 || u === "" ? Promise.reject(new e.BadRequest("id for .patch is required")) : this.send("patch", u, f, c.query || {}, c.route || {});
    }
    patch(u, f, c = {}) {
      return this._patch(u, f, c);
    }
    _remove(u, f = {}) {
      return u === void 0 || u === "" ? Promise.reject(new e.BadRequest("id for .remove is required")) : this.send("remove", u, f.query || {}, f.route || {});
    }
    remove(u, f = {}) {
      return this._remove(u, f);
    }
    // `off` is actually not part of the Node event emitter spec
    // but we are adding it since everybody is expecting it because
    // of the emitter-component Socket.io is using
    off(u, ...f) {
      if (typeof this.connection.off == "function") {
        const c = this.connection.off(`${this.path} ${u}`, ...f);
        return c === this.connection ? this : c;
      } else if (f.length === 0)
        return this.removeAllListeners(u);
      return this.removeListener(u, ...f);
    }
  }
  return xt.Service = s, xt;
}
var ha, Ah;
function e0() {
  return Ah || (Ah = 1, ha = Zw()), ha;
}
var Ch;
function t0() {
  return Ch || (Ch = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = i;
    const r = e0(), n = au();
    function i(o, s) {
      if (!o)
        throw new Error("Socket.io connection needs to be provided");
      const a = function(f) {
        const c = Object.values(n.defaultEventMap), l = Object.assign({}, s, {
          events: c,
          name: f,
          connection: o,
          method: "emit"
        });
        return new r.Service(l);
      }, u = function(f) {
        if (f.io !== void 0)
          throw new Error("Only one default client provider can be configured");
        f.io = o, f.defaultService = a, f.mixins.unshift((c, l, d) => {
          if (d && d.methods && c instanceof r.Service) {
            const h = d.methods.filter((y) => !n.defaultServiceMethods.includes(y));
            c.methods(...h);
          }
        });
      };
      return u.Service = r.Service, u.service = a, u;
    }
    e.exports = Object.assign(i, e.exports);
  })(Sr, Sr.exports)), Sr.exports;
}
var r0 = t0();
const ay = /* @__PURE__ */ at(r0), eS = ({ url: e }) => {
  const t = Jt(e, {
    transports: ["websocket"],
    forceNew: !0
  }), r = Jr.feathers();
  return r.configure(ay(t)), r.configure(
    Qr({
      storage: bt
    })
  ), r;
}, tS = ({ url: e }) => {
  const t = Jt(e), r = Jr.feathers();
  return r.configure(ay(t)), r.configure(
    Qr({
      storage: window.localStorage
    })
  ), r;
};
export {
  P0 as AddCustomerToUserHook,
  d0 as AuthFilterHook,
  s0 as CacheHook,
  S0 as ConvertDateRange,
  l0 as CustomerFilterHook,
  a0 as DebugHook,
  u0 as DisableMultiChangeHook,
  i0 as LogRunTimeHook,
  f0 as PopulateAdminUserRolesHook,
  Y0 as ReactNativeRestClient,
  eS as ReactNativeSocketClient,
  o0 as SetTimestampHook,
  h0 as TransformC360IdNeQuery,
  w0 as TransformCaseInsensitiveFilters,
  _0 as TransformQSearchquery,
  Z0 as WebRestClient,
  tS as WebSocketClient,
  q0 as addCountries,
  y0 as addGuardianCustomerQuery,
  p0 as addSourceIds,
  g0 as addUserLobs,
  R0 as buildLogCtx,
  c0 as checkPermissionsHook,
  m0 as createClientUsersJoinQuery,
  C0 as getAllAccountTags,
  E0 as getAllLobs,
  v0 as getUserAccountTags,
  b0 as getUserCompanies,
  A0 as getUserRolesHook,
  O0 as getUserTerritories,
  Jh as getcustomerFilterData,
  T0 as registerAllServicesWithResource,
  n0 as sum
};
